(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/react/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./icons/add-lg.svg":
/*!**************************!*\
  !*** ./icons/add-lg.svg ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0z\"/><path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z\"/></svg>"

/***/ }),

/***/ "./icons/add-with-circle.svg":
/*!***********************************!*\
  !*** ./icons/add-with-circle.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon cu-icon-fill-stroke\" viewBox=\"0 0 16 16\"><circle stroke=\"currentColor\" fill=\"none\" stroke-width=\"2\" cx=\"8\" cy=\"8\" r=\"7\"/><path d=\"M8.25 4.75h-.5v3h-3v.5h3v3h.5v-3h3v-.5h-3v-3z\"/></svg>"

/***/ }),

/***/ "./icons/add.svg":
/*!***********************!*\
  !*** ./icons/add.svg ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 13 13\"><g fill-rule=\"evenodd\"><circle cx=\"6.5\" cy=\"6.5\" r=\"6.5\"/><path d=\"M6.5 4.063v4.875M4.063 6.5h4.875\" stroke=\"#FFF\" stroke-width=\"2\" stroke-linecap=\"square\"/></g></svg>"

/***/ }),

/***/ "./icons/alarm.svg":
/*!*************************!*\
  !*** ./icons/alarm.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><path d=\"M7 10h2v2H7v-2zm0-6h2v5H7V4z\"/><path d=\"M12.243 12.243a6 6 0 1 0-8.486-8.486 6 6 0 0 0 8.486 8.486zm-9.9 1.414A8 8 0 1 1 13.657 2.343 8 8 0 0 1 2.343 13.657z\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/app-switcher.svg":
/*!********************************!*\
  !*** ./icons/app-switcher.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M0 0h4v4H0zm6 0h4v4H6zm6 0h4v4h-4zM0 6h4v4H0zm6 0h4v4H6zm6 0h4v4h-4zM0 12h4v4H0zm6 0h4v4H6zm6 0h4v4h-4z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/at.svg":
/*!**********************!*\
  !*** ./icons/at.svg ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8,0 C3.57874194,0 0,3.57803226 0,8 C0,12.4212581 3.57803226,16 8,16 C9.55335484,16 11.0755484,15.543871 12.368,14.7024839 C12.7552581,14.4503871 12.8397742,13.919 12.5470968,13.5614516 L12.2188065,13.1603871 C11.9713548,12.8580968 11.5356129,12.7840323 11.2067742,12.9949355 C10.2554839,13.6050645 9.13916129,13.9354839 8,13.9354839 C4.72716129,13.9354839 2.06451613,11.2728387 2.06451613,8 C2.06451613,4.72716129 4.72716129,2.06451613 8,2.06451613 C11.2302903,2.06451613 13.9354839,3.92319355 13.9354839,7.22580645 C13.9354839,8.47696774 13.2550645,9.79812903 12.0590323,9.92558065 C11.4993871,9.91093548 11.5135484,9.51083871 11.6243226,8.95706452 L12.3802258,5.05029032 C12.4726774,4.57258065 12.1067097,4.12903226 11.6201613,4.12903226 L10.1691613,4.12903226 C9.94736037,4.12902742 9.76089289,4.29551821 9.73587097,4.51590323 L9.73554839,4.51887097 C9.26145161,3.94141935 8.43077419,3.81645161 7.801,3.81645161 C5.39519355,3.81645161 3.35483871,5.824 3.35483871,8.70225806 C3.35483871,10.8088065 4.54145161,12.1174194 6.4516129,12.1174194 C7.32206452,12.1174194 8.30222581,11.613 8.87067742,10.880871 C9.17783871,11.981 10.1807742,11.9809677 11.1516452,11.9809677 C14.6648065,11.9809677 16,9.67090323 16,7.22580645 C16,2.82751613 12.4523548,0 8,0 Z M7.30064516,9.82032258 C6.58293548,9.82032258 6.13709677,9.31635484 6.13709677,8.50512903 C6.13709677,7.05374194 7.12996774,6.15903226 8.0283871,6.15903226 C8.74748387,6.15903226 9.17680645,6.65067742 9.17680645,7.47419355 C9.17680645,8.92777419 8.08406452,9.82032258 7.30064516,9.82032258 Z\"/></svg>"

/***/ }),

/***/ "./icons/bar-graph.svg":
/*!*****************************!*\
  !*** ./icons/bar-graph.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"1 1 13 13\"><path d=\"M2 5h2v8H2V5zm6 1h2v7H8V6zm3 3h2v4h-2V9zM5 2h2v11H5V2z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/beautify.svg":
/*!****************************!*\
  !*** ./icons/beautify.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M3.178 15.767L.25 12.837a.744.744 0 010-1.055L11.767.265a.744.744 0 011.055 0l2.929 2.929a.744.744 0 010 1.055L4.233 15.767a.75.75 0 01-1.055 0zM9.494 5.002l1.52 1.52 2.798-2.799-1.52-1.52-2.798 2.8zM4.354 1.27l-.363.74-.816.12a.18.18 0 00-.1.304l.592.576-.14.813a.179.179 0 00.258.19l.729-.387.728.383a.179.179 0 00.258-.19l-.14-.812.592-.576a.18.18 0 00-.1-.305l-.815-.118-.365-.741c-.062-.128-.252-.128-.317.003zM7.397.626l-.243.492-.544.08a.12.12 0 00-.066.203l.392.383-.093.541a.12.12 0 00.174.125l.486-.255.486.255a.12.12 0 00.174-.125l-.094-.541.393-.383a.118.118 0 00-.066-.203l-.544-.077-.243-.492a.116.116 0 00-.212-.003zm-5.977 0l-.242.492-.545.08a.119.119 0 00-.065.203l.392.383-.094.541a.12.12 0 00.175.125l.485-.255.486.255a.12.12 0 00.174-.125l-.093-.541.392-.383a.118.118 0 00-.065-.203l-.545-.077L1.63.629a.116.116 0 00-.21-.003zm12.95 6.957l-.243.492-.545.078a.118.118 0 00-.065.202l.392.383-.093.541a.12.12 0 00.174.125l.486-.255.485.255a.12.12 0 00.175-.125l-.094-.541.392-.383a.118.118 0 00-.065-.202l-.545-.078-.242-.492a.118.118 0 00-.212 0z\"/></svg>"

/***/ }),

/***/ "./icons/bell.svg":
/*!************************!*\
  !*** ./icons/bell.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M14.294 10.342c-.531-.525-1.08-1.067-1.08-3.628a5.222 5.222 0 0 0-4.39-5.149 1 1 0 1 0-1.65 0 5.222 5.222 0 0 0-4.388 5.15c0 2.56-.549 3.102-1.08 3.627C.203 11.826 1.304 14 3.091 14H6a2 2 0 0 0 4 0h2.909c1.787 0 2.888-2.174 1.385-3.658zM8 14.75a.75.75 0 0 1-.75-.75h1.5a.75.75 0 0 1-.75.75zm4.91-2.25H3.09a.59.59 0 0 1-.416-1.006c.893-.893 1.612-1.741 1.612-4.78A3.718 3.718 0 0 1 8 3a3.718 3.718 0 0 1 3.714 3.714c0 3.052.726 3.893 1.612 4.78a.59.59 0 0 1-.417 1.006z\"/></svg>"

/***/ }),

/***/ "./icons/bullhorn.svg":
/*!****************************!*\
  !*** ./icons/bullhorn.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" width=\"16\" height=\"16\" viewBox=\"0 0 24 22\"><path d=\"M20,0.33333333 C21.47275,0.33333333 22.6666667,1.52725 22.6666667,3 L22.6666667,3 L22.6666667,7.78091667 C23.4433333,8.05558333 24,8.796 24,9.6666667 C24,10.5373333 23.4433333,11.27775 22.6666667,11.5524167 L22.6666667,11.5524167 L22.6666667,16.3333333 C22.6666667,17.8060833 21.47275,19 20,19 C17.4412917,16.7950417 14.4334583,13.9952917 9.54045833,13.6937917 C8.20304167,14.1373333 7.67270833,15.6968333 8.35225,16.725125 C8.44819686,16.8694138 8.46458396,17.0524633 8.39579167,17.2115 C7.96491667,18.2093333 8.44941667,18.9961667 9.22058333,19.74725 C9.73883333,20.252 9.57575,21.11825 8.90716667,21.394625 C7.84808333,21.832375 5.86579167,21.728125 4.99995833,21.18 C4.80333333,21.0555417 4.65745833,20.865 4.58654167,20.6433333 C3.90591667,18.5157917 3.02170833,16.3604167 3.802625,13.6666667 L3.802625,13.6666667 L2,13.6666667 C0.895416667,13.6666667 0,12.77125 0,11.6666667 L0,11.6666667 L0,7.66666667 C0,6.56208333 0.895416667,5.66666667 2,5.66666667 L2,5.66666667 L8.66666667,5.66666667 C14.0820417,5.66666667 17.2922917,2.66666667 20,0.33333333 Z M20,3.83933333 C17.724625,5.7135 14.7902917,7.71183333 10.6666667,8.21358333 L10.6666667,8.21358333 L10.6666667,11.1197083 C14.7902917,11.6214583 17.724625,13.6198333 20,15.4939583 L20,15.4939583 L20,3.83933333 Z\"/></svg>"

/***/ }),

/***/ "./icons/calendar.svg":
/*!****************************!*\
  !*** ./icons/calendar.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 14 15\"><path d=\"M2 13h9.994C12 13 12 8 12 8H2v5zM4.001 0S6 .003 6 .009V2h2L8.001.015V0S10 .003 10 .009V2h1.994C13.103 2 14 2.898 14 4.006v8.996A2.001 2.001 0 0111.994 15H2.006A1.997 1.997 0 010 13.002V4.006C0 2.886.898 2 2.006 2H4l.001-2.001zm6 4.004L10 5H8v-.998H5.995L6 5H4V4H2.006C1.996 4 2 7 2 7h10V4.005l-.189-.001-1.81-.002z\"/></svg>"

/***/ }),

/***/ "./icons/checkmark.svg":
/*!*****************************!*\
  !*** ./icons/checkmark.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M6.094 10.18L3.268 7.354 1.854 8.768l4.242 4.242 1.414-1.414-.001-.002 5.826-5.826-1.414-1.414-5.827 5.826z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/chevron-down.svg":
/*!********************************!*\
  !*** ./icons/chevron-down.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-3 -5 16 16\"><path d=\"M1.357.65a.5.5 0 1 0-.714.7l3.915 4a.5.5 0 0 0 .707.007l4.085-4a.5.5 0 0 0-.7-.714l-3.727 3.65L1.357.65z\"/></svg>"

/***/ }),

/***/ "./icons/chevron-left.svg":
/*!********************************!*\
  !*** ./icons/chevron-left.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-5 -3 16 16\"><path d=\"M5.35 1.357a.5.5 0 1 0-.7-.714l-4 3.915a.5.5 0 0 0-.007.707l4 4.085a.5.5 0 0 0 .714-.7l-3.65-3.727L5.35 1.357z\"/></svg>"

/***/ }),

/***/ "./icons/chevron-right.svg":
/*!*********************************!*\
  !*** ./icons/chevron-right.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-5 -3 16 16\"><path d=\"M.65 8.643a.5.5 0 1 0 .7.714l4-3.915a.5.5 0 0 0 .007-.707l-4-4.085a.5.5 0 1 0-.714.7l3.65 3.727L.65 8.643z\"/></svg>"

/***/ }),

/***/ "./icons/chevron-up.svg":
/*!******************************!*\
  !*** ./icons/chevron-up.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-3 -5 16 16\"><path d=\"M5 1.707l3.646 3.647a.5.5 0 1 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 .708.708L5 1.707z\"/></svg>"

/***/ }),

/***/ "./icons/circle-checkmark-filled.svg":
/*!*******************************************!*\
  !*** ./icons/circle-checkmark-filled.svg ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M2.343 13.657A8 8 0 1 1 13.657 2.343 8 8 0 0 1 2.343 13.657zm4.715-5.064L5.004 6.54 3.59 7.953l3.468 3.469 5.215-5.215-1.414-1.414-3.8 3.8z\"/></svg>"

/***/ }),

/***/ "./icons/circle-checkmark.svg":
/*!************************************!*\
  !*** ./icons/circle-checkmark.svg ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M7.058 8.593L5.004 6.539 3.59 7.953l3.468 3.469 5.215-5.215-1.414-1.414z\"/><path d=\"M12.243 12.243a6 6 0 1 0-8.486-8.486 6 6 0 0 0 8.486 8.486zm-9.9 1.414A8 8 0 1 1 13.657 2.343 8 8 0 0 1 2.343 13.657z\"/></svg>"

/***/ }),

/***/ "./icons/close-lg.svg":
/*!****************************!*\
  !*** ./icons/close-lg.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.985 10.571L4.915 3.5 3.5 4.914l7.071 7.071L3.5 19.056l1.414 1.415 7.071-7.072 7.071 7.072 1.415-1.415-7.072-7.07 7.072-7.072L19.056 3.5l-7.07 7.071z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/close.svg":
/*!*************************!*\
  !*** ./icons/close.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8.01 7.303L2.707 2 2 2.707 7.303 8.01 2 13.314l.707.707L8.01 8.718l5.304 5.303.707-.707L8.718 8.01l5.303-5.303L13.314 2 8.01 7.303z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/collapse.svg":
/*!****************************!*\
  !*** ./icons/collapse.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M2 7h12v2H2V7\"/></svg>"

/***/ }),

/***/ "./icons/comments.svg":
/*!****************************!*\
  !*** ./icons/comments.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"1 1 14 14\"><path d=\"M8.492 11.959c1.86-.768 3.168-1.66 3.92-2.675.442-.59.686-1.221.733-1.896a2.809 2.809 0 0 0-.256-1.448 4.078 4.078 0 0 0-.99-1.32 6.267 6.267 0 0 0-3.675-1.431h-.442a6.29 6.29 0 0 0-1.855.273 5.518 5.518 0 0 0-1.553.739c-.442.31-.8.69-1.075 1.14-.276.45-.425.926-.448 1.43-.086.954.186 1.788.814 2.5.357.404.79.715 1.303.932a4.182 4.182 0 0 0 1.65.325c.536.062.909.136 1.118.22.209.087.372.19.488.315.179.264.268.563.268.896m4.304-8.235A5.614 5.614 0 0 1 14.11 5.52c.295.655.423 1.3.384 1.937a4.65 4.65 0 0 1-.425 1.727 5.754 5.754 0 0 1-.866 1.343c-.334.38-.735.745-1.204 1.094a12.52 12.52 0 0 1-2.518 1.454c-.551.24-.941.397-1.17.47-.228.074-.346.11-.354.11h-.175a.444.444 0 0 1-.255-.07.222.222 0 0 1-.105-.196.407.407 0 0 1-.198-.221.81.81 0 0 1-.07-.314v-.896c-.007 0-.08-.016-.215-.047a1.848 1.848 0 0 0-.413-.046 5.3 5.3 0 0 1-2.157-.448 4.58 4.58 0 0 1-1.693-1.25 4.687 4.687 0 0 1-1.163-3.46c.047-.663.26-1.304.64-1.925.38-.62.874-1.143 1.483-1.57.609-.426 1.322-.748 2.14-.965a7.51 7.51 0 0 1 2.542-.221 7.702 7.702 0 0 1 2.43.506 7.126 7.126 0 0 1 2.048 1.192\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/copy.svg":
/*!************************!*\
  !*** ./icons/copy.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M10 14v1.25a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75V3.75A.75.75 0 01.75 3H3v9.25c0 .965.785 1.75 1.75 1.75H10zm0-10.75V0H4.75A.75.75 0 004 .75v11.5c0 .414.336.75.75.75h8.5a.75.75 0 00.75-.75V4h-3.25a.752.752 0 01-.75-.75zm3.78-.97L11.72.22a.75.75 0 00-.53-.22H11v3h3v-.19a.75.75 0 00-.22-.53z\"/></svg>"

/***/ }),

/***/ "./icons/cross-post.svg":
/*!******************************!*\
  !*** ./icons/cross-post.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\"><path d=\"M15.75 10.213a.749.749 0 010 1.059l-2.496 2.495c-.468.468-1.277.14-1.277-.53V11.99h-1.834a.374.374 0 01-.273-.119L7.669 9.514 9.332 7.73l1.647 1.764h.998V8.248c0-.668.809-.998 1.277-.53l2.496 2.495zM.374 4.505h2.62L4.64 6.269l1.664-1.783-2.2-2.357a.374.374 0 00-.274-.12H.374A.374.374 0 000 2.385v1.747c0 .206.168.374.374.374zm11.603 0v1.247c0 .67.81.997 1.277.53l2.496-2.495a.749.749 0 000-1.059L13.254.234a.748.748 0 00-1.277.529V2.01h-1.834a.374.374 0 00-.273.119L2.994 9.495H.374A.374.374 0 000 9.87v1.747c0 .207.168.374.374.374H3.83a.374.374 0 00.273-.119l6.876-7.366h.998z\"/></svg>"

/***/ }),

/***/ "./icons/delete.svg":
/*!**************************!*\
  !*** ./icons/delete.svg ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3.3 4h10.4v9.333A2.667 2.667 0 0 1 11.033 16H5.967A2.667 2.667 0 0 1 3.3 13.333V4zm2.6-2.667V0h5.2v1.333H15v1.334H2V1.333h3.9z\"/></svg>"

/***/ }),

/***/ "./icons/desktop.svg":
/*!***************************!*\
  !*** ./icons/desktop.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 576 512\"><path d=\"M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z\"/></svg>"

/***/ }),

/***/ "./icons/distribute-circle.svg":
/*!*************************************!*\
  !*** ./icons/distribute-circle.svg ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 16\" class=\"cu-icon\"><path d=\"M3.913 13.002c0 .053-.032.079-.095.079 1.263.978 2.656 1.467 4.182 1.467a6.38 6.38 0 003.258-.875 6.596 6.596 0 002.4-2.383 6.348 6.348 0 00.89-3.29 6.262 6.262 0 00-.915-3.298 6.629 6.629 0 00-2.446-2.382 6.54 6.54 0 00-3.282-.868 6.41 6.41 0 00-3.258.868 6.51 6.51 0 00-2.399 2.382A6.39 6.39 0 001.358 8c0 1.462.488 2.824 1.466 4.087L8.82 6.091H6.36c-.422 0-.632-.211-.632-.631 0-.305.105-.521.315-.647a.636.636 0 01.316-.079h4.181l.268.079c.17.084.29.205.363.363.064.063.095.157.095.284v4.086c0 .221-.063.397-.189.529-.127.131-.3.197-.52.197a.693.693 0 01-.537-.221.72.72 0 01-.206-.505V7.085l-5.9 5.917zM4.876.631A7.85 7.85 0 017.984 0a7.8 7.8 0 013.101.631 8.203 8.203 0 012.556 1.696 7.968 7.968 0 011.72 2.549c.426.989.64 2.03.64 3.124a7.813 7.813 0 01-.64 3.124c-.426.989-1 1.839-1.72 2.549a8.203 8.203 0 01-2.556 1.696A7.762 7.762 0 018 16c-2.083 0-3.96-.789-5.633-2.367a8.061 8.061 0 01-1.76-2.603A7.854 7.854 0 010 7.968c0-1.073.21-2.103.631-3.092a7.99 7.99 0 011.696-2.549A7.979 7.979 0 014.877.631z\"/></svg>"

/***/ }),

/***/ "./icons/distribute.svg":
/*!******************************!*\
  !*** ./icons/distribute.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M10.392 5H3.8V3h10v10h-2V6.42l-7.386 7.387L3 12.392 10.392 5z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/double-chevron-right.svg":
/*!****************************************!*\
  !*** ./icons/double-chevron-right.svg ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8.012 8.68l-5.44 5.44a.956.956 0 01-1.356 0l-.904-.904a.956.956 0 010-1.356l3.856-3.856L.312 4.148a.956.956 0 010-1.356l.9-.912a.956.956 0 011.356 0l5.44 5.44c.38.376.38.984.004 1.36zm7.68-1.36l-5.44-5.44a.956.956 0 00-1.356 0l-.904.904a.956.956 0 000 1.356l3.856 3.856-3.856 3.856a.956.956 0 000 1.356l.904.904a.956.956 0 001.356 0l5.44-5.44a.951.951 0 000-1.352z\"/></svg>"

/***/ }),

/***/ "./icons/download.svg":
/*!****************************!*\
  !*** ./icons/download.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M9 8.692l1.864-1.864 1.414 1.415-4.242 4.242-4.243-4.242 1.414-1.415L7 8.621V2h2v6.692zM0 9h2s.006 5 .002 5c0 0 11.998.002 11.998-.01V9h2v4.99A2 2 0 0 1 13.998 16H2.002A2.01 2.01 0 0 1 0 13.99V9z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/edit.svg":
/*!************************!*\
  !*** ./icons/edit.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M0 12.548L9.668 2.88l3.453 3.452L3.453 16H0v-3.452zM11.05 1.5L12.143.404a1.383 1.383 0 0 1 1.954 0l1.499 1.5c.54.54.54 1.414 0 1.953l-1.095 1.095L11.049 1.5z\"/></svg>"

/***/ }),

/***/ "./icons/embed.svg":
/*!*************************!*\
  !*** ./icons/embed.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 20 10\"><path d=\"M11.147 1l-1.94 8.731\" stroke=\"currentColor\" stroke-width=\"2\"/><path fill=\"currentColor\" transform=\"rotate(90 16.707 5.06)\" d=\"M20 8.121l1.414-1.414L16.707 2 12 6.707l1.414 1.414 3.293-3.293z\"/><path fill=\"currentColor\" d=\"M6.768 8.354L5.354 9.768.646 5.06 5.354.354l1.414 1.414L3.475 5.06z\"/></svg>"

/***/ }),

/***/ "./icons/envelope.svg":
/*!****************************!*\
  !*** ./icons/envelope.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M15.697 5.963a.188.188 0 0 1 .303.146V12.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5V6.112c0-.156.178-.243.303-.146.7.543 1.628 1.234 4.816 3.55.66.48 1.772 1.493 2.881 1.487 1.116.01 2.25-1.025 2.884-1.487 3.188-2.316 4.113-3.01 4.813-3.553zM8 10c.725.012 1.769-.912 2.294-1.294 4.147-3.01 4.462-3.272 5.418-4.022a.748.748 0 0 0 .288-.59V3.5A1.5 1.5 0 0 0 14.5 2h-13A1.5 1.5 0 0 0 0 3.5v.594a.75.75 0 0 0 .287.59c.957.747 1.272 1.013 5.42 4.022C6.23 9.088 7.274 10.012 8 10z\"/></svg>"

/***/ }),

/***/ "./icons/error.svg":
/*!*************************!*\
  !*** ./icons/error.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.34314575,13.6568542 C-0.781048583,10.5326599 -0.781048583,5.46734008 2.34314575,2.34314575 C5.46734008,-0.781048584 10.5326599,-0.781048584 13.6568542,2.34314575 C16.7810486,5.46734008 16.7810486,10.5326599 13.6568542,13.6568542 C10.5326599,16.7810486 5.46734008,16.7810486 2.34314575,13.6568542 Z M12.2426407,12.2426407 C14.5857864,9.89949494 14.5857864,6.10050506 12.2426407,3.75735931 C9.89949494,1.41421356 6.10050506,1.41421356 3.75735931,3.75735931 C1.41421356,6.10050506 1.41421356,9.89949494 3.75735931,12.2426407 C6.10050506,14.5857864 9.89949494,14.5857864 12.2426407,12.2426407 Z M9.41421356,8 L11.5355339,10.1213203 L10.1213203,11.5355339 L8,9.41421356 L5.87867966,11.5355339 L4.46446609,10.1213203 L6.58578644,8 L4.46446609,5.87867966 L5.87867966,4.46446609 L8,6.58578644 L10.1213203,4.46446609 L11.5355339,5.87867966 L9.41421356,8 Z\"/></svg>"

/***/ }),

/***/ "./icons/eye-solid.svg":
/*!*****************************!*\
  !*** ./icons/eye-solid.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 576 512\"><path fill=\"currentColor\" d=\"M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 000 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 000-29.19zM288 400a144 144 0 11144-144 143.93 143.93 0 01-144 144zm0-240a95.31 95.31 0 00-25.31 3.79 47.85 47.85 0 01-66.9 66.9A95.78 95.78 0 10288 160z\"/></svg>"

/***/ }),

/***/ "./icons/facebook.svg":
/*!****************************!*\
  !*** ./icons/facebook.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M15.11667 0H.88333C.39533 0 0 .39533 0 .88333v14.234C0 15.60467.39533 16 .88333 16h7.66334V9.804H6.46133V7.38933h2.08534V5.60867c0-2.06667 1.262-3.192 3.106-3.192.88333 0 1.642.066 1.86333.09533v2.16l-1.27867.00067c-1.00266 0-1.19666.47666-1.19666 1.17533V7.39H13.432l-.31133 2.41467h-2.08V16H15.118c.48667 0 .882-.39533.882-.88333V.88333C16 .39533 15.60467 0 15.11667 0z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/fb-comment.svg":
/*!******************************!*\
  !*** ./icons/fb-comment.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M14.66 2.667c0-.734-.593-1.334-1.327-1.334H2.667c-.734 0-1.334.6-1.334 1.334v8c0 .733.6 1.333 1.334 1.333H12l2.667 2.667-.007-12z\"/></svg>"

/***/ }),

/***/ "./icons/fb-gallery.svg":
/*!******************************!*\
  !*** ./icons/fb-gallery.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4 1v12h12V1H4zm11 1v5.724L12.209 9S8.87 5.081 7.81 5.081c-.625 0-1.325.64-1.811 1.191V2h9zm-5 3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zM3.136 4v10.12H13V16H1V4h2.136z\"/></svg>"

/***/ }),

/***/ "./icons/fb-share.svg":
/*!****************************!*\
  !*** ./icons/fb-share.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 12\"><path fill-rule=\"evenodd\" d=\"M9.6 8.572v3.555L16 6.053 9.6 0v3.453C3.38 4.327.9 8.653 0 13c2.22-3.047 5.16-4.428 9.6-4.428z\"/></svg>"

/***/ }),

/***/ "./icons/fb-thumbs-up.svg":
/*!********************************!*\
  !*** ./icons/fb-thumbs-up.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 15\"><path fill-rule=\"evenodd\" d=\"M.667 14h2.666V6H.667v8zm14.666-7.333c0-.734-.6-1.334-1.333-1.334H9.793l.634-3.046.02-.214c0-.273-.114-.526-.294-.706l-.706-.7L5.06 5.06c-.247.24-.393.573-.393.94v6.667C4.667 13.4 5.267 14 6 14h6c.553 0 1.027-.333 1.227-.813l2.013-4.7c.06-.154.093-.314.093-.487V6.667z\"/></svg>"

/***/ }),

/***/ "./icons/file-xl.svg":
/*!***************************!*\
  !*** ./icons/file-xl.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-xl\" viewBox=\"0 0 24 30\"><path d=\"M18.229 12.336H6.272v-.5h11.957v.25zm0 1.836H6.272v-.5h11.957v.25zm0 1.837H6.272v-.5h11.957v.25z\"/><path d=\"M21.11 17.029l-.016-9.347h-.005l-2.446-2.357-2.128-2.05c-.036-.037-.073-.079-.108-.112-.065-.062-.13-.121-.204-.198L9.79 2.92l-6.414-.045v23.5h17.75l-.015-9.346zM18.295 5.686l2.02 1.946h-3.461a.748.748 0 0 1-.75-.75l.002-1.958.002-1.346 2.187 2.108zM12.25 25.875H3.875v-22.5h11.729v3.507a1.249 1.249 0 0 0 1.25 1.25h3.723l.023 8.655.025 9.088H12.25z\"/></svg>"

/***/ }),

/***/ "./icons/file.svg":
/*!************************!*\
  !*** ./icons/file.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"4 0 24 32\"><path d=\"M22 15.5v1.75c0 .413-.337.75-.75.75h-10.5a.752.752 0 01-.75-.75V15.5c0-.412.338-.75.75-.75h10.5c.413 0 .75.338.75.75zm-.75 4.5h-10.5a.752.752 0 00-.75.75v1.75c0 .413.338.75.75.75h10.5c.413 0 .75-.337.75-.75v-1.75a.752.752 0 00-.75-.75zM28 8.244V29a3 3 0 01-3 3H7a3 3 0 01-3-3V3a3 3 0 013-3h12.756a3 3 0 012.119.881l5.244 5.244A2.99 2.99 0 0128 8.244zm-8-5V8h4.756L20 3.244zM25 29V11h-6.5c-.831 0-1.5-.669-1.5-1.5V3H7v26h18z\"/></svg>"

/***/ }),

/***/ "./icons/filters.svg":
/*!***************************!*\
  !*** ./icons/filters.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" d=\"M9.17 9H2.003a.999.999 0 1 1 0-2h7.169a3.001 3.001 0 1 1 0 2zM6.83 2h7.168a.999.999 0 1 1 0 2H6.829a3.001 3.001 0 1 1 0-2zm0 10h7.168a.999.999 0 1 1 0 2H6.829a3.001 3.001 0 1 1 0-2zM4 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM4 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z\"/></svg>"

/***/ }),

/***/ "./icons/graph-trending-up-lg.svg":
/*!****************************************!*\
  !*** ./icons/graph-trending-up-lg.svg ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"2 7 26 16\"><path d=\"M20 7.5l2.863 2.863-6.1 6.1-5-5L2.5 20.738 4.263 22.5l7.5-7.5 5 5 7.874-7.863L27.5 15V7.5z\"/></svg>"

/***/ }),

/***/ "./icons/graph-trending-up.svg":
/*!*************************************!*\
  !*** ./icons/graph-trending-up.svg ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 24 24\"><path d=\"M20.024 6h-5.25c-1.003 0-1.504 1.214-.796 1.922l1.542 1.542-3.375 3.417-2.606-2.606a.557.557 0 00-.793 0l-5.578 5.522a.562.562 0 00-.01.792l1.337 1.378a.56.56 0 00.801.005l3.849-3.849 2.601 2.602c.22.22.577.22.797 0l5.119-5.119 1.566 1.566c.707.708 1.921.206 1.921-.797v-5.25c0-.623-.501-1.125-1.125-1.125z\"/></svg>"

/***/ }),

/***/ "./icons/grid-details.svg":
/*!********************************!*\
  !*** ./icons/grid-details.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M1 1h6v6H1V1zm0 8h6v2H1V9zm0 4h6v2H1v-2zM9 1h6v6H9V1zm0 8h6v2H9V9zm0 4h6v2H9v-2z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/grid.svg":
/*!************************!*\
  !*** ./icons/grid.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M1 1h6v6H1V1zm8 0h6v6H9V1zM1 9h6v6H1V9zm8 0h6v6H9V9z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/hamburger.svg":
/*!*****************************!*\
  !*** ./icons/hamburger.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 14 10\"><path d=\"M14 8v2H0V8h14zm0-4v2H0V4h14zm0-4v2H0V0h14z\"/></svg>"

/***/ }),

/***/ "./icons/hashtag.svg":
/*!***************************!*\
  !*** ./icons/hashtag.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><path d=\"M5.373 2h1.5L5.5 14H4z\"/><path d=\"M3.049 5h9.98l-.191 1.5h-9.98zm-.573 5h9.98l-.19 1.5h-9.98z\"/><path d=\"M9.873 2h1.5L10 14H8.5z\"/></g></svg>"

/***/ }),

/***/ "./icons/help-lg.svg":
/*!***************************!*\
  !*** ./icons/help-lg.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm11.627.268l.675-.676A2.314 2.314 0 0 0 15 9.939C15 8.315 13.658 7 12 7S9 8.315 9 9.939h1.5c0-.808.675-1.47 1.5-1.47s1.5.662 1.5 1.47c0 .404-.165.771-.443 1.036l-.93.925a2.927 2.927 0 0 0-.877 2.08v.367h1.5c0-1.102.338-1.543.877-2.08zm-2.377 5.018h1.5v-1.47h-1.5v1.47z\"/></svg>"

/***/ }),

/***/ "./icons/help-sm.svg":
/*!***************************!*\
  !*** ./icons/help-sm.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-sm\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"svg-fill-color-1\" fill-rule=\"evenodd\" d=\"M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm-1.195-3.814c0 .556.427.931 1.066.931.662 0 1.084-.375 1.084-.931 0-.569-.428-.944-1.084-.944-.639 0-1.066.375-1.066.944zM5.38 6.258h1.517c.006-.598.37-1.06 1.073-1.06.533 0 1.037.269 1.037.907 0 .534-.352.786-.903 1.155-.673.45-1.095 1.031-1.03 1.922l.01.31h1.478V9.2c0-.638.263-.82.949-1.3.568-.393 1.172-.85 1.172-1.881 0-1.46-1.22-2.168-2.62-2.168-1.359 0-2.742.668-2.683 2.408z\"/></svg>"

/***/ }),

/***/ "./icons/history-lg.svg":
/*!******************************!*\
  !*** ./icons/history-lg.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"1 3 27 24\"><path d=\"M16.25 3.75C10.037 3.75 5 8.787 5 15H1.25l4.862 4.863.088.175L11.25 15H7.5a8.744 8.744 0 0 1 8.75-8.75A8.744 8.744 0 0 1 25 15a8.744 8.744 0 0 1-8.75 8.75 8.68 8.68 0 0 1-6.175-2.575L8.3 22.95a11.193 11.193 0 0 0 7.95 3.3c6.212 0 11.25-5.038 11.25-11.25 0-6.213-5.038-11.25-11.25-11.25zM15 10v6.25l5.35 3.175.9-1.512-4.375-2.6V10H15z\"/></svg>"

/***/ }),

/***/ "./icons/ig-comment.svg":
/*!******************************!*\
  !*** ./icons/ig-comment.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 16\" class=\"cu-icon\"><path d=\"M8.002 0C3.584 0 0 3.325 0 7.43c0 1.76.659 3.375 1.759 4.65-.242.832-.614 1.168-1.03 1.54-.31.275-.895.703-.684 1.543.142.55.58.882 1.058.832 1.603-.164 3.09-.686 4.362-1.518a8.59 8.59 0 0 0 2.534.382c4.42 0 8.001-3.322 8.001-7.43C16.003 3.326 12.422 0 8.002 0zm0 13.35c-.903 0-1.817-.235-2.704-.578-.897.68-2.186 1.516-3.742 1.801.89-.857 1.578-2.2 1.7-3.157C2.198 10.487 1.5 9.098 1.5 7.43c0-2.533 2.232-5.93 6.502-5.93S14.5 4.897 14.5 7.43c0 2.536-2.228 5.92-6.498 5.92z\"/></svg>"

/***/ }),

/***/ "./icons/ig-heart.svg":
/*!****************************!*\
  !*** ./icons/ig-heart.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 16\" class=\"cu-icon\"><path d=\"M7.07 14.648L2.076 9.745C1.86 9.545 0 7.761 0 5.54 0 2.791 1.721.97 4.606.97 5.861.97 7.048 1.662 8 2.48c.948-.818 2.14-1.51 3.394-1.51C14.173.97 16 2.683 16 5.54c0 1.576-.964 3.137-2.064 4.203l-.012.013-4.994 4.893c-.515.51-1.345.51-1.86 0zM3.088 8.7L8 13.524l4.903-4.809c.827-.818 1.642-2.009 1.642-3.176 0-2.027-1.157-3.115-3.151-3.115-1.43 0-2.812 1.494-3.394 2.073-.515-.515-1.94-2.073-3.394-2.073-1.997 0-3.151 1.088-3.151 3.115 0 1.13.809 2.391 1.633 3.161z\"/></svg>"

/***/ }),

/***/ "./icons/ig-save.svg":
/*!***************************!*\
  !*** ./icons/ig-save.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 14 16\" class=\"cu-icon\"><path d=\"M14 0v16l-7-6-7 6V0h14zm-1.5 1.5h-11v11.238L7 8.024l5.5 4.715V1.5z\"/></svg>"

/***/ }),

/***/ "./icons/ig-send.svg":
/*!***************************!*\
  !*** ./icons/ig-send.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 16\" class=\"cu-icon\"><path d=\"M15.29 1.09l.05.05a1 1 0 0 1 .19 1.07l-4.17 12.91a1 1 0 0 1-.47.57 1.15 1.15 0 0 1-1.55-.43L7 9.37 1.12 7a1.16 1.16 0 0 1-.43-1.51A1.1 1.1 0 0 1 1.26 5L14.17.85a1 1 0 0 1 1.12.24zm-2.24 3.6L8.7 9l1.43 4.36 2.92-8.67zm-1.36-1.36L3 6.26l4.34 1.42 4.35-4.35z\"/></svg>"

/***/ }),

/***/ "./icons/ig-story-swipe.svg":
/*!**********************************!*\
  !*** ./icons/ig-story-swipe.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 28 28\"><path d=\"M14 0c7.7 0 14 6.3 14 14s-6.3 14-14 14S0 21.7 0 14 6.3 0 14 0zm-.6 10.2l-7.1 5.6c-.3.3-.3.7 0 1 .3.3.9.3 1.3 0l6.5-5.1 6.5 5.1c.3.3.9.3 1.3 0 .3-.3.3-.7 0-1l-7.1-5.6c-.5-.3-1.1-.3-1.4 0z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/ig-tv.svg":
/*!*************************!*\
  !*** ./icons/ig-tv.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 14 16\"><path d=\"M12.948 3.278a3.956 3.956 0 00-2.802-1.17h-1.77l.825-.93a.695.695 0 10-1.04-.92L6.98 1.591 5.794.264a.695.695 0 00-1.039.921l.825.93H3.96c-1.052 0-2.06.418-2.803 1.163A3.917 3.917 0 000 6.053v6.004a3.917 3.917 0 001.156 2.774A3.956 3.956 0 003.96 16h6.187a3.961 3.961 0 003.958-3.938V6.053a3.917 3.917 0 00-1.156-2.775zm-2.232 6.358l-3.378.975a.698.698 0 01-.93-.687l.043-.855-2.829.729a.695.695 0 11-.348-1.346l3.742-.968a.695.695 0 01.869.705l-.042.829 2.49-.717a.695.695 0 01.383 1.335z\"/></svg>"

/***/ }),

/***/ "./icons/index.ts":
/*!************************!*\
  !*** ./icons/index.ts ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var add_lg_svg_1 = __importDefault(__webpack_require__(/*! ./add-lg.svg */ "./icons/add-lg.svg"));
var add_with_circle_svg_1 = __importDefault(__webpack_require__(/*! ./add-with-circle.svg */ "./icons/add-with-circle.svg"));
var add_svg_1 = __importDefault(__webpack_require__(/*! ./add.svg */ "./icons/add.svg"));
var alarm_svg_1 = __importDefault(__webpack_require__(/*! ./alarm.svg */ "./icons/alarm.svg"));
var app_switcher_svg_1 = __importDefault(__webpack_require__(/*! ./app-switcher.svg */ "./icons/app-switcher.svg"));
var at_svg_1 = __importDefault(__webpack_require__(/*! ./at.svg */ "./icons/at.svg"));
var bar_graph_svg_1 = __importDefault(__webpack_require__(/*! ./bar-graph.svg */ "./icons/bar-graph.svg"));
var beautify_svg_1 = __importDefault(__webpack_require__(/*! ./beautify.svg */ "./icons/beautify.svg"));
var bell_svg_1 = __importDefault(__webpack_require__(/*! ./bell.svg */ "./icons/bell.svg"));
var bullhorn_svg_1 = __importDefault(__webpack_require__(/*! ./bullhorn.svg */ "./icons/bullhorn.svg"));
var calendar_svg_1 = __importDefault(__webpack_require__(/*! ./calendar.svg */ "./icons/calendar.svg"));
var checkmark_svg_1 = __importDefault(__webpack_require__(/*! ./checkmark.svg */ "./icons/checkmark.svg"));
var chevron_down_svg_1 = __importDefault(__webpack_require__(/*! ./chevron-down.svg */ "./icons/chevron-down.svg"));
var chevron_left_svg_1 = __importDefault(__webpack_require__(/*! ./chevron-left.svg */ "./icons/chevron-left.svg"));
var chevron_right_svg_1 = __importDefault(__webpack_require__(/*! ./chevron-right.svg */ "./icons/chevron-right.svg"));
var chevron_up_svg_1 = __importDefault(__webpack_require__(/*! ./chevron-up.svg */ "./icons/chevron-up.svg"));
var circle_checkmark_filled_svg_1 = __importDefault(__webpack_require__(/*! ./circle-checkmark-filled.svg */ "./icons/circle-checkmark-filled.svg"));
var circle_checkmark_svg_1 = __importDefault(__webpack_require__(/*! ./circle-checkmark.svg */ "./icons/circle-checkmark.svg"));
var close_lg_svg_1 = __importDefault(__webpack_require__(/*! ./close-lg.svg */ "./icons/close-lg.svg"));
var close_svg_1 = __importDefault(__webpack_require__(/*! ./close.svg */ "./icons/close.svg"));
var collapse_svg_1 = __importDefault(__webpack_require__(/*! ./collapse.svg */ "./icons/collapse.svg"));
var comments_svg_1 = __importDefault(__webpack_require__(/*! ./comments.svg */ "./icons/comments.svg"));
var copy_svg_1 = __importDefault(__webpack_require__(/*! ./copy.svg */ "./icons/copy.svg"));
var cross_post_svg_1 = __importDefault(__webpack_require__(/*! ./cross-post.svg */ "./icons/cross-post.svg"));
var delete_svg_1 = __importDefault(__webpack_require__(/*! ./delete.svg */ "./icons/delete.svg"));
var desktop_svg_1 = __importDefault(__webpack_require__(/*! ./desktop.svg */ "./icons/desktop.svg"));
var distribute_circle_svg_1 = __importDefault(__webpack_require__(/*! ./distribute-circle.svg */ "./icons/distribute-circle.svg"));
var distribute_svg_1 = __importDefault(__webpack_require__(/*! ./distribute.svg */ "./icons/distribute.svg"));
var double_chevron_right_svg_1 = __importDefault(__webpack_require__(/*! ./double-chevron-right.svg */ "./icons/double-chevron-right.svg"));
var download_svg_1 = __importDefault(__webpack_require__(/*! ./download.svg */ "./icons/download.svg"));
var edit_svg_1 = __importDefault(__webpack_require__(/*! ./edit.svg */ "./icons/edit.svg"));
var embed_svg_1 = __importDefault(__webpack_require__(/*! ./embed.svg */ "./icons/embed.svg"));
var envelope_svg_1 = __importDefault(__webpack_require__(/*! ./envelope.svg */ "./icons/envelope.svg"));
var error_svg_1 = __importDefault(__webpack_require__(/*! ./error.svg */ "./icons/error.svg"));
var eye_solid_svg_1 = __importDefault(__webpack_require__(/*! ./eye-solid.svg */ "./icons/eye-solid.svg"));
var facebook_svg_1 = __importDefault(__webpack_require__(/*! ./facebook.svg */ "./icons/facebook.svg"));
var fb_comment_svg_1 = __importDefault(__webpack_require__(/*! ./fb-comment.svg */ "./icons/fb-comment.svg"));
var fb_gallery_svg_1 = __importDefault(__webpack_require__(/*! ./fb-gallery.svg */ "./icons/fb-gallery.svg"));
var fb_share_svg_1 = __importDefault(__webpack_require__(/*! ./fb-share.svg */ "./icons/fb-share.svg"));
var fb_thumbs_up_svg_1 = __importDefault(__webpack_require__(/*! ./fb-thumbs-up.svg */ "./icons/fb-thumbs-up.svg"));
var file_svg_1 = __importDefault(__webpack_require__(/*! ./file.svg */ "./icons/file.svg"));
var file_xl_svg_1 = __importDefault(__webpack_require__(/*! ./file-xl.svg */ "./icons/file-xl.svg"));
var filters_svg_1 = __importDefault(__webpack_require__(/*! ./filters.svg */ "./icons/filters.svg"));
var graph_trending_up_lg_svg_1 = __importDefault(__webpack_require__(/*! ./graph-trending-up-lg.svg */ "./icons/graph-trending-up-lg.svg"));
var graph_trending_up_svg_1 = __importDefault(__webpack_require__(/*! ./graph-trending-up.svg */ "./icons/graph-trending-up.svg"));
var grid_details_svg_1 = __importDefault(__webpack_require__(/*! ./grid-details.svg */ "./icons/grid-details.svg"));
var grid_svg_1 = __importDefault(__webpack_require__(/*! ./grid.svg */ "./icons/grid.svg"));
var hamburger_svg_1 = __importDefault(__webpack_require__(/*! ./hamburger.svg */ "./icons/hamburger.svg"));
var hashtag_svg_1 = __importDefault(__webpack_require__(/*! ./hashtag.svg */ "./icons/hashtag.svg"));
var help_lg_svg_1 = __importDefault(__webpack_require__(/*! ./help-lg.svg */ "./icons/help-lg.svg"));
var help_sm_svg_1 = __importDefault(__webpack_require__(/*! ./help-sm.svg */ "./icons/help-sm.svg"));
var history_lg_svg_1 = __importDefault(__webpack_require__(/*! ./history-lg.svg */ "./icons/history-lg.svg"));
var ig_comment_svg_1 = __importDefault(__webpack_require__(/*! ./ig-comment.svg */ "./icons/ig-comment.svg"));
var ig_heart_svg_1 = __importDefault(__webpack_require__(/*! ./ig-heart.svg */ "./icons/ig-heart.svg"));
var ig_save_svg_1 = __importDefault(__webpack_require__(/*! ./ig-save.svg */ "./icons/ig-save.svg"));
var ig_send_svg_1 = __importDefault(__webpack_require__(/*! ./ig-send.svg */ "./icons/ig-send.svg"));
var ig_story_swipe_svg_1 = __importDefault(__webpack_require__(/*! ./ig-story-swipe.svg */ "./icons/ig-story-swipe.svg"));
var ig_tv_svg_1 = __importDefault(__webpack_require__(/*! ./ig-tv.svg */ "./icons/ig-tv.svg"));
var info_svg_1 = __importDefault(__webpack_require__(/*! ./info.svg */ "./icons/info.svg"));
var instagram_gallery_svg_1 = __importDefault(__webpack_require__(/*! ./instagram-gallery.svg */ "./icons/instagram-gallery.svg"));
var instagram_story_svg_1 = __importDefault(__webpack_require__(/*! ./instagram-story.svg */ "./icons/instagram-story.svg"));
var instagram_video_svg_1 = __importDefault(__webpack_require__(/*! ./instagram-video.svg */ "./icons/instagram-video.svg"));
var instagram_svg_1 = __importDefault(__webpack_require__(/*! ./instagram.svg */ "./icons/instagram.svg"));
var kebab_svg_1 = __importDefault(__webpack_require__(/*! ./kebab.svg */ "./icons/kebab.svg"));
var lightbulb_svg_1 = __importDefault(__webpack_require__(/*! ./lightbulb.svg */ "./icons/lightbulb.svg"));
var likes_svg_1 = __importDefault(__webpack_require__(/*! ./likes.svg */ "./icons/likes.svg"));
var link_svg_1 = __importDefault(__webpack_require__(/*! ./link.svg */ "./icons/link.svg"));
var linkout_svg_1 = __importDefault(__webpack_require__(/*! ./linkout.svg */ "./icons/linkout.svg"));
var location_svg_1 = __importDefault(__webpack_require__(/*! ./location.svg */ "./icons/location.svg"));
var media_published_svg_1 = __importDefault(__webpack_require__(/*! ./media-published.svg */ "./icons/media-published.svg"));
var mobile_svg_1 = __importDefault(__webpack_require__(/*! ./mobile.svg */ "./icons/mobile.svg"));
var more_svg_1 = __importDefault(__webpack_require__(/*! ./more.svg */ "./icons/more.svg"));
var multiple_users_svg_1 = __importDefault(__webpack_require__(/*! ./multiple-users.svg */ "./icons/multiple-users.svg"));
var new_feature_lg_svg_1 = __importDefault(__webpack_require__(/*! ./new-feature-lg.svg */ "./icons/new-feature-lg.svg"));
var new_svg_1 = __importDefault(__webpack_require__(/*! ./new.svg */ "./icons/new.svg"));
var notifications_lg_svg_1 = __importDefault(__webpack_require__(/*! ./notifications-lg.svg */ "./icons/notifications-lg.svg"));
var notifications_svg_1 = __importDefault(__webpack_require__(/*! ./notifications.svg */ "./icons/notifications.svg"));
var pin_circle_svg_1 = __importDefault(__webpack_require__(/*! ./pin-circle.svg */ "./icons/pin-circle.svg"));
var pin_svg_1 = __importDefault(__webpack_require__(/*! ./pin.svg */ "./icons/pin.svg"));
var pinterest_svg_1 = __importDefault(__webpack_require__(/*! ./pinterest.svg */ "./icons/pinterest.svg"));
var pinterest_export_svg_1 = __importDefault(__webpack_require__(/*! ./pinterest-export.svg */ "./icons/pinterest-export.svg"));
var pinterest_more_svg_1 = __importDefault(__webpack_require__(/*! ./pinterest-more.svg */ "./icons/pinterest-more.svg"));
var product_bag_svg_1 = __importDefault(__webpack_require__(/*! ./product-bag.svg */ "./icons/product-bag.svg"));
var product_svg_1 = __importDefault(__webpack_require__(/*! ./product.svg */ "./icons/product.svg"));
var reach_svg_1 = __importDefault(__webpack_require__(/*! ./reach.svg */ "./icons/reach.svg"));
var requestrights_approved_svg_1 = __importDefault(__webpack_require__(/*! ./requestrights-approved.svg */ "./icons/requestrights-approved.svg"));
var requestrights_pending_svg_1 = __importDefault(__webpack_require__(/*! ./requestrights-pending.svg */ "./icons/requestrights-pending.svg"));
var requestrights_rejected_svg_1 = __importDefault(__webpack_require__(/*! ./requestrights-rejected.svg */ "./icons/requestrights-rejected.svg"));
var search_svg_1 = __importDefault(__webpack_require__(/*! ./search.svg */ "./icons/search.svg"));
var settings_svg_1 = __importDefault(__webpack_require__(/*! ./settings.svg */ "./icons/settings.svg"));
var smile_svg_1 = __importDefault(__webpack_require__(/*! ./smile.svg */ "./icons/smile.svg"));
var sparkles_svg_1 = __importDefault(__webpack_require__(/*! ./sparkles.svg */ "./icons/sparkles.svg"));
var spinner_svg_1 = __importDefault(__webpack_require__(/*! ./spinner.svg */ "./icons/spinner.svg"));
var sticker_svg_1 = __importDefault(__webpack_require__(/*! ./sticker.svg */ "./icons/sticker.svg"));
var sync_alt_svg_1 = __importDefault(__webpack_require__(/*! ./sync-alt.svg */ "./icons/sync-alt.svg"));
var tag_svg_1 = __importDefault(__webpack_require__(/*! ./tag.svg */ "./icons/tag.svg"));
var text_svg_1 = __importDefault(__webpack_require__(/*! ./text.svg */ "./icons/text.svg"));
var trending_down_svg_1 = __importDefault(__webpack_require__(/*! ./trending-down.svg */ "./icons/trending-down.svg"));
var trending_up_svg_1 = __importDefault(__webpack_require__(/*! ./trending-up.svg */ "./icons/trending-up.svg"));
var twitter_comment_svg_1 = __importDefault(__webpack_require__(/*! ./twitter-comment.svg */ "./icons/twitter-comment.svg"));
var twitter_like_svg_1 = __importDefault(__webpack_require__(/*! ./twitter-like.svg */ "./icons/twitter-like.svg"));
var twitter_retweet_svg_1 = __importDefault(__webpack_require__(/*! ./twitter-retweet.svg */ "./icons/twitter-retweet.svg"));
var twitter_share_svg_1 = __importDefault(__webpack_require__(/*! ./twitter-share.svg */ "./icons/twitter-share.svg"));
var twitter_square_svg_1 = __importDefault(__webpack_require__(/*! ./twitter-square.svg */ "./icons/twitter-square.svg"));
var twitter_svg_1 = __importDefault(__webpack_require__(/*! ./twitter.svg */ "./icons/twitter.svg"));
var undo_svg_1 = __importDefault(__webpack_require__(/*! ./undo.svg */ "./icons/undo.svg"));
var upload_svg_1 = __importDefault(__webpack_require__(/*! ./upload.svg */ "./icons/upload.svg"));
var user_svg_1 = __importDefault(__webpack_require__(/*! ./user.svg */ "./icons/user.svg"));
var verified_svg_1 = __importDefault(__webpack_require__(/*! ./verified.svg */ "./icons/verified.svg"));
var zoom_svg_1 = __importDefault(__webpack_require__(/*! ./zoom.svg */ "./icons/zoom.svg"));
var icons = {
    'add': add_svg_1.default,
    'add-lg': add_lg_svg_1.default,
    'add-with-circle': add_with_circle_svg_1.default,
    'alarm': alarm_svg_1.default,
    'app-switcher': app_switcher_svg_1.default,
    'at': at_svg_1.default,
    'bar-graph': bar_graph_svg_1.default,
    'bell': bell_svg_1.default,
    'beautify': beautify_svg_1.default,
    'bullhorn': bullhorn_svg_1.default,
    'calendar': calendar_svg_1.default,
    'checkmark': checkmark_svg_1.default,
    'chevron-down': chevron_down_svg_1.default,
    'chevron-left': chevron_left_svg_1.default,
    'chevron-right': chevron_right_svg_1.default,
    'chevron-up': chevron_up_svg_1.default,
    'circle-checkmark': circle_checkmark_svg_1.default,
    'circle-checkmark-filled': circle_checkmark_filled_svg_1.default,
    'close': close_svg_1.default,
    'close-lg': close_lg_svg_1.default,
    'collapse': collapse_svg_1.default,
    'comments': comments_svg_1.default,
    'copy': copy_svg_1.default,
    'cross-post': cross_post_svg_1.default,
    'delete': delete_svg_1.default,
    'desktop': desktop_svg_1.default,
    'distribute': distribute_svg_1.default,
    'distribute-circle': distribute_circle_svg_1.default,
    'double-chevron-right': double_chevron_right_svg_1.default,
    'download': download_svg_1.default,
    'edit': edit_svg_1.default,
    'embed': embed_svg_1.default,
    'envelope': envelope_svg_1.default,
    'error': error_svg_1.default,
    'eye-solid': eye_solid_svg_1.default,
    'facebook': facebook_svg_1.default,
    'fb-comment': fb_comment_svg_1.default,
    'fb-gallery': fb_gallery_svg_1.default,
    'fb-share': fb_share_svg_1.default,
    'fb-thumbs-up': fb_thumbs_up_svg_1.default,
    'file': file_svg_1.default,
    'file-xl': file_xl_svg_1.default,
    'filters': filters_svg_1.default,
    'graph-trending-up': graph_trending_up_svg_1.default,
    'graph-trending-up-lg': graph_trending_up_lg_svg_1.default,
    'grid': grid_svg_1.default,
    'grid-details': grid_details_svg_1.default,
    'hamburger': hamburger_svg_1.default,
    'hashtag': hashtag_svg_1.default,
    'help-lg': help_lg_svg_1.default,
    'help-sm': help_sm_svg_1.default,
    'history-lg': history_lg_svg_1.default,
    'ig-comment': ig_comment_svg_1.default,
    'ig-heart': ig_heart_svg_1.default,
    'ig-save': ig_save_svg_1.default,
    'ig-send': ig_send_svg_1.default,
    'ig-story-swipe': ig_story_swipe_svg_1.default,
    'ig-tv': ig_tv_svg_1.default,
    'info': info_svg_1.default,
    'instagram': instagram_svg_1.default,
    'instagram-gallery': instagram_gallery_svg_1.default,
    'instagram-story': instagram_story_svg_1.default,
    'instagram-video': instagram_video_svg_1.default,
    'kebab': kebab_svg_1.default,
    'lightbulb': lightbulb_svg_1.default,
    'likes': likes_svg_1.default,
    'link': link_svg_1.default,
    'linkout': linkout_svg_1.default,
    'location': location_svg_1.default,
    'media-published': media_published_svg_1.default,
    'mobile': mobile_svg_1.default,
    'more': more_svg_1.default,
    'multiple-users': multiple_users_svg_1.default,
    'new': new_svg_1.default,
    'new-feature-lg': new_feature_lg_svg_1.default,
    'notifications': notifications_svg_1.default,
    'notifications-lg': notifications_lg_svg_1.default,
    'pin': pin_svg_1.default,
    'pin-circle': pin_circle_svg_1.default,
    'pinterest': pinterest_svg_1.default,
    'pinterest-export': pinterest_export_svg_1.default,
    'pinterest-more': pinterest_more_svg_1.default,
    'product': product_svg_1.default,
    'product-bag': product_bag_svg_1.default,
    'reach': reach_svg_1.default,
    'request-rights-approved': requestrights_approved_svg_1.default,
    'request-rights-pending': requestrights_pending_svg_1.default,
    'request-rights-rejected': requestrights_rejected_svg_1.default,
    'search': search_svg_1.default,
    'settings': settings_svg_1.default,
    'smile': smile_svg_1.default,
    'sparkles': sparkles_svg_1.default,
    'spinner': spinner_svg_1.default,
    'sticker': sticker_svg_1.default,
    'sync-alt': sync_alt_svg_1.default,
    'tag': tag_svg_1.default,
    'text': text_svg_1.default,
    'trending-down': trending_down_svg_1.default,
    'trending-up': trending_up_svg_1.default,
    'twitter': twitter_svg_1.default,
    'twitter-comment': twitter_comment_svg_1.default,
    'twitter-like': twitter_like_svg_1.default,
    'twitter-retweet': twitter_retweet_svg_1.default,
    'twitter-share': twitter_share_svg_1.default,
    'twitter-square': twitter_square_svg_1.default,
    'undo': undo_svg_1.default,
    'upload': upload_svg_1.default,
    'user': user_svg_1.default,
    'verified': verified_svg_1.default,
    'zoom': zoom_svg_1.default,
};
exports.default = icons;


/***/ }),

/***/ "./icons/info.svg":
/*!************************!*\
  !*** ./icons/info.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 14 14\"><path d=\"M7 0C3.136 0 0 3.136 0 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7zm.7 10.5H6.3V6.3h1.4v4.2zm0-5.6H6.3V3.5h1.4v1.4z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/instagram-gallery.svg":
/*!*************************************!*\
  !*** ./icons/instagram-gallery.svg ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><path d=\"M14,3 C15.1045695,3 16,3.8954305 16,5 L16,14 C16,15.1045695 15.1045695,16 14,16 L5,16 C3.8954305,16 3,15.1045695 3,14 L12,14 C13.1045695,14 14,13.1045695 14,12 L14,3 Z\"/><rect width=\"13\" height=\"13\" rx=\"2\"/></g></svg>"

/***/ }),

/***/ "./icons/instagram-story.svg":
/*!***********************************!*\
  !*** ./icons/instagram-story.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M9,7 L9,4 L7,4 L7,7 L4,7 L4,9 L7,9 L7,12 L9,12 L9,9 L12,9 L12,7 L9,7 Z M1.39106014,3.49082242 C0.489972223,4.80928646 0,6.36934072 0,8 C0,8.55228475 0.44771525,9 1,9 C1.55228475,9 2,8.55228475 2,8 C2,6.7752654 2.36664056,5.6078948 3.04226921,4.61932082 C3.35389543,4.16335202 3.23688266,3.54109331 2.78091387,3.22946709 C2.32494508,2.91784086 1.70268637,3.03485363 1.39106014,3.49082242 Z M0.876131905,11.6433773 C1.89121865,13.62469 3.6955939,15.1067197 5.84684555,15.7066471 C6.37883117,15.8550039 6.93035767,15.5440113 7.07871446,15.0120257 C7.22707125,14.48004 6.91607863,13.9285135 6.384093,13.7801567 C4.77260986,13.3307565 3.41766646,12.2178692 2.65612092,10.7314348 C2.40429496,10.2399044 1.80168557,10.0455856 1.31015517,10.2974115 C0.818624777,10.5492375 0.624305941,11.1518469 0.876131905,11.6433773 Z M9.59594955,15.8405927 C13.2984571,15.0904967 16,11.8231983 16,8 C16,3.581722 12.418278,0 8,0 C6.94640872,0 5.91956207,0.204289489 4.96419013,0.596398246 C4.4532639,0.806095262 4.20906938,1.39027582 4.4187664,1.90120205 C4.62846342,2.41212827 5.21264398,2.65632279 5.7235702,2.44662577 C6.43901345,2.15298981 7.20800589,2 8,2 C11.3137085,2 14,4.6862915 14,8 C14,10.8671259 11.9732252,13.3183467 9.19883432,13.8804143 C8.65754599,13.9900747 8.30764238,14.5177728 8.41730272,15.0590611 C8.52696306,15.6003495 9.05466122,15.9502531 9.59594955,15.8405927 Z\"/></svg>"

/***/ }),

/***/ "./icons/instagram-video.svg":
/*!***********************************!*\
  !*** ./icons/instagram-video.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M15.458 3.7c-.151 0-.302.063-.451.187l-2.144 1.785c-.345.286-.604.848-.604 1.307v1.946c0 .459.26 1.02.604 1.307l2.144 1.785c.15.124.3.187.451.187v-.002c.17 0 .325-.084.424-.233a.805.805 0 0 0 .118-.45V4.384c0-.472-.272-.683-.542-.683zM10.202 2c.734 0 1.331.621 1.331 1.385v9.23c0 .764-.597 1.385-1.33 1.385H1.33C.597 14 0 13.379 0 12.615v-9.23C0 2.62.597 2 1.33 2h8.872zm-4.481 9.991c2.144 0 3.882-1.808 3.882-4.039 0-2.23-1.738-4.039-3.882-4.039s-3.882 1.809-3.882 4.04c0 2.23 1.738 4.038 3.882 4.038zm0-1.275c-1.467 0-2.656-1.238-2.656-2.764 0-1.526 1.189-2.763 2.656-2.763s2.656 1.237 2.656 2.763c0 1.526-1.19 2.764-2.656 2.764z\"/></svg>"

/***/ }),

/***/ "./icons/instagram.svg":
/*!*****************************!*\
  !*** ./icons/instagram.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><path d=\"M8 1.444c2.135 0 2.388.008 3.232.046.78.036 1.203.166 1.485.275.373.146.64.319.92.599.28.28.452.546.597.92.11.281.24.705.276 1.484.038.844.046 1.097.046 3.232 0 2.135-.008 2.388-.046 3.232-.036.78-.166 1.203-.276 1.485a2.48 2.48 0 0 1-.598.92 2.47 2.47 0 0 1-.92.597c-.281.11-.705.24-1.484.276-.844.038-1.096.046-3.232.046s-2.388-.008-3.232-.046c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.478 2.478 0 0 1-.597-.92c-.11-.281-.24-.705-.276-1.484-.038-.844-.046-1.097-.046-3.232 0-2.135.008-2.388.046-3.232.036-.78.166-1.203.276-1.485a2.48 2.48 0 0 1 .598-.92c.28-.28.546-.452.92-.598.281-.109.705-.24 1.484-.275.844-.038 1.097-.046 3.232-.046M8 .003c-2.172 0-2.444.009-3.297.048C3.85.089 3.27.225 2.76.422a3.92 3.92 0 0 0-1.416.923A3.92 3.92 0 0 0 .422 2.76C.225 3.27.089 3.85.051 4.702.01 5.556.003 5.828.003 8s.009 2.444.048 3.297c.038.852.174 1.433.371 1.942.205.526.478.972.923 1.416.444.445.89.718 1.416.923.51.197 1.09.333 1.942.371.853.04 1.125.048 3.297.048s2.444-.009 3.297-.048c.852-.038 1.433-.174 1.942-.371a3.92 3.92 0 0 0 1.416-.923 3.92 3.92 0 0 0 .923-1.416c.197-.51.333-1.09.371-1.942.04-.853.048-1.125.048-3.297s-.009-2.444-.048-3.297c-.038-.852-.174-1.433-.371-1.942a3.92 3.92 0 0 0-.923-1.416A3.92 3.92 0 0 0 13.24.422c-.51-.197-1.09-.333-1.942-.371C10.444.01 10.172.003 8 .003\"/><path d=\"M8 3.893a4.107 4.107 0 1 0 0 8.214 4.107 4.107 0 0 0 0-8.214zm0 6.773a2.666 2.666 0 1 1 0-5.332 2.666 2.666 0 0 1 0 5.332zm5.229-6.936a.96.96 0 1 1-1.92.001.96.96 0 0 1 1.92 0\"/></g></svg>"

/***/ }),

/***/ "./icons/kebab.svg":
/*!*************************!*\
  !*** ./icons/kebab.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon cu-icon-stroke\" viewBox=\"0 0 16 16\"><path d=\"M8,4.5 C8.82842712,4.5 9.5,3.82842712 9.5,3 C9.5,2.17157288 8.82842712,1.5 8,1.5 C7.17157288,1.5 6.5,2.17157288 6.5,3 C6.5,3.82842712 7.17157288,4.5 8,4.5 Z M8,9.5 C8.82842712,9.5 9.5,8.82842712 9.5,8 C9.5,7.17157288 8.82842712,6.5 8,6.5 C7.17157288,6.5 6.5,7.17157288 6.5,8 C6.5,8.82842712 7.17157288,9.5 8,9.5 Z M8,14.5 C8.82842712,14.5 9.5,13.8284271 9.5,13 C9.5,12.1715729 8.82842712,11.5 8,11.5 C7.17157288,11.5 6.5,12.1715729 6.5,13 C6.5,13.8284271 7.17157288,14.5 8,14.5 Z\"/></svg>"

/***/ }),

/***/ "./icons/lightbulb.svg":
/*!*****************************!*\
  !*** ./icons/lightbulb.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8 3.817c2.348.003 4.25 1.94 4.252 4.33.002.968-.32 1.91-.911 2.669a13.25 13.25 0 0 1-.33.405l-.017.02c-.408.489-.866 1.037-1.02 1.608a2.32 2.32 0 0 0-.038.536v.334a.543.543 0 0 1-.538.548H6.579a.543.543 0 0 1-.538-.548v-.33a2.757 2.757 0 0 0-.037-.58c-.155-.574-.568-1.062-.967-1.534l-.008-.008c-.13-.154-.254-.3-.37-.452a4.324 4.324 0 0 1-.91-2.669c.003-2.39 1.905-4.327 4.252-4.33zm2.389 6.274h-.001a3.09 3.09 0 0 0 .65-1.907c0-1.709-1.36-3.094-3.039-3.094-1.678 0-3.039 1.385-3.039 3.094a3.088 3.088 0 0 0 .65 1.906c.099.127.21.257.326.396l.007.008c.415.491.93 1.098 1.14 1.88.05.203.073.411.072.62h1.67a2.378 2.378 0 0 1 .071-.588c.209-.77.726-1.389 1.181-1.934l.021-.025c.106-.127.206-.246.29-.356zm-.991 4.726a.58.58 0 0 1 .574.585.58.58 0 0 1-.574.584H6.579a.58.58 0 0 1-.574-.584.58.58 0 0 1 .574-.585h2.819zm6.028-7.255a.58.58 0 0 1 .574.584.58.58 0 0 1-.574.585H13.57a.58.58 0 0 1-.574-.585.58.58 0 0 1 .574-.584h1.856zm-12.457.584a.563.563 0 0 1-.538.585H.574A.58.58 0 0 1 0 8.146a.58.58 0 0 1 .574-.584h1.857c.307.01.548.272.538.584zM4.446 4.53a.55.55 0 0 1-.786.026L2.346 3.219a.592.592 0 0 1 0-.827.567.567 0 0 1 .813 0L4.47 3.728a.573.573 0 0 1-.025.803zm3.555-1.507a.561.561 0 0 1-.574-.548V.585A.58.58 0 0 1 8 0a.58.58 0 0 1 .574.584v1.891A.561.561 0 0 1 8 3.023zm3.558 1.5a.574.574 0 0 1-.022-.8l1.313-1.338a.567.567 0 0 1 .801.01c.22.225.225.587.01.817l-1.313 1.337a.551.551 0 0 1-.789-.026z\"/></svg>"

/***/ }),

/***/ "./icons/likes.svg":
/*!*************************!*\
  !*** ./icons/likes.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"1 1 14 14\"><path d=\"M5.304 3.323c-.85 0-1.509.31-1.973.927-.353.476-.529 1.124-.529 1.945 0 .37.13.8.387 1.289.258.49.574.96.948 1.41.374.449.888.998 1.541 1.646A25.854 25.854 0 0 0 8 12.558a26.017 26.017 0 0 0 3.864-3.665c.374-.45.69-.92.948-1.409.258-.49.387-.92.387-1.29 0-.952-.267-1.702-.8-2.25-.395-.413-.963-.62-1.702-.62a2.5 2.5 0 0 0-1.438.442c-.434.296-.652.664-.652 1.105 0 .194-.06.344-.18.45A.62.62 0 0 1 8 5.48a.619.619 0 0 1-.425-.16c-.12-.105-.18-.268-.18-.489 0-.22-.059-.43-.175-.628a1.466 1.466 0 0 0-.419-.47c-.533-.273-1.032-.41-1.496-.41M8 14c-.197 0-.33-.036-.399-.106-.73-.503-1.617-1.235-2.657-2.196C3.37 10.233 2.325 8.871 1.81 7.61a4.187 4.187 0 0 1-.31-1.6c0-.564.107-1.122.322-1.673.215-.552.503-.991.864-1.317A3.742 3.742 0 0 1 5.304 2c.55 0 1.062.097 1.535.291.473.194.86.472 1.16.834a2.93 2.93 0 0 1 1.162-.834A3.89 3.89 0 0 1 10.65 2c.52 0 1.003.086 1.45.259.447.17.852.423 1.213.753.36.33.649.772.864 1.324.215.55.322 1.095.322 1.633s-.077 1.024-.232 1.456a5.965 5.965 0 0 1-.638 1.263c-.271.41-.57.82-.897 1.23-.326.41-.68.8-1.057 1.17-1.313 1.287-2.405 2.222-3.276 2.806-.07.07-.202.106-.4.106\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/link.svg":
/*!************************!*\
  !*** ./icons/link.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M14.07 2.227c1.24 1.304 1.24 3.425 0 4.728l-2.283 2.4a3.108 3.108 0 0 1-2.246.978 3.115 3.115 0 0 1-2.253-.978l-.238-.25a3.366 3.366 0 0 1-.324-.399.714.714 0 0 1 .145-.965.637.637 0 0 1 .918.152c.058.082.122.161.192.235l.237.25a1.817 1.817 0 0 0 1.621.547 1.821 1.821 0 0 0 1.017-.548l2.284-2.4a2.034 2.034 0 0 0 0-2.772l-.238-.25a1.804 1.804 0 0 0-2.638 0l-1.428 1.5a.635.635 0 0 1-.93 0 .716.716 0 0 1 0-.978l1.428-1.5a3.076 3.076 0 0 1 4.498 0l.238.25zm-6.906 9.318a.635.635 0 0 1 .93 0 .716.716 0 0 1 0 .978l-1.427 1.5A3.092 3.092 0 0 1 4.418 15a3.093 3.093 0 0 1-2.249-.978l-.238-.25c-.6-.63-.93-1.47-.931-2.363 0-.893.33-1.732.931-2.364l2.284-2.4a3.108 3.108 0 0 1 1.734-.935 3.092 3.092 0 0 1 2.763.936l.238.25c.118.124.227.258.324.398a.715.715 0 0 1-.145.965.637.637 0 0 1-.918-.152 1.943 1.943 0 0 0-.191-.234l-.238-.25a1.818 1.818 0 0 0-1.62-.548 1.823 1.823 0 0 0-1.017.548l-2.284 2.4a2 2 0 0 0-.546 1.386c0 .524.194 1.016.547 1.386l.237.25c.728.764 1.91.764 2.638 0l1.427-1.5z\"/></svg>"

/***/ }),

/***/ "./icons/linkout.svg":
/*!***************************!*\
  !*** ./icons/linkout.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M12.923 2H11V1h4v4h-1V3.077L8.538 8.538 7.462 7.462 12.923 2zM1 2h7v2H3v9h9V8h2v7H1V2z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/location.svg":
/*!****************************!*\
  !*** ./icons/location.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"1 1 14 14\"><path d=\"M8.005 2.996a2.97 2.97 0 0 0-2.186.916 3 3 0 0 0-.91 2.192c0 .542.305 1.412.916 2.612a45.823 45.823 0 0 0 2.18 3.785 34.961 34.961 0 0 0 2.141-3.676c.637-1.264.955-2.171.955-2.721a3 3 0 0 0-.91-2.192 2.97 2.97 0 0 0-2.186-.916m.348 11.427a.827.827 0 0 1-.316.077c-.312 0-.525-.099-.638-.297a4.052 4.052 0 0 0-.24-.367 38.25 38.25 0 0 1-.534-.806c-.206-.318-.53-.839-.968-1.561a30.396 30.396 0 0 1-1.096-1.941 16.665 16.665 0 0 1-.8-1.838C3.52 7.037 3.4 6.508 3.4 6.104c0-.825.208-1.59.625-2.296a4.693 4.693 0 0 1 1.69-1.683 4.44 4.44 0 0 1 2.29-.625c.817 0 1.58.208 2.29.625.71.417 1.273.978 1.69 1.683.417.706.625 1.471.625 2.296 0 .404-.12.933-.361 1.586a19.672 19.672 0 0 1-1.662 3.395 67.288 67.288 0 0 1-1.505 2.403c-.305.451-.473.707-.503.767-.03.06-.105.116-.226.168\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/media-published.svg":
/*!***********************************!*\
  !*** ./icons/media-published.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M14.61 9.759c.096 0 .189.037.256.103l1.028.99a.34.34 0 010 .494l-4.728 4.55a.369.369 0 01-.514 0l-2.546-2.452a.34.34 0 010-.494l1.03-.99a.368.368 0 01.513 0l1.26 1.213 3.444-3.311a.368.368 0 01.257-.103zM12.45 2a1.3 1.3 0 011.3 1.3v5.704h-1.734L9.908 7.057a.4.4 0 00-.554.011l-3.666 3.67-1.449-1.464a.4.4 0 00-.565-.003L1.75 11.174v3.059h5.51v1.747H1.3a1.3 1.3 0 01-1.3-1.3V3.3A1.3 1.3 0 011.3 2h11.15zM3.063 4.403a1.53 1.53 0 101.53 1.529 1.53 1.53 0 00-1.53-1.53z\"/></svg>"

/***/ }),

/***/ "./icons/mobile.svg":
/*!**************************!*\
  !*** ./icons/mobile.svg ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 320 512\"><path d=\"M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z\"/></svg>"

/***/ }),

/***/ "./icons/more.svg":
/*!************************!*\
  !*** ./icons/more.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path transform=\"rotate(90 8 8)\" fill-rule=\"evenodd\" d=\"M8 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4z\"/></svg>"

/***/ }),

/***/ "./icons/multiple-users.svg":
/*!**********************************!*\
  !*** ./icons/multiple-users.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M11 14l-.046-3C10.77 9.996 10.037 9.13 9 8.59A5.427 5.427 0 0 1 11.5 8c2.267 0 4.142 1.304 4.454 3L16 14h-5zM4.5 8c2.267 0 4.142 1.304 4.454 3L9 14H0l.046-3C.358 9.304 2.233 8 4.5 8zm7-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-7 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z\"/></svg>"

/***/ }),

/***/ "./icons/new-feature-lg.svg":
/*!**********************************!*\
  !*** ./icons/new-feature-lg.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"0 0 20 18\"><path d=\"M19.167 9l-2.034-2.317.284-3.066-3.009-.684-1.575-2.65L10 1.5 7.167.283l-1.575 2.65-3.009.675.284 3.067L.833 9l2.034 2.317-.284 3.075 3.009.683 1.575 2.65L10 16.5l2.833 1.217 1.575-2.65 3.009-.684-.284-3.066L19.167 9zm-8.334 4.167H9.167V11.5h1.666v1.667zm0-3.334H9.167v-5h1.666v5z\"/></svg>"

/***/ }),

/***/ "./icons/new.svg":
/*!***********************!*\
  !*** ./icons/new.svg ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M9 7h5v2H9v5H7V9H2V7h5V2h2v5z\"/></svg>"

/***/ }),

/***/ "./icons/notifications-lg.svg":
/*!************************************!*\
  !*** ./icons/notifications-lg.svg ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0z\"/><path d=\"M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 16a1.264 1.264 0 0 0 1.15-.75c.063-.148.094-.308.094-.48h-2.5A1.25 1.25 0 0 0 12 18zm3.75-6.77c0-1.888-1.025-3.47-2.813-3.888v-.419A.93.93 0 0 0 12 6a.93.93 0 0 0-.938.923v.419C9.27 7.76 8.25 9.335 8.25 11.23v3.077L7 15.538v.616h10v-.616l-1.25-1.23V11.23z\"/></svg>"

/***/ }),

/***/ "./icons/notifications.svg":
/*!*********************************!*\
  !*** ./icons/notifications.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8 0c4.416 0 8 3.584 8 8s-3.584 8-8 8-8-3.584-8-8 3.584-8 8-8zm0 12.8a1.011 1.011 0 0 0 .92-.6.975.975 0 0 0 .075-.385h-2A1 1 0 0 0 8 12.8zm3-5.415c0-1.512-.82-2.777-2.25-3.112v-.335A.743.743 0 0 0 8 3.2c-.415 0-.75.33-.75.738v.335C5.815 4.608 5 5.868 5 7.385v2.461l-1 .985v.492h8v-.492l-1-.985V7.385z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/pin-circle.svg":
/*!******************************!*\
  !*** ./icons/pin-circle.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 22 22\" class=\"cu-icon\"><path d=\"M11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11zm1.993-16.267l1.483-.742V4.25H7.525v.741l1.483.742a.869.869 0 01.255.614v2.478a.865.865 0 01-.475.77c-1.263.64-1.263 1.673-1.263 2.475h2.703v4.905l.773.775.772-.775V12.07h2.703c0-.79 0-1.833-1.205-2.455-.278-.145-.533-.474-.533-.79V6.347a.87.87 0 01.255-.614z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/pin.svg":
/*!***********************!*\
  !*** ./icons/pin.svg ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 9 16\"><path d=\"M6.48 1.758l1.758-.88V0H0v.879l1.758.879c.193.193.302.454.302.727v2.938c0 .384-.22.738-.563.911C0 7.094 0 8.318 0 9.268h3.204v5.814l.915.918.916-.918V9.268h3.203c0-.935 0-2.172-1.428-2.91-.33-.17-.631-.562-.631-.935V2.485c0-.273.108-.534.301-.727\"/></svg>"

/***/ }),

/***/ "./icons/pinterest-export.svg":
/*!************************************!*\
  !*** ./icons/pinterest-export.svg ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 .371h15.629V16H0z\"/><path d=\"M13.676 9.117c.716 0 1.302.586 1.302 1.303v3.907c0 .716-.586 1.302-1.302 1.302H1.954A1.306 1.306 0 01.65 14.327V10.42c0-.717.586-1.303 1.303-1.303.716 0 1.302.586 1.302 1.303v2.604h9.117V10.42c0-.717.586-1.303 1.303-1.303zm-7.932-3.36a1.299 1.299 0 01-1.843 0 1.297 1.297 0 01-.007-1.837L7.808 0l3.92 3.914c.508.508.515 1.335.007 1.843a1.299 1.299 0 01-1.843 0l-.781-.775v4.024a1.302 1.302 0 11-2.605 0V4.988l-.762.769z\" fill=\"#868B8F\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/pinterest-more.svg":
/*!**********************************!*\
  !*** ./icons/pinterest-more.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h15.629v15.629H0z\"/><path d=\"M7.815 5.861A1.951 1.951 0 005.86 7.815c0 1.08.873 1.953 1.954 1.953a1.951 1.951 0 001.953-1.953A1.951 1.951 0 007.815 5.86m-5.861 0c1.08 0 1.953.873 1.953 1.954a1.951 1.951 0 01-1.953 1.953A1.951 1.951 0 010 7.815C0 6.734.873 5.86 1.954 5.86zm11.722 0c1.08 0 1.953.873 1.953 1.954a1.951 1.951 0 01-1.953 1.953 1.951 1.951 0 01-1.954-1.953c0-1.081.873-1.954 1.954-1.954z\" fill=\"#868B8F\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/pinterest.svg":
/*!*****************************!*\
  !*** ./icons/pinterest.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M5.70439 16c.7406-1.20555.82301-1.91279 1.35961-4.038.369.702 1.323 1.08 2.079 1.08 3.186 0 4.617-3.105 4.617-5.904 0-2.979-2.574-4.923-5.4-4.923-3.078 0-6.12 2.052-6.12 5.373C2.24 9.7 3.428 10.9 4.148 10.9c.297 0 .468-.828.468-1.062 0-.279-.711-.873-.711-2.034 0-2.412 1.836-4.122 4.212-4.122 2.043 0 3.555 1.161 3.555 3.294 0 1.593-.639 4.581-2.709 4.581-.747 0-1.386-.54-1.386-1.314 0-1.134.792-2.232.792-3.402 0-1.986-2.817-1.626-2.817.774 0 .504.063 1.062.288 1.521-.414 1.782-1.26 4.437-1.26 6.273 0 .19784.00986.39459.025.591H1c-.55228 0-1-.44772-1-1V1c0-.55228.44772-1 1-1h14c.55228 0 1 .44772 1 1v14c0 .55228-.44772 1-1 1H5.70439z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/product-bag.svg":
/*!*******************************!*\
  !*** ./icons/product-bag.svg ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M0,13.523 L0,13.412 L0.9,5.46 C0.957716756,5.30539871 1.05208275,5.16710964 1.175,5.057 C1.2857946,4.9450435 1.43554503,4.88019941 1.593,4.876 L4.181,4.876 L4.181,3.676 C4.181,2.676 4.549,1.815 5.286,1.089 C5.99972701,0.384970368 6.8573339,0.0213624129 7.85790873,-6.21724894e-15 L8.04617933,-6.21724894e-15 C9.0476661,0.0213624129 9.90527299,0.384970368 10.619,1.089 C11.355,1.815 11.724,2.677 11.724,3.677 L11.724,4.876 L14.311,4.876 C14.511,4.876 14.677,4.936 14.808,5.056 C14.9296286,5.15545068 15.0019139,5.30294184 15.006,5.46 L16,13.412 C16,14.117 15.76,14.709 15.282,15.188 C14.8508443,15.6277153 14.2682843,15.883294 13.6562361,15.905 L2.41487078,15.905 C1.75469001,15.8880022 1.19173309,15.6542992 0.726,15.203 C0.242,14.735 0,14.175 0,13.523 Z M13.412,14.517 C13.843,14.517 14.159,14.359 14.359,14.044 C14.4628523,13.8901695 14.5179148,13.7086025 14.5170221,13.523 L13.712,6.265 L11.724,6.265 L11.724,8.947 C11.730508,9.13315445 11.6593429,9.31363762 11.5275366,9.44525425 C11.3957303,9.57687089 11.2151449,9.64777608 11.029,9.641 C10.8431106,9.64719215 10.6629683,9.57606485 10.5314517,9.44454828 C10.3999351,9.3130317 10.3288079,9.13288942 10.335,8.947 L10.335,6.265 L5.57,6.265 L5.57,8.852 C5.57558389,9.03780616 5.50429463,9.21769072 5.37294518,9.34922943 C5.24159573,9.48076815 5.06181401,9.55231635 4.876,9.547 C4.69001504,9.55259737 4.50996821,9.48117333 4.37839744,9.34960256 C4.24682667,9.21803179 4.17540263,9.03798496 4.181,8.852 L4.181,6.17 L2.193,6.17 L1.388,13.523 C1.388,13.817 1.494,14.057 1.704,14.241 C1.914,14.425 2.177,14.517 2.494,14.517 L13.412,14.517 Z M5.57,3.677 L5.57,4.876 L10.335,4.876 L10.335,3.676 C10.335,3.035 10.101,2.493 9.633,2.052 C9.1829414,1.61717174 8.57871772,1.37871918 7.953,1.389 C7.3,1.389 6.74,1.609 6.273,2.052 C5.81572421,2.46725173 5.55955042,3.05940309 5.57,3.677 Z\"/></svg>"

/***/ }),

/***/ "./icons/product.svg":
/*!***************************!*\
  !*** ./icons/product.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8 0c2.032 0 3.716 1.503 4.145 3.5H13a2 2 0 012 2V14a2 2 0 01-2 2H3a2 2 0 01-2-2V5.5a2 2 0 012-2h.855C4.284 1.503 5.968 0 8 0zM4.75 5a.75.75 0 100 1.5.75.75 0 000-1.5zm6.5 0a.75.75 0 100 1.5.75.75 0 000-1.5zM8 1.5c-1.19 0-2.215.83-2.594 2h5.188c-.38-1.17-1.404-2-2.594-2z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/reach.svg":
/*!*************************!*\
  !*** ./icons/reach.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M15.517 6.927a1.649 1.649 0 0 0-2.692.542h-3.72l1.917-3.19a1.648 1.648 0 1 0-.15-3.23 1.65 1.65 0 0 0-.922 2.587L8 6.88 6.053 3.639a1.65 1.65 0 1 0-2.925-1.387 1.652 1.652 0 0 0 1.854 2.03L6.896 7.47H3.18a1.65 1.65 0 1 0-.001 1.25h3.717l-1.914 3.185a1.652 1.652 0 0 0-1.854 2.031 1.65 1.65 0 1 0 2.925-1.387L8 9.307l1.95 3.244a1.65 1.65 0 0 0 .922 2.586 1.648 1.648 0 1 0 .15-3.23L9.106 8.719h3.719a1.649 1.649 0 1 0 2.692-1.792\"/></svg>"

/***/ }),

/***/ "./icons/requestrights-approved.svg":
/*!******************************************!*\
  !*** ./icons/requestrights-approved.svg ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"-1 0 1126 1008\" class=\"cu-icon\"><path d=\"M975 155q77 66 115 151 74 162-3 319-33 69-82 119.5t-109.5 95-118 74T667 965q-90 37-123 43h-10q-9 0-18-9-14-7-14-29v-28q0-3 1-10 7-56-1.5-64.5T427 853q-100-7-184.5-45.5T98 703Q-7 583 0 413q5-90 55-170t129-135 186-83.5T589.5 4t213 46.5T975 155zM577 928q196-72 324-178 189-156 153-343-22-117-121-201Q797 85 586 70h-37q-126 0-233 45.5T143 242Q47 360 76 510q18 91 79 156 49 56 123 89.5T436 792q91 0 122 38 30 30 19 98zm131-595q10-11 23.5-10t23.5 15q10 10 10 23t-10 23L539 600q-9 9-23 9t-24-9L370 478q-10-10-10-23t10.5-23.5T394 421t23 10l99 99z\"/></svg>"

/***/ }),

/***/ "./icons/requestrights-pending.svg":
/*!*****************************************!*\
  !*** ./icons/requestrights-pending.svg ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-1 -5 1125 1008\"><path d=\"M300 445.5q0-27.5 19.5-46.5t39.5-19 32 5 21 14q19 19 19 46.5T412 492t-46 19-46.5-19-19.5-46.5zm197 0q0-27.5 19-46.5t46.5-19 46.5 19 19 41.5-9 37.5q-19 33-51.5 33T516 492t-19-46.5zm197 0q0-27.5 19-46.5t39.5-19 32.5 5 21 14q19 19 19 46.5T806 492t-46.5 19-46.5-19-19-46.5zM975 155q77 66 115 151 66 145 11 287-81 207-383 351-82 39-170 67-3 1-4 2h-10q-9 0-18-10-14-7-14-28v-28q0-3 1-10 7-56-1.5-64.5T427 858q-100-7-184.5-45.5T98 708Q-7 588 0 417q7-91 55-170t133-139Q363-17 591 5q111 7 211.5 45.5T975 155zM577 928q196-72 324-178 189-156 153-343-22-117-121-201Q797 85 586 70h-37q-182 0-319 94-74 49-115 116-63 104-39 230 18 91 79 156 49 56 123 89.5T436 792q91 0 122 38 30 30 19 98z\"/></svg>"

/***/ }),

/***/ "./icons/requestrights-rejected.svg":
/*!******************************************!*\
  !*** ./icons/requestrights-rejected.svg ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-1 0 1126 1008\"><path d=\"M975 155q77 66 115 151 74 162-3 319-33 69-82 119.5t-109.5 95-118 74T667 965q-90 37-123 43h-10q-9 0-18-9-14-7-14-29v-28q0-3 1-10 7-56-1.5-64.5T427 853q-100-7-184.5-45.5T98 703Q-7 583 0 413q5-90 55-170t129-135 186-83.5T589.5 4t213 46.5T975 155zM577 928q196-72 324-178 189-156 153-343-22-117-121-201Q797 85 586 70h-37q-126 0-233 45.5T143 242Q47 360 76 510q18 91 79 156 49 56 123 89.5T436 792q91 0 122 38 30 30 19 98zm140.5-646.5Q728 292 728 305t-11 23L609 436l108 108q11 10 11 23t-10 23-24 10-24-9L563 483 455 591q-10 9-24 9t-24-10-10-23 11-23l108-108-108-108q-11-10-11-23t10.5-23.5T431 271t24 10l108 113 107-113q11-10 24-10t23.5 10.5z\"/></svg>"

/***/ }),

/***/ "./icons/search.svg":
/*!**************************!*\
  !*** ./icons/search.svg ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 13 13\"><path fill-rule=\"evenodd\" d=\"M12.774 11.72L8.854 7.8c.604-.79.943-1.81.943-2.9C9.797 2.185 7.612 0 4.9 0 2.185 0 0 2.186 0 4.9 0 7.61 2.186 9.796 4.9 9.796c1.09 0 2.07-.34 2.9-.942l3.92 3.92c.15.15.338.225.526.225.19 0 .377-.075.528-.226.3-.302.3-.754 0-1.055zM4.9 8.29c-1.886 0-3.393-1.507-3.393-3.39 0-1.886 1.507-3.393 3.392-3.393 1.883 0 3.39 1.507 3.39 3.392 0 1.883-1.507 3.39-3.39 3.39z\"/></svg>"

/***/ }),

/***/ "./icons/settings.svg":
/*!****************************!*\
  !*** ./icons/settings.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path class=\"svg-fill-color-1\" d=\"M15.862 7.253s-.29-.109-1.13-.186c-1.028-.095-1.338-.48-1.68-.96h-.007a5.22 5.22 0 0 0-.138-.337l.004-.004c-.098-.58-.15-1.072.509-1.866.539-.649.667-.932.667-.932-.126-.32-.43-.625-.43-.625s-.305-.304-.625-.43c0 0-.283.128-.932.667-.794.66-1.286.607-1.867.51l-.004.003a5.274 5.274 0 0 0-.336-.138v-.007c-.48-.341-.865-.652-.96-1.68-.078-.84-.187-1.13-.187-1.13C8.43 0 8 0 8 0s-.43 0-.747.138c0 0-.109.29-.187 1.13-.095 1.028-.48 1.339-.96 1.68v.007a5.444 5.444 0 0 0-.336.138l-.004-.004c-.58.098-1.072.15-1.866-.509-.649-.539-.932-.667-.932-.667-.321.126-.625.43-.625.43s-.304.305-.43.625c0 0 .128.283.667.932.66.794.606 1.286.51 1.866l.003.004c-.05.11-.095.223-.138.337h-.007c-.341.48-.652.865-1.68.96-.84.077-1.13.187-1.13.187C0 7.57 0 8 0 8s0 .43.138.746c0 0 .29.11 1.13.187 1.028.095 1.338.48 1.68.96h.007c.043.114.088.227.138.337l-.004.004c.098.58.15 1.072-.509 1.866-.539.649-.667.932-.667.932.126.32.43.625.43.625s.304.304.625.43c0 0 .283-.128.932-.667.794-.66 1.286-.606 1.866-.51l.004-.003c.11.05.223.095.337.138v.007c.48.341.864.652.96 1.68.077.84.186 1.13.186 1.13C7.57 16 8 16 8 16s.43 0 .746-.138c0 0 .11-.29.187-1.13.095-1.028.48-1.338.96-1.68v-.007c.114-.043.226-.088.336-.138l.005.004c.58-.098 1.072-.15 1.866.509.649.539.932.668.932.668.32-.127.625-.431.625-.431s.304-.304.43-.625c0 0-.128-.283-.667-.932-.66-.794-.607-1.286-.51-1.866l-.003-.004c.05-.11.095-.223.138-.337h.007c.341-.48.652-.865 1.68-.96.84-.077 1.13-.187 1.13-.187C16 8.43 16 8 16 8s0-.43-.138-.747zM8 11.741A3.741 3.741 0 1 1 8 4.26a3.741 3.741 0 0 1 0 7.482z\"/></svg>"

/***/ }),

/***/ "./icons/smile.svg":
/*!*************************!*\
  !*** ./icons/smile.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8,0 C12.4182903,0 16,3.58170968 16,8 C16,12.4182903 12.4182903,16 8,16 C3.58170968,16 0,12.4182903 0,8 C0,3.58170968 3.58170968,0 8,0 Z M8,1.5483871 C4.43390323,1.5483871 1.5483871,4.43445161 1.5483871,8 C1.5483871,11.5660968 4.43445161,14.4516129 8,14.4516129 C11.5660968,14.4516129 14.4516129,11.5655484 14.4516129,8 C14.4516129,4.43390323 11.5655484,1.5483871 8,1.5483871 Z M3.7633871,10.265129 C3.15667742,9.44006452 4.40345161,8.52193548 5.01080645,9.34777419 C6.62816129,11.547129 9.37312903,11.5470323 10.9903871,9.34777419 C11.5972903,8.52264516 12.844871,9.43958065 12.2378065,10.265129 C9.9996129,13.3087097 5.99880645,13.3048387 3.7633871,10.265129 Z M5.33333333,4.66666667 C6.069713,4.66666667 6.66666667,5.26362033 6.66666667,6 C6.66666667,6.73637967 6.069713,7.33333333 5.33333333,7.33333333 C4.59695367,7.33333333 4,6.73637967 4,6 C4,5.26362033 4.59695367,4.66666667 5.33333333,4.66666667 Z M10.6666667,4.66666667 C11.4030463,4.66666667 12,5.26362033 12,6 C12,6.73637967 11.4030463,7.33333333 10.6666667,7.33333333 C9.930287,7.33333333 9.33333333,6.73637967 9.33333333,6 C9.33333333,5.26362033 9.930287,4.66666667 10.6666667,4.66666667 Z\"/></svg>"

/***/ }),

/***/ "./icons/sparkles.svg":
/*!****************************!*\
  !*** ./icons/sparkles.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M15.362 2.974a.25.25 0 000-.448L13.77 1.73 12.974.138a.25.25 0 00-.448 0L11.73 1.73l-1.592.796a.25.25 0 000 .448l1.592.796.796 1.592a.25.25 0 00.448 0l.796-1.592 1.592-.796zm0 10.5a.25.25 0 000-.448l-1.592-.796-.796-1.592a.25.25 0 00-.448 0l-.796 1.592-1.592.796a.25.25 0 000 .448l1.592.796.796 1.592a.25.25 0 00.448 0l.796-1.592 1.592-.796zm-3.638-5.027a.5.5 0 000-.894l-3.518-1.76-1.759-3.517a.5.5 0 00-.894 0L3.794 5.794.276 7.553a.5.5 0 000 .894l3.518 1.76 1.759 3.517a.5.5 0 00.894 0l1.759-3.518 3.518-1.759z\"/></svg>"

/***/ }),

/***/ "./icons/spinner.svg":
/*!***************************!*\
  !*** ./icons/spinner.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"10 10 80 80\"><circle cx=\"50\" cy=\"50\" fill=\"none\" r=\"30\" stroke=\"#a7ebe1\" stroke-width=\"8\"/><circle class=\"cu-spinner-spiral\" cx=\"50\" cy=\"50\" fill=\"none\" r=\"30\" stroke=\"#00c9b1\" stroke-width=\"8\" stroke-linecap=\"square\" transform=\"rotate(64.538 50 50)\"/></svg>"

/***/ }),

/***/ "./icons/sticker.svg":
/*!***************************!*\
  !*** ./icons/sticker.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M11.307 0A4.699 4.699 0 0 1 16 4.693v4.438a.403.403 0 0 1-.118.286l-.004.004-6.653 6.464a.404.404 0 0 1-.281.115l-.014-.001L4.693 16A4.699 4.699 0 0 1 0 11.307V4.693A4.699 4.699 0 0 1 4.693 0h6.614zM10.5 1.616H5.501a3.89 3.89 0 0 0-3.885 3.885V10.5a3.89 3.89 0 0 0 3.885 3.885l3.038-.001v-.963a4.73 4.73 0 0 1 .26-1.536c-.39.105-.794.158-1.203.156a4.77 4.77 0 0 1-3.485-1.523.543.543 0 0 1-.135-.51.511.511 0 0 1 .355-.374.48.48 0 0 1 .483.143c1.352 1.362 3.377 1.541 4.906.539a4.68 4.68 0 0 1 3.514-1.588h1.149V5.501A3.89 3.89 0 0 0 10.5 1.616zM5.172 4.768a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424zm5.656 0a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424z\"/></svg>"

/***/ }),

/***/ "./icons/sync-alt.svg":
/*!****************************!*\
  !*** ./icons/sync-alt.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M11.7 4.041a5.38 5.38 0 0 0-3.705-1.46 5.426 5.426 0 0 0-5.251 4.092.388.388 0 0 1-.376.295H.519a.387.387 0 0 1-.38-.458 8.002 8.002 0 0 1 13.387-4.294l1.152-1.152A.774.774 0 0 1 16 1.61v4.324a.774.774 0 0 1-.774.775H10.9a.774.774 0 0 1-.547-1.322L11.7 4.041zM.775 9.291H5.1c.69 0 1.035.833.547 1.321L4.3 11.959a5.38 5.38 0 0 0 3.706 1.46 5.426 5.426 0 0 0 5.251-4.092.388.388 0 0 1 .376-.295h1.849c.241 0 .425.22.38.458a8.002 8.002 0 0 1-13.387 4.294l-1.152 1.152A.774.774 0 0 1 0 14.39v-4.324c0-.428.347-.775.774-.775z\"/></svg>"

/***/ }),

/***/ "./icons/tag.svg":
/*!***********************!*\
  !*** ./icons/tag.svg ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><path d=\"M7.562 5.32a.947.947 0 0 0-.709-.305.989.989 0 0 0-.714.293.987.987 0 0 0-.293.714c0 .28.107.526.309.713L9.049 9.63a.914.914 0 0 0 .66.271.938.938 0 0 0 .671-.274.953.953 0 0 0 .29-.703.949.949 0 0 0-.309-.713L7.562 5.32zM5.666 7.248a.978.978 0 0 0-.709-.29.993.993 0 0 0-.714.294.983.983 0 0 0-.293.706c0 .269.094.507.278.706l2.91 2.909a.92.92 0 0 0 .668.27.924.924 0 0 0 .679-.29.977.977 0 0 0 .274-.701.979.979 0 0 0-.285-.706L5.666 7.248z\"/><path d=\"M13.948 2.381v4.893c0 .104-.028.321-.162.763a2.09 2.09 0 0 1-.484.852l-5.069 4.977a.317.317 0 0 1-.245.097.317.317 0 0 1-.244-.095L2.031 8.155a.407.407 0 0 1-.109-.289c0-.117.037-.21.117-.298l4.887-4.977c.06-.053.23-.175.64-.393a2.06 2.06 0 0 1 .97-.246h4.982a.43.43 0 0 1 .305.124c.085.08.125.177.125.305M15.443.938C14.96.315 14.311 0 13.518 0H8.535c-.322 0-.684.06-1.075.18-.813.235-1.47.604-1.95 1.095L.71 6.167A2.24 2.24 0 0 0 0 7.82c0 .64.24 1.197.713 1.66l5.618 5.707a2.304 2.304 0 0 0 1.702.728c.66 0 1.202-.215 1.613-.638l4.981-4.98c.348-.338.652-.809.9-1.395.247-.587.373-1.135.373-1.628V2.29c0-.5-.154-.956-.457-1.352\"/><path d=\"M11.611 2.993c-.329 0-.615.12-.85.354a1.163 1.163 0 0 0-.354.85c0 .33.12.615.354.85.235.235.521.354.85.354.33 0 .616-.119.851-.354.234-.235.353-.52.353-.85 0-.329-.119-.616-.353-.85a1.165 1.165 0 0 0-.85-.354\"/></g></svg>"

/***/ }),

/***/ "./icons/text.svg":
/*!************************!*\
  !*** ./icons/text.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 -3 16 16\"><path d=\"M2.004 9.884l.708-2.397h3.086l.694 2.397h2.15L5.52 0H3.135L0 9.884h2.004zM5.41 5.887H3.107l1.11-3.867h.097L5.41 5.887zM12.095 10c1.09 0 1.7-.529 1.977-1.079h.09v.963H16V4.736c0-1.977-1.366-2.68-3.052-2.68-2.101 0-2.94 1.123-3.01 2.376h1.838c.084-.464.423-.797 1.138-.797.707 0 1.158.348 1.158 1.036v.666h-1.776c-1.706 0-2.628.92-2.628 2.31 0 1.462.992 2.353 2.427 2.353zm.652-1.52c-.596 0-1.144-.326-1.144-.985 0-.55.374-.942 1.144-.942h1.325v.775c0 .673-.603 1.151-1.325 1.151z\"/></svg>"

/***/ }),

/***/ "./icons/trending-down.svg":
/*!*********************************!*\
  !*** ./icons/trending-down.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M14.52 6.788l.79.792a.852.852 0 010 1.208l-6.923 6.927a.852.852 0 01-1.208 0L.25 8.788a.852.852 0 010-1.208l.791-.792a.856.856 0 011.223.015l4.09 4.294V.855c0-.474.382-.855.856-.855h1.14c.474 0 .855.381.855.855v10.242l4.091-4.294a.85.85 0 011.222-.015z\"/></svg>"

/***/ }),

/***/ "./icons/trending-up.svg":
/*!*******************************!*\
  !*** ./icons/trending-up.svg ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M1.042 9.178l-.79-.791a.852.852 0 010-1.208L7.174.25a.852.852 0 011.208 0l6.924 6.924a.852.852 0 010 1.208l-.791.791a.856.856 0 01-1.222-.014L9.206 4.87v10.24a.853.853 0 01-.855.856h-1.14a.853.853 0 01-.856-.855V4.869l-4.09 4.294a.85.85 0 01-1.223.015z\"/></svg>"

/***/ }),

/***/ "./icons/twitter-comment.svg":
/*!***********************************!*\
  !*** ./icons/twitter-comment.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\"/><path d=\"M13 1H8.8A7.72 7.72 0 001 8.8a7.4 7.4 0 007.47 7.37V20a.77.77 0 00.12.4.73.73 0 00.63.35.77.77 0 00.4-.12c.26-.17 6.47-4.14 8.09-5.5a8.44 8.44 0 003-6.32A7.72 7.72 0 0013 1zm3.79 13c-1.14 1-4.86 3.41-6.77 4.65v-3.21a.75.75 0 00-.75-.75h-.4c-3.66 0-6.32-2.48-6.32-5.89A6.24 6.24 0 018.8 2.5H13a6.24 6.24 0 016.3 6.3 6.92 6.92 0 01-2.56 5.2h.05z\" fill=\"#8899A6\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/twitter-like.svg":
/*!********************************!*\
  !*** ./icons/twitter-like.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\"/><path d=\"M11 20.41c-2.59 0-10-6.78-10-13.16A5.74 5.74 0 016.35 1.5 5.86 5.86 0 0111 4.23a5.83 5.83 0 014.64-2.73 5.74 5.74 0 015.41 5.76c0 6.37-7.46 13.11-10 13.15H11zM6.35 3a4.2 4.2 0 00-3.9 4.26c0 5.74 7 11.59 8.55 11.65 1.55.06 8.55-5.91 8.55-11.65A4.2 4.2 0 0015.65 3c-2.53 0-3.94 2.94-3.95 3a.79.79 0 01-1.39 0S8.88 3 6.36 3h-.01z\" fill=\"#8899A6\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/twitter-retweet.svg":
/*!***********************************!*\
  !*** ./icons/twitter-retweet.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\"/><path d=\"M21.785 14.161a.695.695 0 00-.973 0l-2.037 2.02V6.897c0-1.876-1.54-3.397-3.441-3.397H9.966a.684.684 0 00-.688.68c0 .375.308.679.688.679h5.368a2.08 2.08 0 011.472.59c.39.383.611.904.61 1.448v9.284l-2.036-2.01a.695.695 0 00-.973 0 .673.673 0 000 .96l3.212 3.17c.128.129.303.2.486.199a.684.684 0 00.486-.2l3.212-3.17a.675.675 0 00-.018-.969zm-9.782 2.971H6.635c-1.14 0-2.064-.912-2.064-2.038V5.82l2.037 2.01a.695.695 0 00.972 0 .673.673 0 000-.96L4.37 3.7a.695.695 0 00-.973 0L.185 6.87a.673.673 0 00.017.944.695.695 0 00.955.017L3.194 5.82v9.275c0 1.876 1.54 3.397 3.441 3.397h5.368c.38 0 .688-.304.688-.68a.684.684 0 00-.688-.679z\" fill=\"#8899A6\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/twitter-share.svg":
/*!*********************************!*\
  !*** ./icons/twitter-share.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\"/><path d=\"M20.25 12.15a.75.75 0 01.75.75v5.65a2.29 2.29 0 01-2.29 2.29H3.29A2.29 2.29 0 011 18.55V12.9a.76.76 0 01.75-.75.76.76 0 01.75.75v5.65c0 .436.354.79.79.79h15.42a.79.79 0 00.79-.79V12.9a.75.75 0 01.75-.75zM10.47 1.37a.75.75 0 011.06 0l5 5a.75.75 0 01-1.06 1.06l-3.72-3.72V13.9a.75.75 0 11-1.5 0V3.71L6.53 7.43a.75.75 0 01-1.06-1.06z\" fill=\"#8899A6\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/twitter-square.svg":
/*!**********************************!*\
  !*** ./icons/twitter-square.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M14.286 0H1.714C.768 0 0 .768 0 1.714v12.572C0 15.232.768 16 1.714 16h12.572c.946 0 1.714-.768 1.714-1.714V1.714C16 .768 15.232 0 14.286 0zm-1.747 5.671c.007.1.007.204.007.304 0 3.096-2.357 6.664-6.664 6.664a6.634 6.634 0 01-3.596-1.05c.189.022.371.029.564.029a4.696 4.696 0 002.907-1 2.345 2.345 0 01-2.19-1.625c.362.053.687.053 1.058-.043a2.343 2.343 0 01-1.875-2.3v-.029c.31.175.675.283 1.057.297a2.337 2.337 0 01-1.043-1.95c0-.436.115-.836.318-1.182a6.65 6.65 0 004.829 2.45c-.332-1.59.857-2.879 2.285-2.879.675 0 1.283.282 1.711.74a4.59 4.59 0 001.486-.565 2.34 2.34 0 01-1.029 1.29c.472-.05.929-.183 1.35-.365a4.93 4.93 0 01-1.175 1.214z\"/></svg>"

/***/ }),

/***/ "./icons/twitter.svg":
/*!***************************!*\
  !*** ./icons/twitter.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon cu-icon-stroke\" viewBox=\"0 0 16 14\"><path d=\"M5.032 13.473c6.037 0 9.34-5.002 9.34-9.34 0-.142 0-.284-.01-.425A6.679 6.679 0 0 0 16 2.01a6.55 6.55 0 0 1-1.885.517A3.294 3.294 0 0 0 15.558.71a6.579 6.579 0 0 1-2.085.797A3.286 3.286 0 0 0 7.88 4.5a9.32 9.32 0 0 1-6.765-3.43A3.285 3.285 0 0 0 2.13 5.453a3.258 3.258 0 0 1-1.49-.41v.04a3.284 3.284 0 0 0 2.634 3.219c-.484.132-.99.15-1.483.056a3.286 3.286 0 0 0 3.067 2.28A6.587 6.587 0 0 1 0 11.998a9.293 9.293 0 0 0 5.032 1.472\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/undo.svg":
/*!************************!*\
  !*** ./icons/undo.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" width=\"16\" height=\"16\"><path d=\"M4.857 8.081L6.798 6 8 7.143 4 11 0 7.143 1.202 6 3 7.928a6.5 6.5 0 1 1 4.348 6.207l.615-1.752A4.643 4.643 0 1 0 4.857 8v.081z\"/></svg>"

/***/ }),

/***/ "./icons/upload.svg":
/*!**************************!*\
  !*** ./icons/upload.svg ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M9.5,0 C6.812,0 4.41,1.673 3.448,4.14 C1.441,4.613 0,6.383 0,8.5 C0,10.981 2.019,13 4.5,13 C5.052,13 5.5,12.553 5.5,12 C5.5,11.447 5.052,11 4.5,11 C3.122,11 2,9.879 2,8.5 C2,7.201 2.984,6.137 4.289,6.026 C4.706,5.991 5.057,5.7 5.168,5.297 C5.707,3.356 7.488,2 9.5,2 C11.981,2 14,4.019 14,6.5 C14,8.423 12.779,10.134 10.962,10.757 C10.439,10.937 10.161,11.505 10.34,12.027 C10.52,12.55 11.088,12.826 11.61,12.649 C14.236,11.749 16,9.277 16,6.5 C16,2.916 13.084,0 9.5,0\"/><path d=\"M10.5352,7.293 L8.7072,5.464 C8.5192,5.277 8.2652,5.171 8.0002,5.171 C7.7352,5.171 7.4802,5.277 7.2932,5.464 L5.4642,7.293 C5.0742,7.684 5.0742,8.316 5.4642,8.707 C5.8552,9.098 6.4882,9.098 6.8782,8.707 L7.0002,8.585 L7.0002,15 C7.0002,15.553 7.4482,16 8.0002,16 C8.5522,16 9.0002,15.553 9.0002,15 L9.0002,8.586 L9.1212,8.707 C9.3162,8.902 9.5722,9 9.8282,9 C10.0842,9 10.3402,8.902 10.5352,8.707 C10.9262,8.317 10.9262,7.684 10.5352,7.293\"/></g></svg>"

/***/ }),

/***/ "./icons/user.svg":
/*!************************!*\
  !*** ./icons/user.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 16\" class=\"cu-icon\"><path fill-rule=\"evenodd\" d=\"M8 9c3.023 0 5.523 1.087 5.94 2.5L14 14H2l.06-2.5C2.478 10.087 4.978 9 8 9zm0-1a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\"/></svg>"

/***/ }),

/***/ "./icons/verified.svg":
/*!****************************!*\
  !*** ./icons/verified.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M15.30347,8.35273037 C15.3174743,7.30258744 14.7390263,6.33402345 13.8078179,5.84838254 C13.9199868,5.536004 13.9764951,5.20637197 13.9747744,4.8744695 C13.9915717,4.15302647 13.7209898,3.45447793 13.2225918,2.93259519 C12.7241938,2.41071244 12.0388349,2.10827589 11.3173831,2.0918608 C11.0008479,2.09181528 10.6870796,2.1507943 10.3921657,2.26577384 C9.97843262,1.3124655 9.03833917,0.695652174 7.99912222,0.695652174 C6.95990527,0.695652174 6.01981182,1.3124655 5.60607874,2.26577384 C5.31116485,2.1507943 4.99739649,2.09181528 4.68086135,2.0918608 C3.95940953,2.10827589 3.27405068,2.41071244 2.77565265,2.93259519 C2.27725463,3.45447793 2.00667272,4.15302647 2.02347005,4.8744695 C2.02174932,5.20637197 2.07825767,5.536004 2.19042657,5.84838254 C1.29605227,6.3323566 0.727014462,7.25591703 0.696907182,8.27239616 C0.666799902,9.28887529 1.18017791,10.244496 2.04433961,10.7805565 C2.03741705,10.898716 2.03741705,11.0171795 2.04433961,11.1353391 C2.02754229,11.8567821 2.29812419,12.5553306 2.79652222,13.0772134 C3.29492024,13.5990961 3.98027909,13.9015327 4.70173092,13.9179478 C5.01826606,13.9179933 5.33203442,13.8590143 5.62694831,13.7440347 C6.04068139,14.6973431 6.98077484,15.3141564 8.01999179,15.3141564 C9.05920874,15.3141564 9.99930219,14.6973431 10.4130353,13.7440347 C10.7079492,13.8590143 11.0217175,13.9179933 11.3382527,13.9179478 C12.0597045,13.9015327 12.7450633,13.5990961 13.2434614,13.0772134 C13.7418594,12.5553306 14.0124413,11.8567821 13.995644,11.1353391 C14.0027592,11.0148643 14.0027592,10.8940747 13.995644,10.7735999 C14.8279742,10.253718 15.3249157,9.33384752 15.30347,8.35273037 Z M10.7052092,6.03620863 L7.68607874,10.5579478 C7.589239,10.701218 7.42770274,10.787197 7.2547744,10.787513 C7.14797127,10.790041 7.04315779,10.7583532 6.95564396,10.6970782 L6.8721657,10.6344695 L5.20260048,8.95099124 C5.08372326,8.74190815 5.12317818,8.47865265 5.29812736,8.31360625 C5.47307654,8.14855985 5.73818217,8.12449409 5.93999179,8.25533906 L7.17129613,9.47968689 L9.83564396,5.48664341 C9.99700716,5.2465196 10.3224767,5.18267152 10.5626005,5.34403471 C10.8027243,5.50539791 10.8665724,5.83086743 10.7052092,6.07099124 L10.7052092,6.03620863 Z\"/></svg>"

/***/ }),

/***/ "./icons/zoom.svg":
/*!************************!*\
  !*** ./icons/zoom.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.003 0a7 7 0 015.769 10.965l2.952 2.986c.49.492.264 1.026-.227 1.518-.49.492-1 .767-1.49.275l-3.003-3.004a6.975 6.975 0 01-4.001 1.254A7 7 0 010 6.997 7 7 0 017.003 0zm.019 2.513A4.5 4.5 0 002.52 7.01a4.5 4.5 0 004.502 4.498 4.5 4.5 0 004.501-4.498 4.5 4.5 0 00-4.501-4.498z\"/><path d=\"M7.5 4a.5.5 0 01.5.5V6h1.5a.5.5 0 01.492.41L10 6.5v1a.5.5 0 01-.5.5H8v1.5a.5.5 0 01-.41.492L7.5 10h-1a.5.5 0 01-.5-.5V8H4.5a.5.5 0 01-.492-.41L4 7.5v-1a.5.5 0 01.5-.5H6V4.5a.5.5 0 01.41-.492L6.5 4z\"/></svg>"

/***/ }),

/***/ "./node_modules/classnames/index.js":
/*!******************************************!*\
  !*** ./node_modules/classnames/index.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "./src/common/agnostic-list-manager.ts":
/*!*********************************************!*\
  !*** ./src/common/agnostic-list-manager.ts ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
Object.defineProperty(exports, "__esModule", { value: true });
var typeaheadCancelKeyCodes = [13, 37, 38, 39, 40];
var AgnosticListManager = /** @class */ (function () {
    function AgnosticListManager($timeout) {
        var _this = this;
        this.$timeout = $timeout;
        this.items = [];
        this.itemsByValue = {};
        this.typeaheadValue = '';
        this.typeaheadTimeout = null;
        this.setItems = function (items) {
            _this.items = items;
            _this.itemsByValue = _this.createItemsByValue(items);
        };
    }
    AgnosticListManager.prototype.createItemsByValue = function (items, parent, itemsByValueAcc) {
        var itemsByValue = itemsByValueAcc || {};
        for (var i = 0; i < items.length; i += 1) {
            var item = items[i];
            item.index = i;
            item.typeaheadValue = item.typeaheadValue === undefined ? item.label : item.typeaheadValue;
            itemsByValue[item.value] = item;
            if (parent) {
                item.parent = parent;
            }
            if (i < items.length - 1) {
                item.next = items[i + 1];
            }
            if (i > 0) {
                item.prev = items[i - 1];
            }
            if (item.children) {
                this.createItemsByValue(item.children, item, itemsByValue);
            }
        }
        return itemsByValue;
    };
    AgnosticListManager.prototype.nextItem = function (itemOrValue) {
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        return item ? item.next || item : this.items[0];
    };
    AgnosticListManager.prototype.prevItem = function (itemOrValue) {
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        return item ? item.prev || item : this.items[this.items.length - 1];
    };
    AgnosticListManager.prototype.parent = function (itemOrValue) {
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        return item.parent;
    };
    AgnosticListManager.prototype.children = function (itemOrValue) {
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        return item.children;
    };
    AgnosticListManager.prototype.siblings = function (itemOrValue) {
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        if (item && item.parent) {
            return item.parent.children;
        }
        return this.items;
    };
    AgnosticListManager.prototype.ancestors = function (itemOrValue) {
        var _a;
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        var ancestors = [];
        var currItem = item;
        while ((_a = currItem) === null || _a === void 0 ? void 0 : _a.parent) {
            ancestors.push(currItem.parent);
            currItem = currItem.parent;
        }
        return ancestors;
    };
    AgnosticListManager.prototype.registerTypeaheadListener = function (element, fn) {
        var _this = this;
        element.on('keydown', function (event) {
            // Currently only the AngularJS version of the select uses a Timeout
            if (!_this.$timeout) {
                return;
            }
            if (_this.typeaheadTimeout) {
                _this.$timeout.cancel(_this.typeaheadTimeout);
            }
            if (typeaheadCancelKeyCodes.indexOf(event.keyCode) !== -1) {
                return;
            }
            _this.typeaheadValue += String.fromCharCode(event.keyCode).toLowerCase();
            _this.typeaheadTimeout = _this.$timeout(function () {
                _this.typeaheadValue = '';
                _this.typeaheadTimeout = null;
            }, 1000);
            fn(_this.typeaheadValue);
        });
    };
    return AgnosticListManager;
}());
exports.AgnosticListManager = AgnosticListManager;


/***/ }),

/***/ "./src/common/date-utils/dateUtils.ts":
/*!********************************************!*\
  !*** ./src/common/date-utils/dateUtils.ts ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
function createDateLite() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var date = new ((_a = Date).bind.apply(_a, __spreadArrays([void 0], args)))();
    date.setHours(0, 0, 0, 0);
    return date;
}
exports.createDateLite = createDateLite;
exports.MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
/** Gets a date range object with the calculated start/end dates for the given alias. */
exports.getDateRangeFromAlias = function (alias) { return ({
    alias: alias,
    startDate: exports.ALIASES[alias].start(),
    endDate: exports.ALIASES[alias].end(),
}); };
exports.ALIASES = {
    today: {
        name: 'today',
        display: 'Today',
        start: function () { return exports.today(); },
        end: function () { return exports.today(); },
    },
    last24Hours: {
        name: 'last24Hours',
        display: 'Last 24 Hours',
        start: function () { return exports.today(); },
        end: function () { return exports.today(); },
    },
    last7Days: {
        name: 'last7Days',
        display: 'Last 7 Days',
        start: function () { return createDateLite(exports.todayYear(), exports.todayMonth(), exports.todayDate() - 6); },
        end: function () { return exports.today(); },
    },
    last30Days: {
        name: 'last30Days',
        display: 'Last 30 Days',
        start: function () { return createDateLite(exports.todayYear(), exports.todayMonth(), exports.todayDate() - 29); },
        end: function () { return exports.today(); },
    },
    last90Days: {
        name: 'last90Days',
        display: 'Last 90 Days',
        start: function () { return createDateLite(exports.todayYear(), exports.todayMonth(), exports.todayDate() - 89); },
        end: function () { return exports.today(); },
    },
    last3Months: {
        name: 'last3Months',
        display: 'Last 3 Months',
        start: function () { return createDateLite(exports.todayYear(), exports.todayMonth() - 3, exports.todayDate()); },
        end: function () { return exports.today(); },
    },
    last1Year: {
        name: 'last1Year',
        display: 'Last 1 Year',
        start: function () { return createDateLite(exports.todayYear() - 1, exports.todayMonth(), exports.todayDate()); },
        end: function () { return exports.today(); },
    },
    allTime: {
        name: 'allTime',
        display: 'All Time',
        start: function () { return createDateLite(0); },
        end: function () { return exports.today(); },
    },
    custom: {
        name: 'custom',
        display: 'Custom',
    },
};
exports.genesis = createDateLite(0);
exports.genesisYear = exports.genesis.getFullYear();
exports.maxDate = createDateLite('12/31/3000');
exports.today = function () { return createDateLite(); };
exports.todayYear = function () { return exports.today().getFullYear(); };
exports.todayMonth = function () { return exports.today().getMonth(); };
exports.todayDate = function () { return exports.today().getDate(); };
exports.getAbsoluteMonth = function (date) {
    return ((date.getFullYear() - exports.genesisYear) * 12) + date.getMonth();
};
/** Gets a MM/DD/YY string for the given Date object */
exports.dateToString = function (date) {
    var rawYear = date.getFullYear();
    var formattedYear = rawYear.toString().substr(2, 2);
    var rawMonth = date.getMonth() + 1;
    var formattedMonth = rawMonth < 10 ? "0" + rawMonth : rawMonth;
    var rawDay = date.getDate();
    var formattedDay = rawDay < 10 ? "0" + rawDay : rawDay;
    return formattedMonth + "/" + formattedDay + "/" + formattedYear;
};
exports.numDaysInMonth = function (month, year) { return new Date(year, month + 1, 0).getDate(); };
exports.isDateValid = function (date) { return +date === +date; };
exports.dateStringRegex = /([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4}|[0-9]{2})$/;
exports.isDateStringValid = function (str) {
    var match = str.match(exports.dateStringRegex);
    var date = createDateLite(str);
    if (!match || !exports.isDateValid(date)) {
        return false;
    }
    var monthNum = parseInt(match[1], 10);
    var yearNum = parseInt(match[3], 10);
    var numDays = exports.numDaysInMonth(monthNum - 1, yearNum);
    if (date.getDate() > numDays || monthNum - 1 !== date.getMonth()) {
        return false;
    }
    return true;
};
/** Checks if the given date falls between the a set of start and end dates */
exports.contains = function (date, start, end) { return +date >= +start && +date <= +end; };
exports.msPerDay = 1000 * 60 * 60 * 24;


/***/ }),

/***/ "./src/common/popover.ts":
/*!*******************************!*\
  !*** ./src/common/popover.ts ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.POPOVER_OFFSET = 12;
exports.POPOVER_NO_ARROW_OFFSET = 4;
exports.CUSTOM_POSITIONING_TARGET_SELECTOR = '[cu-popover-positioning-target]';
exports.DEFAULT_POSITIONING_STRATEGY = {
    align: ['left', 'right'],
    fixed: ['bottom', 'top'],
};
function invert(direction) {
    switch (direction) {
        case 'top': return 'bottom';
        case 'bottom': return 'top';
        case 'left': return 'right';
        case 'right': return 'left';
    }
}
exports.invert = invert;
function rotate(direction) {
    switch (direction) {
        case 'top': return 'left';
        case 'bottom': return 'right';
        case 'left': return 'bottom';
        case 'right': return 'top';
    }
}
exports.rotate = rotate;
function control(direction) {
    switch (direction) {
        case 'top':
        case 'bottom': return 'top';
        case 'left':
        case 'right': return 'left';
    }
}
exports.control = control;
function dimension(direction) {
    switch (direction) {
        case 'top':
        case 'bottom': return 'height';
        case 'left':
        case 'right': return 'width';
    }
}
exports.dimension = dimension;
function computeCushions(positionMetrics, fixedOffset) {
    var targetBox = positionMetrics.targetBox, contentDimensions = positionMetrics.contentDimensions, windowBox = positionMetrics.windowBox;
    // Fixed cushions represent the amount of free space remaining if the
    // popover content was to be opened in a certain direction.
    var fixedCushions = {
        bottom: windowBox.height - targetBox.bottom
            - contentDimensions.height - fixedOffset,
        left: targetBox.left - contentDimensions.width - fixedOffset,
        right: windowBox.width - targetBox.right
            - contentDimensions.width - fixedOffset,
        top: targetBox.top - contentDimensions.height - fixedOffset,
    };
    // Align cushions represent the amount of free space remaining if the
    // popover content was to have one of it's sides aligned with the corresponding
    // side of the target box. For example, the alignLeftCushion represents how much
    // free space would remain to the right if the left edge of the content was aligned
    // with the left edge of the target.
    var alignCushions = {
        bottom: fixedCushions.top + targetBox.height,
        left: fixedCushions.right + targetBox.width,
        right: fixedCushions.left + targetBox.width,
        top: fixedCushions.bottom + targetBox.height,
    };
    return {
        alignCushions: alignCushions,
        fixedCushions: fixedCushions,
    };
}
/**
 * Determine the final positioning strategy to be used for the popover, based on the available metrics.
 * @param positionMetrics Relevant metrics for positioning logic
 * @param positioningStrategies Positioning & alignment options to consider
 * @param fixedOffset How far the popover content must be offset from the popover target (default is arrow size)
 *
 * @returns Finalized positioning strategy to use for the popover content.
 */
function determinePositioningStrategies(positionMetrics, positioningStrategies, fixedOffset) {
    // Calculate how much free space we have remaining around the popover content if we open it in each direction
    var _a = computeCushions(positionMetrics, fixedOffset), fixedCushions = _a.fixedCushions, alignCushions = _a.alignCushions;
    // Determine which direction we'll use to pop the popover out
    var fixedDirection = (function () {
        var fixedDirectionStrategy = positioningStrategies.fixed;
        // Given an array of strategies to use...
        if (Array.isArray(fixedDirectionStrategy)) {
            // Pick the first one that "fits", e.g. more than 0 pixels of space available if used.
            var preferredFixedDirection = fixedDirectionStrategy
                .filter(function (_) { return fixedCushions[_] >= 0; })[0];
            // If we don't have one (if the window is undersized, e.g.), pick the roomiest direction.
            return preferredFixedDirection || fixedDirectionStrategy.sort(function (a, b) {
                return fixedCushions[b] - fixedCushions[a];
            })[0];
        }
        // If we were given a single direction strategy option, use that.
        return fixedDirectionStrategy;
    })();
    // Determine which side of the popover target we'll align the popover content to.
    var alignDirection = (function () {
        var alignStrategy = positioningStrategies.align;
        // Given an array of strategies to use...
        if (Array.isArray(alignStrategy)) {
            // Pick the first one that "fits", e.g. more than 0 pixels of space available if used.
            var validAlignDirections = alignStrategy
                .filter(function (_) { return alignCushions[_] >= 0; });
            // If none is available, default to screen-center;
            return validAlignDirections.length > 0 ? validAlignDirections[0] : 'screen-center';
        }
        // If we were given a single align strategy option, use that.
        return alignStrategy;
    })();
    return {
        align: alignDirection,
        fixed: fixedDirection,
    };
}
exports.determinePositioningStrategies = determinePositioningStrategies;
function calculatePositioning(metrics, options) {
    var windowBox = metrics.windowBox, targetBox = metrics.targetBox, contentDimensions = metrics.contentDimensions;
    var contentStyles = {};
    var arrowStyles = {};
    var fixedStyle = options.fixedDirection === 'top' || options.fixedDirection === 'left' ?
        (windowBox[invert(options.fixedDirection)] - targetBox[options.fixedDirection]) + options.fixedOffset + "px" :
        (windowBox[invert(options.fixedDirection)] + targetBox[options.fixedDirection]) + options.fixedOffset + "px";
    contentStyles[invert(options.fixedDirection)] = fixedStyle;
    arrowStyles[invert(options.fixedDirection)] = fixedStyle;
    switch (options.alignDirection) {
        case 'screen-center': {
            var alignDirection = control(rotate(options.fixedDirection));
            var alignDimension = dimension(rotate(options.fixedDirection));
            contentStyles[alignDirection] = (windowBox[alignDimension] - contentDimensions[alignDimension]) / 2 + "px";
            arrowStyles[alignDirection] = targetBox[alignDirection] + (targetBox[alignDimension] / 2) + "px";
            break;
        }
        case 'center': {
            var alignDirection = control(rotate(options.fixedDirection));
            var alignDimension = dimension(rotate(options.fixedDirection));
            var targetBoxCenter = targetBox[alignDirection] + (targetBox[alignDimension] / 2);
            arrowStyles[alignDirection] = targetBoxCenter + "px";
            contentStyles[alignDirection] = targetBoxCenter - (contentDimensions[alignDimension] / 2) + "px";
            break;
        }
        default: {
            contentStyles[options.alignDirection] = options.alignDirection === 'top' || options.alignDirection === 'left' ?
                windowBox[options.alignDirection] + targetBox[options.alignDirection] + "px" :
                windowBox[options.alignDirection] - targetBox[options.alignDirection] + "px";
            arrowStyles[options.alignDirection] = contentStyles[options.alignDirection];
            break;
        }
    }
    return {
        arrowStyles: arrowStyles,
        contentStyles: contentStyles,
    };
}
exports.calculatePositioning = calculatePositioning;


/***/ }),

/***/ "./src/common/trackable-component.ts":
/*!*******************************************!*\
  !*** ./src/common/trackable-component.ts ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
Object.defineProperty(exports, "__esModule", { value: true });
var TRACKING_ID_ATTR = 'data-tracking-id';
var TESTING_ID_ATTR = 'data-testid';
exports.optionallyAssignTrackingId = function (trackingId) {
    var _a;
    return trackingId ? (_a = {},
        _a[TRACKING_ID_ATTR] = trackingId,
        _a[TESTING_ID_ATTR] = trackingId,
        _a) : {};
};


/***/ }),

/***/ "./src/common/variables.ts":
/*!*********************************!*\
  !*** ./src/common/variables.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// N.B. ANY CHANGES TO VARIABLES SHOULD BE MADE IN /variables.ts, NOT ./variables.json
Object.defineProperty(exports, "__esModule", { value: true });
var variables_1 = __webpack_require__(/*! ../variables */ "./src/variables.ts");
var constants = {
    colors: {
        white: variables_1.variables.white,
        gray00: variables_1.variables['gray-00'],
        gray0: variables_1.variables['gray-0'],
        gray1: variables_1.variables['gray-1'],
        gray2: variables_1.variables['gray-2'],
        gray3: variables_1.variables['gray-3'],
        gray4: variables_1.variables['gray-4'],
        gray5: variables_1.variables['gray-5'],
        gray6: variables_1.variables['gray-6'],
        gray7: variables_1.variables['gray-7'],
        gray8: variables_1.variables['gray-8'],
        gray9: variables_1.variables['gray-9'],
        orange0: variables_1.variables['orange-0'],
        orange1: variables_1.variables['orange-1'],
        orange2: variables_1.variables['orange-2'],
        orange3: variables_1.variables['orange-3'],
        orange4: variables_1.variables['orange-4'],
        orange5: variables_1.variables['orange-5'],
        orange6: variables_1.variables['orange-6'],
        orange7: variables_1.variables['orange-7'],
        orange8: variables_1.variables['orange-8'],
        orange9: variables_1.variables['orange-9'],
        mint0: variables_1.variables['mint-0'],
        mint1: variables_1.variables['mint-1'],
        mint2: variables_1.variables['mint-2'],
        mint3: variables_1.variables['mint-3'],
        mint4: variables_1.variables['mint-4'],
        mint5: variables_1.variables['mint-5'],
        mint6: variables_1.variables['mint-6'],
        mint7: variables_1.variables['mint-7'],
        mint8: variables_1.variables['mint-8'],
        mint9: variables_1.variables['mint-9'],
        cyan0: variables_1.variables['cyan-0'],
        cyan1: variables_1.variables['cyan-1'],
        cyan2: variables_1.variables['cyan-2'],
        cyan3: variables_1.variables['cyan-3'],
        cyan4: variables_1.variables['cyan-4'],
        cyan5: variables_1.variables['cyan-5'],
        cyan6: variables_1.variables['cyan-6'],
        cyan7: variables_1.variables['cyan-7'],
        cyan8: variables_1.variables['cyan-8'],
        cyan9: variables_1.variables['cyan-9'],
        red0: variables_1.variables['red-0'],
        red1: variables_1.variables['red-1'],
        red2: variables_1.variables['red-2'],
        red3: variables_1.variables['red-3'],
        red4: variables_1.variables['red-4'],
        red5: variables_1.variables['red-5'],
        red6: variables_1.variables['red-6'],
        red7: variables_1.variables['red-7'],
        red8: variables_1.variables['red-8'],
        red9: variables_1.variables['red-9'],
        yellow0: variables_1.variables['yellow-0'],
        yellow1: variables_1.variables['yellow-1'],
        yellow2: variables_1.variables['yellow-2'],
        yellow3: variables_1.variables['yellow-3'],
        yellow4: variables_1.variables['yellow-4'],
        yellow5: variables_1.variables['yellow-5'],
        yellow6: variables_1.variables['yellow-6'],
        yellow7: variables_1.variables['yellow-7'],
        yellow8: variables_1.variables['yellow-8'],
        yellow9: variables_1.variables['yellow-9'],
        green0: variables_1.variables['green-0'],
        green1: variables_1.variables['green-1'],
        green2: variables_1.variables['green-2'],
        green3: variables_1.variables['green-3'],
        green4: variables_1.variables['green-4'],
        green5: variables_1.variables['green-5'],
        green6: variables_1.variables['green-6'],
        green7: variables_1.variables['green-7'],
        green8: variables_1.variables['green-8'],
        green9: variables_1.variables['green-9'],
        purple1: variables_1.variables['purple-1'],
        purple2: variables_1.variables['purple-2'],
        purple3: variables_1.variables['purple-3'],
        teal1: variables_1.variables['teal-1'],
        teal2: variables_1.variables['teal-2'],
        teal3: variables_1.variables['teal-3'],
        aliases: {
            primary: variables_1.variables['teal-1'],
            primaryShade1: variables_1.variables['teal-2'],
            primaryShade2: variables_1.variables['teal-3'],
            secondary: variables_1.variables['purple-1'],
            secondaryShade1: variables_1.variables['purple-2'],
            secondaryShade2: variables_1.variables['purple-3'],
            success: variables_1.variables['green-8'],
            error: variables_1.variables['red-8'],
            warning: variables_1.variables['yellow-5'],
            focus: variables_1.variables['cyan-8'],
            disabled: variables_1.variables['gray-4'],
            new: variables_1.variables['mint-5'],
            bodyPrimary: variables_1.variables['gray-9'],
            bodySecondary: variables_1.variables['gray-7'],
        },
    },
    spacings: variables_1.variables.spacings,
    zindex: {
        popoverBackdrop: variables_1.variables['z-index']['popover-backdrop'],
        fixed: variables_1.variables['z-index'].fixed,
        sticky: variables_1.variables['z-index'].sticky,
        modalBackdrop: variables_1.variables['z-index']['modal-backdrop'],
        modal: variables_1.variables['z-index'].modal,
        popover: variables_1.variables['z-index'].popover,
        tooltip: variables_1.variables['z-index'].tooltip,
        navbar: variables_1.variables['z-index'].navbar,
    },
    containerMaxWidths: variables_1.variables['container-max-widths'],
    gridBreakpoints: variables_1.variables['grid-breakpoints'],
    fontSizes: variables_1.variables['font-sizes'],
    fontWeights: {
        light: variables_1.variables['font-weights'].light,
        normal: variables_1.variables['font-weights'].normal,
        semiBold: variables_1.variables['font-weights']['semi-bold'],
        bold: variables_1.variables['font-weights'].bold,
    },
    wideMeasure: variables_1.variables['wide-measure'],
    mediumMeasure: variables_1.variables['medium-measure'],
    smallMeasure: variables_1.variables['small-measure'],
    borderRadii: variables_1.variables['border-radii'],
    borderWidths: variables_1.variables['border-widths'],
    lineHeights: {
        titleLeading: variables_1.variables['title-leading'],
        bodyLeading: variables_1.variables['body-leading'],
        uiLeading: variables_1.variables['ui-leading'],
    },
    boxShadows: variables_1.variables['box-shadows'],
};
exports.default = constants;


/***/ }),

/***/ "./src/react/components/action-button/ActionButton.tsx":
/*!*************************************************************!*\
  !*** ./src/react/components/action-button/ActionButton.tsx ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var styled_components_1 = __importStar(__webpack_require__(/*! styled-components */ "styled-components"));
var Icon_1 = __importDefault(__webpack_require__(/*! @react/components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var Popover_1 = __importDefault(__webpack_require__(/*! @react/components/popover/Popover */ "./src/react/components/popover/Popover.tsx"));
var PopoverContent_1 = __importDefault(__webpack_require__(/*! @react/components/popover/PopoverContent */ "./src/react/components/popover/PopoverContent.tsx"));
var PopoverTarget_1 = __importDefault(__webpack_require__(/*! @react/components/popover/PopoverTarget */ "./src/react/components/popover/PopoverTarget.tsx"));
var ActionButton = function (_a) {
    var iconColor = _a.iconColor, iconName = _a.iconName, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, label = _a.label, _c = _a.size, size = _c === void 0 ? 'small' : _c, buttonProps = __rest(_a, ["iconColor", "iconName", "isDisabled", "label", "size"]);
    var _d = react_1.useState(false), isHovering = _d[0], updateIsHovering = _d[1];
    return (react_1.default.createElement(Popover_1.default, { isDisabled: !label || isDisabled, isOpen: isHovering, noArrow: true, openOnHover: true, positioningStrategy: { align: 'center', fixed: 'bottom' }, stealFocus: false, toggle: updateIsHovering },
        react_1.default.createElement(PopoverTarget_1.default, { allowCustomOnClick: true },
            react_1.default.createElement(ActionButtonButton, __assign({ "aria-label": label || iconName, buttonSize: size, disabled: isDisabled }, buttonProps),
                react_1.default.createElement(ActionIcon, { buttonSize: size, iconColor: iconColor, isDisabled: isDisabled, name: iconName }))),
        react_1.default.createElement(ActionLabel, null,
            react_1.default.createElement(PopoverContent_1.default, null, label))));
};
var ActionButtonButton = styled_components_1.default.button.attrs({
    className: 'cu-button-invisible',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    ", "\n  }\n"], ["\n  && {\n    ",
    "\n  }\n"])), function (_a) {
    var theme = _a.theme, buttonSize = _a.buttonSize;
    var size = buttonSize === 'small' ? theme.spacings[5] : theme.spacings[6];
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        border-radius: 50%;\n        width: ", ";\n        height: ", ";\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n\n        &:hover {\n          background-color: rgba(0, 0, 0, 0.1);\n        }\n      "], ["\n        border-radius: 50%;\n        width: ", ";\n        height: ", ";\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n\n        &:hover {\n          background-color: rgba(0, 0, 0, 0.1);\n        }\n      "])), size, size);
});
var ActionIcon = styled_components_1.default(Icon_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n", "\n"], ["\n",
    "\n"])), function (_a) {
    var theme = _a.theme, buttonSize = _a.buttonSize, iconColor = _a.iconColor, isDisabled = _a.isDisabled;
    var size = buttonSize === 'small' ? theme.spacings[3] : theme.spacings[4];
    return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n    color: ", ";\n\n    ", ":hover & {\n      color: ", ";\n    }\n\n    svg {\n      width: ", ";\n      height: ", ";\n    }\n  "], ["\n    ", "\n    color: ", ";\n\n    ", ":hover & {\n      color: ", ";\n    }\n\n    svg {\n      width: ", ";\n      height: ", ";\n    }\n  "])), isDisabled && 'opacity: 0.6', iconColor || theme.colors.gray7, ActionButtonButton, iconColor || theme.colors.gray9, size, size);
});
var ActionLabel = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      display: inline-block;\n\n      .cu-popover-content {\n        background-color: rgba(0, 0, 0, 0.7);\n        padding: ", ";\n        display: flex;\n        align-items: center;\n        color: ", ";\n        border-radius: ", ";\n        font-size: ", ";\n        height: ", ";\n      }\n\n      .cu-popover-content-container {\n        box-shadow: none;\n        border: none;\n        margin-top: -2px;\n      }\n    "], ["\n      display: inline-block;\n\n      .cu-popover-content {\n        background-color: rgba(0, 0, 0, 0.7);\n        padding: ", ";\n        display: flex;\n        align-items: center;\n        color: ", ";\n        border-radius: ", ";\n        font-size: ", ";\n        height: ", ";\n      }\n\n      .cu-popover-content-container {\n        box-shadow: none;\n        border: none;\n        margin-top: -2px;\n      }\n    "])), theme.spacings[1], theme.colors.white, theme.borderRadii[1], theme.fontSizes[6], theme.spacings[3]);
});
exports.default = ActionButton;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),

/***/ "./src/react/components/alert/Alert.tsx":
/*!**********************************************!*\
  !*** ./src/react/components/alert/Alert.tsx ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Button_1 = __importDefault(__webpack_require__(/*! @react/components/button/Button */ "./src/react/components/button/Button.tsx"));
var Icon_1 = __importDefault(__webpack_require__(/*! @react/components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var AlertIcons = {
    error: 'error',
    info: 'lightbulb',
    success: 'circle-checkmark',
    warning: 'alarm',
};
var Alert = function (props) {
    var children = props.children, className = props.className, onDismiss = props.onDismiss, type = props.type;
    var alertClassName = classnames_1.default(className, 'cu-alert', "cu-alert-" + type, 'cu-text-body');
    var iconName = AlertIcons[type];
    return (React.createElement("div", { className: alertClassName, role: 'alert' },
        React.createElement("span", { className: 'cu-alert-icon' },
            React.createElement(Icon_1.default, { name: iconName })),
        React.createElement("span", { className: 'cu-alert-content' },
            onDismiss && (React.createElement(Button_1.default, { "aria-label": 'close', className: 'cu-close cu-button-invisible', onClick: onDismiss },
                React.createElement(Icon_1.default, { name: 'close' }))),
            children)));
};
exports.default = Alert;


/***/ }),

/***/ "./src/react/components/anchor/Anchor.tsx":
/*!************************************************!*\
  !*** ./src/react/components/anchor/Anchor.tsx ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Anchor = function (props) {
    var children = props.children, className = props.className, href = props.href, isDisabled = props.isDisabled, attributes = __rest(props, ["children", "className", "href", "isDisabled"]);
    var anchorClassName = classnames_1.default(className, {
        'cu-disabled': isDisabled,
    });
    if (isDisabled) {
        return (React.createElement("a", __assign({ className: anchorClassName }, attributes), children));
    }
    else {
        return (React.createElement("a", __assign({ className: anchorClassName, href: href }, attributes), children));
    }
};
Anchor.defaultProps = {
    className: 'cu-anchor-invisible',
    href: '',
    isDisabled: false,
};
exports.default = Anchor;


/***/ }),

/***/ "./src/react/components/badge/Badge.tsx":
/*!**********************************************!*\
  !*** ./src/react/components/badge/Badge.tsx ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Badge = function (_a) {
    var className = _a.className, children = _a.children;
    var badgeClassName = classnames_1.default('cu-badge', className);
    return (React.createElement("div", { className: badgeClassName }, children));
};
Badge.defaultProps = {
    className: '',
};
exports.default = Badge;


/***/ }),

/***/ "./src/react/components/button/Button.tsx":
/*!************************************************!*\
  !*** ./src/react/components/button/Button.tsx ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
var trackable_component_1 = __webpack_require__(/*! ../../../common/trackable-component */ "./src/common/trackable-component.ts");
var Button = function (_a) {
    var _b = _a.className, className = _b === void 0 ? 'cu-button-invisible' : _b, children = _a.children, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, trackingId = _a.trackingId, _d = _a.type, type = _d === void 0 ? 'button' : _d, buttonProps = __rest(_a, ["className", "children", "isDisabled", "trackingId", "type"]);
    return (React.createElement("button", __assign({ className: className, disabled: isDisabled, type: type }, buttonProps, trackable_component_1.optionallyAssignTrackingId(trackingId)), children));
};
exports.default = Button;


/***/ }),

/***/ "./src/react/components/checkbox/Checkbox.tsx":
/*!****************************************************!*\
  !*** ./src/react/components/checkbox/Checkbox.tsx ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Button_1 = __importDefault(__webpack_require__(/*! ../../components/button/Button */ "./src/react/components/button/Button.tsx"));
var Icon_1 = __importDefault(__webpack_require__(/*! ../../components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalHandleClick = function () {
            _this.props.handleClick(!_this.props.isChecked);
        };
        return _this;
    }
    Checkbox.prototype.render = function () {
        var currentCheckboxClass = classnames_1.default(this.props.className, 'cu-button-invisible', {
            'cu-checkbox-checked': this.props.isChecked && !this.props.isIndeterminate,
            'cu-checkbox-unchecked': !this.props.isChecked && !this.props.isIndeterminate,
            'cu-checkbox-indeterminate': this.props.isIndeterminate,
        });
        return (React.createElement(Button_1.default, { className: currentCheckboxClass, isDisabled: this.props.isDisabled, onClick: this.internalHandleClick, trackingId: this.props.trackingId },
            this.props.isChecked && !this.props.isIndeterminate &&
                React.createElement(Icon_1.default, { className: 'cu-checkbox-checkmark-icon', name: 'checkmark' }),
            this.props.isIndeterminate &&
                React.createElement(Icon_1.default, { className: 'cu-checkbox-collapse-icon', name: 'collapse' })));
    };
    Checkbox.defaultProps = {
        isChecked: false,
        isDisabled: false,
    };
    return Checkbox;
}(React.Component));
exports.default = Checkbox;


/***/ }),

/***/ "./src/react/components/drag-and-drop/DragAndDrop.tsx":
/*!************************************************************!*\
  !*** ./src/react/components/drag-and-drop/DragAndDrop.tsx ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var Alert_1 = __importDefault(__webpack_require__(/*! @react/components/alert/Alert */ "./src/react/components/alert/Alert.tsx"));
var FileUploaderImage_1 = __webpack_require__(/*! @react/components/drag-and-drop/FileUploaderImage */ "./src/react/components/drag-and-drop/FileUploaderImage.tsx");
var Icon_1 = __importDefault(__webpack_require__(/*! @react/components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var ProgressBar_1 = __importDefault(__webpack_require__(/*! @react/components/progress-bar/ProgressBar */ "./src/react/components/progress-bar/ProgressBar.tsx"));
var buildOxfordList_1 = __importDefault(__webpack_require__(/*! @src/utils/buildOxfordList */ "./src/utils/buildOxfordList.ts"));
var formatSizeUnits_1 = __importDefault(__webpack_require__(/*! @src/utils/formatSizeUnits */ "./src/utils/formatSizeUnits.ts"));
var uuid_1 = __importDefault(__webpack_require__(/*! @src/utils/uuid */ "./src/utils/uuid.ts"));
var DragAndDrop = function (props) {
    var _a = react_1.useState(''), fileName = _a[0], setFileName = _a[1];
    var _b = react_1.useState(0), fileSize = _b[0], setFileSize = _b[1];
    var _c = react_1.useState(''), fileTypeUploaded = _c[0], setFileTypeUploaded = _c[1];
    var _d = react_1.useState(false), isFileUploaded = _d[0], setIsFileUploaded = _d[1];
    var _e = react_1.useState(false), isIncorrectFileType = _e[0], setIsIncorrectFileType = _e[1];
    var _f = react_1.useState(false), isFileTooLarge = _f[0], setIsFileTooLarge = _f[1];
    var _g = react_1.useState([]), filesUploaded = _g[0], setFilesUploaded = _g[1];
    var _h = react_1.useState(false), isUploading = _h[0], setIsUploading = _h[1];
    var _j = react_1.useState(false), isDropZoneHovering = _j[0], setIsDropZoneHovering = _j[1];
    DragAndDrop.defaultProps = {
        allowMultipleFiles: false,
    };
    var acceptedFileTypes = props.acceptedFileTypes, maxFileSize = props.maxFileSize, allowMultipleFiles = props.allowMultipleFiles, handleUploadedFile = props.handleUploadedFile, headerText = props.headerText;
    var uploadedClassNames = classnames_1.default('cu-drag-and-drop-file-uploaded', 'cu-text-body');
    var dropZoneClassNames = classnames_1.default('cu-drag-and-drop-zone', { 'cu-drag-and-drop-zone-hovering': isDropZoneHovering });
    var fileTypesText = '';
    if (acceptedFileTypes) {
        var formats = acceptedFileTypes.map(function (fileType) { return "." + fileType; });
        fileTypesText = buildOxfordList_1.default(formats);
    }
    var IncorrectFileTypeAlert = function () {
        return (react_1.default.createElement(Alert_1.default, { type: 'error', className: 'cu-mb-2' },
            "Invalid file type (",
            fileTypeUploaded,
            "). Please upload a ",
            fileTypesText,
            "."));
    };
    var FileTooLargeAlert = function () {
        if (maxFileSize) {
            return (react_1.default.createElement(Alert_1.default, { type: 'error', className: 'cu-mb-2' },
                "Your file is too large (",
                formatSizeUnits_1.default(fileSize),
                "). Please upload a file ",
                formatSizeUnits_1.default(maxFileSize),
                " or less."));
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null));
        }
    };
    function onFileUpload(file) {
        return __awaiter(this, void 0, void 0, function () {
            var fileHasError, fileType;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fileHasError = false;
                        // sets boolean for max file size exceeded
                        if (maxFileSize && (file.size > maxFileSize)) {
                            setIsFileTooLarge(true);
                            fileHasError = true;
                        }
                        else {
                            setIsFileTooLarge(false);
                            fileHasError = false;
                        }
                        fileType = file.name.slice(file.name.lastIndexOf('.') + 1);
                        // sets boolean for file type accepted
                        if (acceptedFileTypes) {
                            if (acceptedFileTypes.includes(fileType)) {
                                setIsIncorrectFileType(false);
                                setFileTypeUploaded(fileType);
                                fileHasError = false;
                            }
                            else {
                                setIsIncorrectFileType(true);
                                fileHasError = true;
                            }
                        }
                        if (!fileHasError) return [3 /*break*/, 1];
                        setIsDropZoneHovering(false);
                        return [3 /*break*/, 5];
                    case 1:
                        if (!allowMultipleFiles) return [3 /*break*/, 3];
                        setIsUploading(true);
                        setIsDropZoneHovering(false);
                        return [4 /*yield*/, handleUploadedFile(file)];
                    case 2:
                        _a.sent();
                        setIsUploading(false);
                        setFilesUploaded(__spreadArrays(filesUploaded, [file]));
                        return [3 /*break*/, 5];
                    case 3:
                        setIsUploading(true);
                        setIsDropZoneHovering(false);
                        return [4 /*yield*/, handleUploadedFile(file)];
                    case 4:
                        _a.sent();
                        setIsUploading(false);
                        setFileName(file.name);
                        setFileSize(file.size);
                        setIsFileUploaded(true);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    // file upload path upon 'browse' click
    function handleDirectUpload(event) {
        var files = event.target.files;
        if (files) {
            if (allowMultipleFiles) {
                Array.from(files).forEach(function (file) {
                    onFileUpload(file);
                });
            }
            else {
                var file = files[0];
                onFileUpload(file);
            }
        }
    }
    // file upload path upon drag-and-drop on the file field
    function handleDropUpload(event) {
        event.preventDefault();
        var items = event.dataTransfer.items;
        if (allowMultipleFiles) {
            Array.from(items)
                .filter(function (item) { return item.kind === 'file'; })
                .map(function (item) { return item.getAsFile(); })
                .forEach(function (file) {
                if (file) {
                    onFileUpload(file);
                }
            });
        }
        else {
            if (items[0].kind === 'file') {
                var file = items[0].getAsFile();
                if (file) {
                    onFileUpload(file);
                }
            }
        }
    }
    // recreate the files uploaded array when a file is removed
    function fileRemovedFromUpload(event, indexRemoved) {
        event.preventDefault();
        var currArray = __spreadArrays(filesUploaded);
        currArray.splice(indexRemoved, 1);
        setFilesUploaded(currArray);
    }
    // change the background of the drag-and-drop field when hovering with a file
    function handleDragOver(event) {
        setIsDropZoneHovering(true);
        event.preventDefault();
    }
    function handleDragLeave(event) {
        setIsDropZoneHovering(false),
            event.preventDefault();
    }
    function fileDisplay(name, size) {
        return (react_1.default.createElement("div", { className: 'cu-drag-and-drop-file' },
            react_1.default.createElement(Icon_1.default, { name: 'file-xl', className: 'cu-mr-2' }),
            react_1.default.createElement("div", null,
                name,
                react_1.default.createElement("div", { className: 'cu-text-body-secondary' }, formatSizeUnits_1.default(size)))));
    }
    function uploadedClose() {
        setIsDropZoneHovering(false),
            setIsFileUploaded(false);
    }
    if (!allowMultipleFiles && isFileUploaded) {
        return (react_1.default.createElement("div", { className: props.className },
            react_1.default.createElement("div", { className: 'cu-text-subsection-2 cu-mb-2' }, "File Uploaded"),
            react_1.default.createElement("div", { className: uploadedClassNames },
                react_1.default.createElement("div", { className: 'cu-drag-and-drop-file-uploaded-content' },
                    fileDisplay(fileName, fileSize),
                    react_1.default.createElement(Icon_1.default, { name: 'close', onClick: uploadedClose, className: 'cu-drag-and-drop-uploaded-exit' })))));
    }
    else {
        return (react_1.default.createElement("div", { className: props.className },
            isIncorrectFileType && react_1.default.createElement(IncorrectFileTypeAlert, null),
            maxFileSize && isFileTooLarge && react_1.default.createElement(FileTooLargeAlert, null),
            headerText && react_1.default.createElement("div", { className: 'cu-text-body-2 cu-mb-2' }, headerText),
            react_1.default.createElement("div", { className: dropZoneClassNames, onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDropUpload }, isUploading ?
                react_1.default.createElement("div", { className: 'cu-drag-and-drop-progress cu-text-section' },
                    react_1.default.createElement(ProgressBar_1.default, { value: 0.0, isIndeterminate: true, className: 'cu-progress-bar-success cu-drag-and-drop-progress-bar' }),
                    "Your file is uploading...")
                :
                    react_1.default.createElement("div", { className: 'cu-drag-and-drop-content cu-text-body-2' },
                        react_1.default.createElement(FileUploaderImage_1.FileUploaderImage, null),
                        react_1.default.createElement("div", { className: 'cu-drag-and-drop-text' },
                            react_1.default.createElement("input", { className: 'cu-drag-and-drop-input', type: 'file', id: 'file', accept: fileTypesText, onChange: handleDirectUpload }),
                            react_1.default.createElement("strong", null, "Drag and drop to upload"),
                            react_1.default.createElement("br", null),
                            "or",
                            react_1.default.createElement("label", { htmlFor: 'file', className: 'cu-drag-and-drop-upload' }, " browse"),
                            " to choose a file",
                            maxFileSize &&
                                react_1.default.createElement("div", { className: 'cu-text-caption-secondary' }, "The max file size is " + formatSizeUnits_1.default(maxFileSize)),
                            acceptedFileTypes &&
                                react_1.default.createElement("div", { className: 'cu-text-caption-secondary' }, "(Accepted file types are " + fileTypesText + ")")))),
            allowMultipleFiles && filesUploaded.length !== 0 &&
                filesUploaded.map(function (file, index) {
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: 'cu-text-subsection-2 cu-mt-4' }, "Uploaded Files"),
                        react_1.default.createElement("div", { className: 'cu-my-2', key: uuid_1.default() },
                            react_1.default.createElement("div", { className: 'cu-drag-and-drop-multiple-files' },
                                fileDisplay(file.name, file.size),
                                react_1.default.createElement(Icon_1.default, { name: 'close', onClick: function (event) { return fileRemovedFromUpload(event, index); }, className: 'cu-drag-and-drop-uploaded-exit' })))));
                })));
    }
};
exports.default = DragAndDrop;


/***/ }),

/***/ "./src/react/components/drag-and-drop/FileUploaderImage.tsx":
/*!******************************************************************!*\
  !*** ./src/react/components/drag-and-drop/FileUploaderImage.tsx ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate  Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
exports.FileUploaderImage = function () {
    return (react_1.default.createElement("svg", { viewBox: '0 0 29.2 21.56' },
        react_1.default.createElement("g", null,
            react_1.default.createElement("g", null,
                react_1.default.createElement("path", { d: 'M12 16.62H5.85c-1.8 0-4-1.33-4.23-3.11s1.23-3.58 3.58-4a5.82 5.82 0 0 1-.07-.73C5 6.07 6 3 8.65\n            2.32c4.94-1.22 7.21 2.19 8.16 5.36A3.81 3.81 0 0 1 20.4 6c2.6.36 2.89 2.37 2.94 3.8h.05c1.37 0 3 0\n            3.85 1.67C28.57 14 26 16.62 23.56 16.62H17.31', fill: '#84efe9' }),
                react_1.default.createElement("path", { d: 'M24.6 17.2h-8V16h8a3.4 3.4 0 0 0 0-6.8h-.53L24 8.67A3.9 3.9 0 0 0 20.1 5.2 3.85 3.85 0 0 0 17.68 6L17\n              6.6l-.25-.85A6.4 6.4 0 0 0 4.2 7.6a6.77 6.77 0 0 0 .08 1l.09.55-.55.13A3.4 3.4 0 0 0 4.6 16h8v1.2h-8A4.6\n              4.6 0 0 1 3 8.27c0-.22 0-.44 0-.67A7.6 7.6 0 0 1 17.6 4.65 5 5 0 0 1 20.1 4a5.1 5.1 0 0 1 5 4 4.6 4.6 0\n              0 1-.49 9.17Z', fill: '#329e9b' }),
                react_1.default.createElement("rect", { fill: '#329e9b', x: '14.02', y: '11.29', width: '1.2', height: '10.28' }),
                react_1.default.createElement("polygon", { fill: '#329e9b', points: '12.82 11.38 14.62 8.4 16.42 11.38 12.82 11.38' })))));
};


/***/ }),

/***/ "./src/react/components/expanding-data-table/ExpandingDataTable.tsx":
/*!**************************************************************************!*\
  !*** ./src/react/components/expanding-data-table/ExpandingDataTable.tsx ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Icon_1 = __importDefault(__webpack_require__(/*! @react/components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var ExpandingDataTable = /** @class */ (function (_super) {
    __extends(ExpandingDataTable, _super);
    function ExpandingDataTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isExpanded: false,
        };
        _this.tableHeaders = (_this.props.customTableHeaders) ?
            _this.props.customTableHeaders : Object.keys(_this.props.tableData[0]);
        _this.onToggleClick = function () { return _this.setState({ isExpanded: !_this.state.isExpanded }); };
        return _this;
    }
    ExpandingDataTable.prototype.render = function () {
        var _a = this.props, tableTitle = _a.tableTitle, tableDescription = _a.tableDescription, tableData = _a.tableData, errorColumns = _a.errorColumns;
        var isExpanded = this.state.isExpanded;
        return (React.createElement("div", { className: 'cu-expanding-data-table' },
            React.createElement("div", { className: 'cu-expanding-data-table-row cu-text-body' },
                React.createElement("div", { className: 'cu-ml-3' },
                    React.createElement("div", { className: 'cu-mb-2' }, tableTitle),
                    tableDescription),
                React.createElement("div", { className: 'cu-expanding-data-table-type' },
                    React.createElement("div", { className: 'cu-mr-4' },
                        tableData.length,
                        " ",
                        tableData.length === 1 ? 'item' : 'items'),
                    React.createElement(Icon_1.default, { className: '', name: isExpanded ? 'chevron-up' : 'chevron-down', onClick: this.onToggleClick }))),
            React.createElement("div", null, isExpanded &&
                React.createElement("table", { className: 'cu-expanding-data-table-expanded' },
                    React.createElement("thead", { key: 'header' },
                        React.createElement("tr", { className: 'cu-text-subsection-2 cu-expanding-data-table-expanded-header' }, this.tableHeaders.map(function (header, headerIndex) {
                            return (React.createElement("th", { key: headerIndex }, header));
                        }))),
                    React.createElement("tbody", { key: 'body' }, tableData.map(function (row, rowIndex) {
                        return (React.createElement("tr", { key: rowIndex, className: 'cu-expanding-data-table-expanded-row' }, Object.values(row).map(function (entry, entryIndex) {
                            var columnClassName = classnames_1.default({ 'cu-expanding-data-table-column-error': errorColumns !== undefined ? errorColumns.includes(entryIndex + 1) : false });
                            return (React.createElement("td", { className: columnClassName, key: entryIndex }, entry));
                        })));
                    }))))));
    };
    ExpandingDataTable.defaultProps = {
        errorColumns: [],
        tableData: [],
        tableDescription: '',
        tableTitle: '',
    };
    return ExpandingDataTable;
}(React.Component));
exports.ExpandingDataTable = ExpandingDataTable;
exports.default = ExpandingDataTable;


/***/ }),

/***/ "./src/react/components/icon/Icon.tsx":
/*!********************************************!*\
  !*** ./src/react/components/icon/Icon.tsx ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var index_1 = __importDefault(__webpack_require__(/*! @icons/index */ "./icons/index.ts"));
var trackable_component_1 = __webpack_require__(/*! ../../../common/trackable-component */ "./src/common/trackable-component.ts");
var Icon = function (props) {
    var icon = index_1.default[props.name];
    var className = classnames_1.default(props.className, 'cu-icon-container');
    return (React.createElement("span", __assign({ "data-name": props.name, className: className, onClick: props.onClick, dangerouslySetInnerHTML: { __html: icon } }, trackable_component_1.optionallyAssignTrackingId(props.trackingId))));
};
exports.default = Icon;


/***/ }),

/***/ "./src/react/components/modal/Modal.tsx":
/*!**********************************************!*\
  !*** ./src/react/components/modal/Modal.tsx ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var trackable_component_1 = __webpack_require__(/*! ../../../common/trackable-component */ "./src/common/trackable-component.ts");
var Modal = function (props) {
    if (!props.isOpen) {
        return null;
    }
    var modalClasses = classnames_1.default(props.className, 'cu-sheet-low', 'cu-d-flex', 'cu-flex-column', 'cu-pos-relative');
    return (React.createElement("div", __assign({ className: 'cu-modal-container' }, trackable_component_1.optionallyAssignTrackingId(props.trackingId)),
        React.createElement("div", { className: modalClasses }, props.children)));
};
Modal.defaultProps = {
    className: '',
};
exports.default = Modal;


/***/ }),

/***/ "./src/react/components/modal/ModalBody.tsx":
/*!**************************************************!*\
  !*** ./src/react/components/modal/ModalBody.tsx ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var ModalBody = function (props) {
    var bodyClasses = classnames_1.default(props.className, 'cu-modal-body-container');
    return (React.createElement("div", { className: bodyClasses }, props.children));
};
ModalBody.defaultProps = {
    className: '',
};
exports.default = ModalBody;


/***/ }),

/***/ "./src/react/components/modal/ModalFooter.tsx":
/*!****************************************************!*\
  !*** ./src/react/components/modal/ModalFooter.tsx ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var ModalFooter = function (props) {
    var footerClasses = classnames_1.default(props.className, 'cu-modal-footer-container');
    return (React.createElement("div", { className: footerClasses }, props.children));
};
ModalFooter.defaultProps = {
    className: '',
};
exports.default = ModalFooter;


/***/ }),

/***/ "./src/react/components/modal/ModalHeader.tsx":
/*!****************************************************!*\
  !*** ./src/react/components/modal/ModalHeader.tsx ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Icon_1 = __importDefault(__webpack_require__(/*! ../icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var ModalHeader = function (props) {
    var headerClasses = classnames_1.default(props.className, 'cu-modal-header-container');
    return (React.createElement("div", { className: headerClasses },
        props.children,
        props.onCancel &&
            React.createElement(Icon_1.default, { className: 'cu-modal-closer', name: 'close', onClick: props.onCancel, "ct-modal-cancel-button": true, trackingId: props.cancelTrackingId })));
};
ModalHeader.defaultProps = {
    className: '',
};
exports.default = ModalHeader;


/***/ }),

/***/ "./src/react/components/nav-tabs/NavTab.tsx":
/*!**************************************************!*\
  !*** ./src/react/components/nav-tabs/NavTab.tsx ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var NavTab = function (props) {
    var navTabClasses = classnames_1.default(props.className, 'cu-nav-item', {
        'cu-active': props.isActive,
        'cu-disabled': props.isDisabled,
    });
    return (React.createElement("div", { className: navTabClasses }, React.cloneElement(props.children, { isDisabled: props.isDisabled })));
};
NavTab.defaultProps = {
    className: '',
    isActive: false,
    isDisabled: false,
};
exports.default = NavTab;


/***/ }),

/***/ "./src/react/components/nav-tabs/NavTabs.tsx":
/*!***************************************************!*\
  !*** ./src/react/components/nav-tabs/NavTabs.tsx ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var NavTabs = function (props) {
    var navTabsClasses = classnames_1.default(props.className, ["cu-nav-tabs-" + props.direction]);
    return (React.createElement("div", { className: navTabsClasses }, props.children));
};
NavTabs.defaultProps = {
    className: '',
    direction: 'horizontal',
};
exports.default = NavTabs;


/***/ }),

/***/ "./src/react/components/page-frame/PageFrame.tsx":
/*!*******************************************************!*\
  !*** ./src/react/components/page-frame/PageFrame.tsx ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
exports.PageFrame = function (props) {
    var classes = classnames_1.default(props.className, 'cu-page-frame');
    return (React.createElement("div", { className: classes }, props.children));
};
exports.default = exports.PageFrame;


/***/ }),

/***/ "./src/react/components/page-frame/PageFrameContent.tsx":
/*!**************************************************************!*\
  !*** ./src/react/components/page-frame/PageFrameContent.tsx ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
exports.PageFrameContent = function (props) {
    return (React.createElement("div", { className: 'cu-page-frame-content-wrap' },
        React.createElement("div", { className: 'cu-page-frame-content-area' },
            React.createElement("div", { className: 'cu-page-frame-content' }, props.children))));
};
exports.default = exports.PageFrameContent;


/***/ }),

/***/ "./src/react/components/page-frame/PageFrameHeader.tsx":
/*!*************************************************************!*\
  !*** ./src/react/components/page-frame/PageFrameHeader.tsx ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
exports.PageFrameHeader = function (props) {
    var classes = classnames_1.default(props.className, 'cu-page-frame-header-wrap');
    return (React.createElement("div", { className: classes }, props.children));
};
exports.default = exports.PageFrameHeader;


/***/ }),

/***/ "./src/react/components/page-frame/PageFrameMain.tsx":
/*!***********************************************************!*\
  !*** ./src/react/components/page-frame/PageFrameMain.tsx ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
exports.PageFrameMain = function (props) {
    return (React.createElement("div", { className: 'cu-page-frame-main' }, props.children));
};
exports.default = exports.PageFrameMain;


/***/ }),

/***/ "./src/react/components/page-frame/PageFrameScrollWrap.tsx":
/*!*****************************************************************!*\
  !*** ./src/react/components/page-frame/PageFrameScrollWrap.tsx ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
exports.default = React.forwardRef(function (props, ref) {
    if (props === void 0) { props = { onScroll: function () { return undefined; } }; }
    var classes = classnames_1.default(props.className, 'cu-page-frame-scroll-wrap');
    return (React.createElement("div", { className: classes, onScroll: props.onScroll, ref: ref }, props.children));
});


/***/ }),

/***/ "./src/react/components/page-frame/PageFrameSidebar.tsx":
/*!**************************************************************!*\
  !*** ./src/react/components/page-frame/PageFrameSidebar.tsx ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
exports.PageFrameSidebar = function (props) {
    var classes = classnames_1.default(props.className, 'cu-page-frame-sidebar');
    return (React.createElement("div", { className: classes }, props.children));
};
exports.default = exports.PageFrameSidebar;


/***/ }),

/***/ "./src/react/components/pagination-controls/PaginationControls.tsx":
/*!*************************************************************************!*\
  !*** ./src/react/components/pagination-controls/PaginationControls.tsx ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Button_1 = __importDefault(__webpack_require__(/*! ../../components/button/Button */ "./src/react/components/button/Button.tsx"));
var Icon_1 = __importDefault(__webpack_require__(/*! ../../components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var PaginationControls = /** @class */ (function (_super) {
    __extends(PaginationControls, _super);
    function PaginationControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            visiblePages: [],
        };
        _this.numPageControls = 3;
        _this.updateVisiblePages = function (numPages, currentPage) {
            if (numPages === void 0) { numPages = 0; }
            if (currentPage === void 0) { currentPage = 0; }
            var firstNum = currentPage - (currentPage % _this.numPageControls);
            var currentVisiblePages = [];
            if (numPages === 0) {
                return;
            }
            for (var i = 0, j = firstNum; i < _this.numPageControls && j < numPages; i += 1, j += 1) {
                currentVisiblePages.push(j);
            }
            _this.setState({ visiblePages: currentVisiblePages });
        };
        _this.callOnChange = function (currentPage) {
            _this.props.handlePageChange(currentPage);
        };
        _this.handleBackButtonClick = function () {
            var currentPage = _this.props.currentPage;
            _this.callOnChange(currentPage - 1);
        };
        _this.handleForwardButtonClick = function () {
            var currentPage = _this.props.currentPage;
            _this.callOnChange(currentPage + 1);
        };
        _this.renderControls = function () {
            var _a = _this.props, currentPage = _a.currentPage, isDisabled = _a.isDisabled, numPages = _a.numPages;
            var visiblePages = _this.state.visiblePages;
            var headButton = null;
            var headSpreadButton = null;
            var tailSpreadButton = null;
            var tailButton = null;
            if (visiblePages.length > 0 && visiblePages[0] > 1) {
                // These 2 buttons need to be separated to preserve the sibling-enforced styling
                headButton = (React.createElement(Button_1.default, { className: 'cu-button-default', isDisabled: isDisabled, onClick: function () { return _this.callOnChange(0); } }, "1"));
                headSpreadButton = (React.createElement(Button_1.default, { className: 'cu-button-default', isDisabled: isDisabled, onClick: function () { return _this.callOnChange(visiblePages[0] - 1); } }, "..."));
            }
            if (visiblePages.length > 0 && visiblePages[visiblePages.length - 1] < numPages - 2) {
                tailSpreadButton = (React.createElement(Button_1.default, { className: 'cu-button-default', isDisabled: isDisabled, onClick: function () { return _this.callOnChange(visiblePages[visiblePages.length - 1] + 1); } }, "..."));
            }
            if (visiblePages.length > 0 && visiblePages[visiblePages.length - 1] < numPages - 1) {
                tailButton = (React.createElement(Button_1.default, { className: 'cu-button-default', isDisabled: isDisabled, onClick: function () { return _this.callOnChange(numPages - 1); } }, numPages.toString()));
            }
            var mainButtons = visiblePages.map(function (pageIndex) {
                var buttonClasses = classnames_1.default(pageIndex === currentPage ? 'cu-selected' : '', 'cu-button-default');
                return (React.createElement(Button_1.default, { className: buttonClasses, isDisabled: isDisabled, key: pageIndex, onClick: function () { return _this.callOnChange(pageIndex); } }, (pageIndex + 1).toString()));
            });
            return [headButton, headSpreadButton, mainButtons, tailSpreadButton, tailButton];
        };
        return _this;
    }
    // We call updateVisiblePages here to ensure we properly initialize visiblePages for rendering
    PaginationControls.prototype.componentDidMount = function () {
        var _a = this.props, numPages = _a.numPages, currentPage = _a.currentPage;
        this.updateVisiblePages(numPages, currentPage);
    };
    PaginationControls.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, numPages = _a.numPages, currentPage = _a.currentPage;
        var visiblePages = this.state.visiblePages;
        if (prevProps.numPages !== numPages ||
            prevProps.currentPage !== currentPage ||
            visiblePages.length === 0) {
            this.updateVisiblePages(numPages, currentPage);
        }
    };
    PaginationControls.prototype.render = function () {
        var _a = this.props, currentPage = _a.currentPage, isDisabled = _a.isDisabled, numPages = _a.numPages;
        return (React.createElement("div", { className: 'cu-d-flex cu-pagination-controls' },
            React.createElement(Button_1.default, { className: 'cu-button-default cu-button-icon', isDisabled: numPages === 0 || currentPage === 0 || isDisabled, onClick: this.handleBackButtonClick },
                React.createElement(Icon_1.default, { name: 'chevron-right', className: 'cu-rot-180' })),
            this.renderControls(),
            React.createElement(Button_1.default, { className: 'cu-button-default cu-button-icon', isDisabled: numPages === 0 || currentPage === numPages - 1 || isDisabled, onClick: this.handleForwardButtonClick },
                React.createElement(Icon_1.default, { name: 'chevron-right' }))));
    };
    PaginationControls.defaultProps = {
        isDisabled: false,
    };
    return PaginationControls;
}(React.Component));
exports.PaginationControls = PaginationControls;
exports.default = PaginationControls;


/***/ }),

/***/ "./src/react/components/popover/Popover.tsx":
/*!**************************************************!*\
  !*** ./src/react/components/popover/Popover.tsx ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
var PopoverCommon = __importStar(__webpack_require__(/*! ../../../common/popover */ "./src/common/popover.ts"));
var PopoverContext_1 = __webpack_require__(/*! ./PopoverContext */ "./src/react/components/popover/PopoverContext.tsx");
var Popover = /** @class */ (function (_super) {
    __extends(Popover, _super);
    function Popover(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.HOVER_OPEN_TIMEOUT_DELAY = 100;
        _this.HOVER_CLOSE_TIMEOUT_DELAY = 200;
        _this.state = {
            getTargetBoundingClientRect: function () { return ({}); },
            hoverCloseTimeout: undefined,
            hoverOpenTimeout: undefined,
            shouldPreload: false,
        };
        _this.forceClose = function () {
            if (_this.props.isOpen) {
                _this.close();
            }
        };
        _this.handleOpenOnHover = function () {
            if (!_this.props.isDisabled) {
                var hoverOpenTimeout = setTimeout(function () {
                    if (!_this.props.isDisabled) {
                        _this.props.toggle(true);
                    }
                }, _this.HOVER_OPEN_TIMEOUT_DELAY);
                // cancel any outstanding close timeouts
                clearTimeout(_this.state.hoverCloseTimeout);
                // update timeout state
                _this.setState({
                    hoverCloseTimeout: undefined,
                    hoverOpenTimeout: hoverOpenTimeout,
                });
            }
        };
        _this.handleCloseOnHover = function () {
            var hoverCloseTimeout = setTimeout(function () {
                _this.props.toggle(false);
            }, _this.HOVER_CLOSE_TIMEOUT_DELAY);
            // cancel any outstanding open timeouts
            clearTimeout(_this.state.hoverOpenTimeout);
            // update timeout state
            _this.setState({
                hoverCloseTimeout: hoverCloseTimeout,
                hoverOpenTimeout: undefined,
            });
        };
        _this.setShouldPreload = function (shouldPreload) {
            _this.setState({
                shouldPreload: shouldPreload,
            });
        };
        _this.setTargetBoundingClientRectGetter = function (getterFn) {
            _this.setState({
                getTargetBoundingClientRect: getterFn,
            });
        };
        // Initialize the child context with default values from our props.
        _this.childContext = {
            appendToBody: !!props.appendToBody,
            closeOnScroll: !!props.closeOnScroll,
            fixedOffset: props.fixedOffset === undefined ?
                (props.noArrow ? PopoverCommon.POPOVER_NO_ARROW_OFFSET : PopoverCommon.POPOVER_OFFSET) :
                +props.fixedOffset,
            getTargetBoundingClientRect: _this.state.getTargetBoundingClientRect,
            handleCloseOnHover: _this.handleCloseOnHover,
            handleOpenOnHover: _this.handleOpenOnHover,
            isDisabled: !!props.isDisabled,
            isLazy: !!props.isLazy,
            isOpen: props.isOpen,
            noArrow: !!props.noArrow,
            openOnHover: !!props.openOnHover,
            positioningStrategy: __assign(__assign({}, PopoverCommon.DEFAULT_POSITIONING_STRATEGY), props.positioningStrategy),
            setShouldPreload: _this.setShouldPreload,
            setTargetBoundingClientRectGetter: _this.setTargetBoundingClientRectGetter,
            shouldPreload: false,
            toggle: props.toggle,
        };
        return _this;
    }
    Popover.prototype.close = function () {
        this.props.toggle(false);
    };
    Popover.prototype.getPopoverContext = function () {
        // After initialization, only accept changes to a few props...
        if (this.childContext.isDisabled !== this.props.isDisabled ||
            this.childContext.isOpen !== this.props.isOpen ||
            this.childContext.shouldPreload !== this.state.shouldPreload ||
            this.childContext.getTargetBoundingClientRect !== this.state.getTargetBoundingClientRect) {
            this.childContext = __assign(__assign({}, this.childContext), { getTargetBoundingClientRect: this.state.getTargetBoundingClientRect, isDisabled: !!this.props.isDisabled, isOpen: this.props.isOpen, shouldPreload: this.state.shouldPreload });
        }
        return this.childContext;
    };
    Popover.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.forceClose);
    };
    Popover.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.forceClose);
    };
    Popover.prototype.render = function () {
        var context = this.getPopoverContext();
        return (React.createElement(PopoverContext_1.PopoverContext.Provider, { value: context }, this.props.children));
    };
    Popover.defaultProps = {
        appendToBody: false,
        closeOnScroll: false,
        fixedOffset: undefined,
        isDisabled: false,
        isLazy: true,
        noArrow: false,
        openOnHover: false,
        positioningStrategy: {},
        stealFocus: false,
    };
    return Popover;
}(React.Component));
exports.default = Popover;


/***/ }),

/***/ "./src/react/components/popover/PopoverContent.tsx":
/*!*********************************************************!*\
  !*** ./src/react/components/popover/PopoverContent.tsx ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var ReactDOM = __importStar(__webpack_require__(/*! react-dom */ "react-dom"));
var PopoverCommon = __importStar(__webpack_require__(/*! ../../../common/popover */ "./src/common/popover.ts"));
var PopoverContext_1 = __webpack_require__(/*! ./PopoverContext */ "./src/react/components/popover/PopoverContext.tsx");
var OFFSCREEN_POSITION = {
    left: '-99999px',
    top: '-99999px',
};
var PopoverContent = /** @class */ (function (_super) {
    __extends(PopoverContent, _super);
    function PopoverContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.containerRef = React.createRef();
        _this.needsRepositioning = false;
        _this.scrollParents = [];
        _this.state = {
            alignDirection: PopoverCommon.DEFAULT_POSITIONING_STRATEGY.align[0],
            arrowStyles: {},
            contentStyles: {},
            fixedDirection: PopoverCommon.DEFAULT_POSITIONING_STRATEGY.fixed[0],
        };
        _this.repositionContentIfNecessary = function () {
            if (_this.props.popoverContext.isOpen && _this.needsRepositioning) {
                _this.repositionContent();
                _this.needsRepositioning = false;
            }
        };
        _this.forceReposition = function () {
            _this.needsRepositioning = true;
            _this.repositionContentIfNecessary();
        };
        _this.forceClose = function () {
            _this.clearScrollParents();
            _this.props.popoverContext.toggle(false);
        };
        _this.clearScrollParents = function () {
            _this.scrollParents.forEach(function (scrollParent) {
                scrollParent.removeEventListener('scroll', _this.forceClose);
                scrollParent.removeEventListener('scroll', _this.forceReposition);
            });
            _this.scrollParents = [];
            window.removeEventListener('scroll', _this.forceClose);
            window.removeEventListener('scroll', _this.forceReposition);
        };
        _this.setScrollParents = function () {
            var _a, _b;
            _this.clearScrollParents();
            var scrollFn = _this.props.popoverContext.closeOnScroll ? _this.forceClose : _this.forceReposition;
            var parent = (_a = _this.containerRef.current) === null || _a === void 0 ? void 0 : _a.parentNode;
            while (((_b = parent) === null || _b === void 0 ? void 0 : _b.nodeType) === Node.ELEMENT_NODE) {
                var parentElem = parent;
                var styles = window.getComputedStyle(parentElem);
                var canScroll = styles.overflow === 'auto' || styles.overflow === 'scroll';
                if (canScroll) {
                    parentElem.addEventListener('scroll', scrollFn);
                    _this.scrollParents.push(parentElem);
                }
                parent = parent.parentNode;
            }
            window.addEventListener('scroll', scrollFn);
        };
        _this.handleMouseEnter = function () {
            var popoverContext = _this.props.popoverContext;
            if (popoverContext.openOnHover) {
                popoverContext.handleOpenOnHover();
            }
        };
        _this.handleMouseLeave = function () {
            var popoverContext = _this.props.popoverContext;
            if (popoverContext.openOnHover) {
                popoverContext.handleCloseOnHover();
            }
        };
        return _this;
    }
    PopoverContent.prototype.getPositionMetrics = function () {
        var container = this.containerRef.current;
        var contentDimensions = {
            height: container.offsetHeight,
            width: container.offsetWidth,
        };
        var targetBox = this.props.popoverContext.getTargetBoundingClientRect();
        var windowBox = {
            bottom: window.innerHeight,
            left: 0,
            right: window.innerWidth,
            top: 0,
            height: window.innerHeight,
            width: window.innerWidth,
        };
        return { contentDimensions: contentDimensions, targetBox: targetBox, windowBox: windowBox };
    };
    PopoverContent.prototype.repositionContent = function () {
        var positionMetrics = this.getPositionMetrics();
        var positioning = PopoverCommon.determinePositioningStrategies(positionMetrics, this.props.popoverContext.positioningStrategy, this.props.popoverContext.fixedOffset);
        var styles = PopoverCommon.calculatePositioning(positionMetrics, {
            alignDirection: positioning.align,
            fixedDirection: positioning.fixed,
            fixedOffset: this.props.popoverContext.fixedOffset,
        });
        this.setState({
            alignDirection: positioning.align,
            arrowStyles: styles.arrowStyles,
            contentStyles: styles.contentStyles,
            fixedDirection: positioning.fixed,
        });
    };
    PopoverContent.prototype.renderArrow = function () {
        if (this.props.popoverContext.noArrow) {
            return null;
        }
        var className = classnames_1.default('cu-popover-arrow', "cu-popover-arrow-fixed-" + this.state.fixedDirection, "cu-popover-arrow-align-" + this.state.alignDirection);
        // If we're not open yet (just preloading, or not lazy), we should position offscreen.
        var arrowStyles = this.props.popoverContext.isOpen ? this.state.arrowStyles : OFFSCREEN_POSITION;
        return React.createElement("div", { className: className, style: arrowStyles });
    };
    PopoverContent.prototype.renderContent = function () {
        var _a = this.props.popoverContext, isOpen = _a.isOpen, shouldPreload = _a.shouldPreload, isLazy = _a.isLazy;
        if (!isOpen) {
            this.clearScrollParents();
        }
        if (isOpen || shouldPreload || !isLazy) {
            this.setScrollParents();
            var className = classnames_1.default('cu-popover-content-container', this.props.className);
            // If we're not open yet (just preloading, or not lazy), we should position offscreen.
            var contentStyles = isOpen ? this.state.contentStyles : OFFSCREEN_POSITION;
            return (React.createElement("div", { className: className, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, ref: this.containerRef, style: contentStyles },
                React.createElement("div", { className: 'cu-popover-content' }, this.props.children),
                this.renderArrow()));
        }
        return null;
    };
    PopoverContent.prototype.componentWillUnmount = function () {
        this.clearScrollParents();
        if (this.portalContainer) {
            // Clean up the portal container if one exists.
            document.body.removeChild(this.portalContainer);
            this.portalContainer = undefined;
        }
    };
    PopoverContent.prototype.componentDidMount = function () {
        requestAnimationFrame(this.repositionContentIfNecessary);
    };
    PopoverContent.prototype.componentDidUpdate = function () {
        requestAnimationFrame(this.repositionContentIfNecessary);
    };
    PopoverContent.prototype.render = function () {
        this.needsRepositioning = true;
        var content = this.renderContent();
        // Wraps the content in a portal if requested by our props.
        if (this.props.popoverContext.appendToBody) {
            if (!this.portalContainer) {
                this.portalContainer = document.createElement('div');
                this.portalContainer.className = 'unison-component';
                document.body.appendChild(this.portalContainer);
            }
            return ReactDOM.createPortal(content, this.portalContainer);
        }
        return content;
    };
    return PopoverContent;
}(React.Component));
exports.default = PopoverContext_1.withPopoverContext(PopoverContent);


/***/ }),

/***/ "./src/react/components/popover/PopoverContext.tsx":
/*!*********************************************************!*\
  !*** ./src/react/components/popover/PopoverContext.tsx ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
var popover_1 = __webpack_require__(/*! ../../../common/popover */ "./src/common/popover.ts");
exports.PopoverContext = React.createContext({
    appendToBody: false,
    closeOnScroll: false,
    fixedOffset: popover_1.POPOVER_OFFSET,
    getTargetBoundingClientRect: function () { return ({}); },
    handleCloseOnHover: function () { return undefined; },
    handleOpenOnHover: function () { return undefined; },
    isDisabled: false,
    isLazy: false,
    isOpen: false,
    noArrow: false,
    openOnHover: false,
    positioningStrategy: popover_1.DEFAULT_POSITIONING_STRATEGY,
    setShouldPreload: function () { return undefined; },
    setTargetBoundingClientRectGetter: function () { return undefined; },
    shouldPreload: false,
    toggle: function () { return undefined; },
});
function withPopoverContext(WrappedComponent) {
    return function (props) {
        return (
        // `{...props as P}` below is a slightly improper cast.
        // See ongoing TS issues with React HoCs: https://github.com/Microsoft/TypeScript/issues/28938
        React.createElement(exports.PopoverContext.Consumer, null, function (context) { return React.createElement(WrappedComponent, __assign({}, props, { popoverContext: context })); }));
    };
}
exports.withPopoverContext = withPopoverContext;


/***/ }),

/***/ "./src/react/components/popover/PopoverTarget.tsx":
/*!********************************************************!*\
  !*** ./src/react/components/popover/PopoverTarget.tsx ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var PopoverContext_1 = __webpack_require__(/*! @react/components/popover/PopoverContext */ "./src/react/components/popover/PopoverContext.tsx");
var PopoverTarget = /** @class */ (function (_super) {
    __extends(PopoverTarget, _super);
    function PopoverTarget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.targetElementRef = React.createRef();
        _this.getPositioningTargetBoundingBox = function () {
            var target = _this.props.positioningTarget || _this.targetElementRef;
            return target.current.getBoundingClientRect();
        };
        _this.handleClick = function () {
            var popoverContext = _this.props.popoverContext;
            if (!popoverContext.isDisabled) {
                popoverContext.toggle(!popoverContext.isOpen);
            }
        };
        _this.handleMouseEnter = function () {
            var popoverContext = _this.props.popoverContext;
            if (!popoverContext.isDisabled) {
                popoverContext.setShouldPreload(true);
                if (popoverContext.openOnHover) {
                    popoverContext.handleOpenOnHover();
                }
            }
        };
        _this.handleMouseLeave = function () {
            var popoverContext = _this.props.popoverContext;
            if (!popoverContext.isDisabled) {
                popoverContext.setShouldPreload(false);
            }
            // Make sure to close the popover on mouseLeave regardless
            // of whether it is disabled, otherwise it will stay open
            // indefinitely if it disables while we are hovered over it.
            if (popoverContext.openOnHover) {
                popoverContext.handleCloseOnHover();
            }
        };
        return _this;
    }
    PopoverTarget.prototype.componentDidMount = function () {
        this.props.popoverContext.setTargetBoundingClientRectGetter(this.getPositioningTargetBoundingBox);
    };
    PopoverTarget.prototype.render = function () {
        var _a = this.props, allowCustomOnClick = _a.allowCustomOnClick, children = _a.children, className = _a.className;
        var popoverTargetClassName = classnames_1.default(className, 'cu-popover-target', 'cu-d-inline-block');
        return (React.createElement("div", { className: popoverTargetClassName, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, ref: this.targetElementRef }, React.isValidElement(children) && !allowCustomOnClick
            ? React.cloneElement(children, {
                onClick: this.handleClick,
            })
            : children));
    };
    return PopoverTarget;
}(React.Component));
exports.default = PopoverContext_1.withPopoverContext(PopoverTarget);


/***/ }),

/***/ "./src/react/components/progress-bar/ProgressBar.tsx":
/*!***********************************************************!*\
  !*** ./src/react/components/progress-bar/ProgressBar.tsx ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var trackable_component_1 = __webpack_require__(/*! ../../../common/trackable-component */ "./src/common/trackable-component.ts");
var getBarWidth = function (value) {
    return Math.min(Math.max(0, Math.floor(100 * value)), 100);
};
var ProgressBar = /** @class */ (function (_super) {
    __extends(ProgressBar, _super);
    function ProgressBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            // Typescript doesn't recognize default props, so we have to tell
            // it that we know the value is a number
            currentBarWidth: getBarWidth(_this.props.value),
        };
        return _this;
    }
    /*
     * We store an internal state to stop movement in determinate progress bars while they are disabled.
     * Value is arbitrary when a bar is indeterminate so we do not take that into account while calculating width.
    */
    ProgressBar.getDerivedStateFromProps = function (props) {
        if (!props.isDisabled && props.value !== undefined) {
            return {
                currentBarWidth: getBarWidth(props.value),
            };
        }
        else {
            return null;
        }
    };
    ProgressBar.prototype.render = function () {
        var progressClasses = classnames_1.default(this.props.className, 'cu-progress');
        var progressBarClasses = classnames_1.default({
            'cu-disabled': this.props.isDisabled,
            'cu-progress-bar': !this.props.isIndeterminate,
            'cu-progress-bar-indeterminate': this.props.isIndeterminate,
        });
        return (React.createElement("div", __assign({ className: progressClasses }, trackable_component_1.optionallyAssignTrackingId(this.props.trackingId)),
            React.createElement("span", { "aria-valuemax": 100, "aria-valuemin": 0, "aria-valuenow": this.state.currentBarWidth, className: progressBarClasses, style: { width: this.state.currentBarWidth + "%" } })));
    };
    return ProgressBar;
}(React.Component));
exports.default = ProgressBar;


/***/ }),

/***/ "./src/react/components/radio-button-group/RadioButtonGroup.tsx":
/*!**********************************************************************!*\
  !*** ./src/react/components/radio-button-group/RadioButtonGroup.tsx ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
var RadioButtonGroupContext_1 = __webpack_require__(/*! ../../components/radio-button-group/RadioButtonGroupContext */ "./src/react/components/radio-button-group/RadioButtonGroupContext.tsx");
var RadioButtonGroup = /** @class */ (function (_super) {
    __extends(RadioButtonGroup, _super);
    function RadioButtonGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            groupValue: _this.props.value,
            handleGroupValueChange: _this.props.handleChange,
            isGroupDisabled: _this.props.isDisabled,
        };
        return _this;
    }
    // Only allow certain prop updates to propogate to the context consumers
    RadioButtonGroup.getDerivedStateFromProps = function (props, state) {
        if (props.isDisabled !== state.isGroupDisabled) {
            return { isGroupDisabled: props.isDisabled };
        }
        else if (props.value !== state.groupValue) {
            return { groupValue: props.value };
        }
        else {
            return null;
        }
    };
    RadioButtonGroup.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        return (React.createElement("div", { className: className + " cu-radio-button-group cu-d-inline-flex" },
            React.createElement(RadioButtonGroupContext_1.RadioButtonGroupContext.Provider, { value: this.state }, children)));
    };
    RadioButtonGroup.defaultProps = {
        className: '',
        isDisabled: false,
    };
    return RadioButtonGroup;
}(React.Component));
exports.RadioButtonGroup = RadioButtonGroup;
exports.default = RadioButtonGroup;


/***/ }),

/***/ "./src/react/components/radio-button-group/RadioButtonGroupContext.tsx":
/*!*****************************************************************************!*\
  !*** ./src/react/components/radio-button-group/RadioButtonGroupContext.tsx ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
exports.RadioButtonGroupContext = React.createContext({
    groupValue: undefined,
    handleGroupValueChange: function () { return undefined; },
    isGroupDisabled: false,
});
function withRadioButtonGroupContext(WrappedComponent) {
    var component = function (props) {
        return (
        // `{...props as P}` below is a slightly improper cast.
        // See ongoing TS issues with React HoCs: https://github.com/Microsoft/TypeScript/issues/28938
        React.createElement(exports.RadioButtonGroupContext.Consumer, null, function (context) { return React.createElement(WrappedComponent, __assign({}, props, { groupContext: context })); }));
    };
    component.displayName = WrappedComponent.displayName || WrappedComponent.name;
    return component;
}
exports.withRadioButtonGroupContext = withRadioButtonGroupContext;


/***/ }),

/***/ "./src/react/components/radio-button-group/RadioButtonOption.tsx":
/*!***********************************************************************!*\
  !*** ./src/react/components/radio-button-group/RadioButtonOption.tsx ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Button_1 = __importDefault(__webpack_require__(/*! ../../components/button/Button */ "./src/react/components/button/Button.tsx"));
var RadioButtonGroupContext_1 = __webpack_require__(/*! ../../components/radio-button-group/RadioButtonGroupContext */ "./src/react/components/radio-button-group/RadioButtonGroupContext.tsx");
var RadioButtonOption = /** @class */ (function (_super) {
    __extends(RadioButtonOption, _super);
    function RadioButtonOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChangeInner = function () {
            _this.props.groupContext.handleGroupValueChange(_this.props.value);
        };
        return _this;
    }
    RadioButtonOption.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, groupContext = _a.groupContext, isDisabled = _a.isDisabled, value = _a.value;
        var isSelected = value === groupContext.groupValue;
        var classNames = classnames_1.default('cu-radio-button-option', (isDisabled || groupContext.isGroupDisabled) && 'cu-disabled', isSelected && 'cu-selected');
        var buttonClassnames = classnames_1.default(className, 'cu-button-default', 'cu-radio-button-option', isSelected && 'cu-selected');
        return (React.createElement("div", { className: classNames },
            React.createElement(Button_1.default, { className: buttonClassnames, isDisabled: isDisabled || groupContext.isGroupDisabled, onClick: this.handleChangeInner }, children)));
    };
    RadioButtonOption.defaultProps = {
        className: '',
        isDisabled: false,
    };
    return RadioButtonOption;
}(React.Component));
exports.default = RadioButtonGroupContext_1.withRadioButtonGroupContext(RadioButtonOption);


/***/ }),

/***/ "./src/react/components/radio-group/RadioGroup.tsx":
/*!*********************************************************!*\
  !*** ./src/react/components/radio-group/RadioGroup.tsx ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
var RadioGroupContext_1 = __webpack_require__(/*! ../../components/radio-group/RadioGroupContext */ "./src/react/components/radio-group/RadioGroupContext.tsx");
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            groupValue: _this.props.value,
            handleGroupValueChange: _this.props.handleChange,
            isGroupDisabled: _this.props.isDisabled,
        };
        return _this;
    }
    // Only allow certain prop updates to propogate to the context consumers
    RadioGroup.getDerivedStateFromProps = function (props, state) {
        if (props.isDisabled !== state.isGroupDisabled) {
            return { isGroupDisabled: props.isDisabled };
        }
        else if (props.value !== state.groupValue) {
            return { groupValue: props.value };
        }
        else {
            return null;
        }
    };
    RadioGroup.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        return (React.createElement("div", { className: className + " cu-radio-group" },
            React.createElement(RadioGroupContext_1.RadioGroupContext.Provider, { value: this.state }, children)));
    };
    RadioGroup.defaultProps = {
        className: '',
        isDisabled: false,
    };
    return RadioGroup;
}(React.Component));
exports.RadioGroup = RadioGroup;
exports.default = RadioGroup;


/***/ }),

/***/ "./src/react/components/radio-group/RadioGroupContext.tsx":
/*!****************************************************************!*\
  !*** ./src/react/components/radio-group/RadioGroupContext.tsx ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
exports.RadioGroupContext = React.createContext({
    groupValue: undefined,
    handleGroupValueChange: function () { return undefined; },
    isGroupDisabled: false,
});
function withRadioGroupContext(WrappedComponent) {
    var component = function (props) {
        return (
        // `{...props as P}` below is a slightly improper cast.
        // See ongoing TS issues with React HoCs: https://github.com/Microsoft/TypeScript/issues/28938
        React.createElement(exports.RadioGroupContext.Consumer, null, function (context) { return React.createElement(WrappedComponent, __assign({}, props, { groupContext: context })); }));
    };
    component.displayName = WrappedComponent.displayName || WrappedComponent.name;
    return component;
}
exports.withRadioGroupContext = withRadioGroupContext;


/***/ }),

/***/ "./src/react/components/radio-group/RadioOption.tsx":
/*!**********************************************************!*\
  !*** ./src/react/components/radio-group/RadioOption.tsx ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Button_1 = __importDefault(__webpack_require__(/*! ../../components/button/Button */ "./src/react/components/button/Button.tsx"));
var RadioGroupContext_1 = __webpack_require__(/*! ../../components/radio-group/RadioGroupContext */ "./src/react/components/radio-group/RadioGroupContext.tsx");
var RadioOption = /** @class */ (function (_super) {
    __extends(RadioOption, _super);
    function RadioOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChangeInner = function () {
            _this.props.groupContext.handleGroupValueChange(_this.props.value);
        };
        return _this;
    }
    RadioOption.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, groupContext = _a.groupContext, isDisabled = _a.isDisabled, value = _a.value, trackingId = _a.trackingId;
        var isSelected = value === groupContext.groupValue;
        var classnames = classnames_1.default(className, 'cu-button-invisible', 'cu-radio-option', isSelected && 'cu-selected');
        return (React.createElement(Button_1.default, { className: classnames, isDisabled: isDisabled || groupContext.isGroupDisabled, onClick: this.handleChangeInner, trackingId: trackingId },
            React.createElement("div", { className: 'cu-radio-outer-circle' }, isSelected &&
                React.createElement("div", { className: 'cu-radio-inner-circle' })),
            React.createElement("div", { className: 'cu-radio-label cu-text-body' }, children)));
    };
    RadioOption.defaultProps = {
        className: '',
        isDisabled: false,
    };
    return RadioOption;
}(React.Component));
exports.default = RadioGroupContext_1.withRadioGroupContext(RadioOption);


/***/ }),

/***/ "./src/react/components/search-bar/SearchBar.tsx":
/*!*******************************************************!*\
  !*** ./src/react/components/search-bar/SearchBar.tsx ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Button_1 = __importDefault(__webpack_require__(/*! @react/components/button/Button */ "./src/react/components/button/Button.tsx"));
var Icon_1 = __importDefault(__webpack_require__(/*! @react/components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var SearchBar = /** @class */ (function (_super) {
    __extends(SearchBar, _super);
    function SearchBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchBar.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, handleClear = _a.handleClear, showClearButton = _a.showClearButton;
        var searchBarClasses = classnames_1.default(className, 'cu-search-bar', {
            'cu-search-bar-with-clear-button': showClearButton,
        });
        return (React.createElement("div", { className: searchBarClasses },
            React.createElement(Icon_1.default, { name: 'search', className: 'cu-search-bar-search-icon' }),
            children,
            showClearButton &&
                React.createElement(Button_1.default, { className: 'cu-button-invisible cu-search-bar-close-button', onClick: handleClear },
                    React.createElement(Icon_1.default, { name: 'close' }))));
    };
    SearchBar.defaultProps = {
        className: '',
        handleClear: function () { return undefined; },
        showClearButton: false,
    };
    return SearchBar;
}(React.Component));
exports.SearchBar = SearchBar;
exports.default = SearchBar;


/***/ }),

/***/ "./src/react/components/select/Select.tsx":
/*!************************************************!*\
  !*** ./src/react/components/select/Select.tsx ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Button_1 = __importDefault(__webpack_require__(/*! @react/components/button/Button */ "./src/react/components/button/Button.tsx"));
var Icon_1 = __importDefault(__webpack_require__(/*! @react/components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var Popover_1 = __importDefault(__webpack_require__(/*! @react/components/popover/Popover */ "./src/react/components/popover/Popover.tsx"));
var PopoverContent_1 = __importDefault(__webpack_require__(/*! @react/components/popover/PopoverContent */ "./src/react/components/popover/PopoverContent.tsx"));
var PopoverTarget_1 = __importDefault(__webpack_require__(/*! @react/components/popover/PopoverTarget */ "./src/react/components/popover/PopoverTarget.tsx"));
var agnostic_list_manager_1 = __webpack_require__(/*! ../../../common/agnostic-list-manager */ "./src/common/agnostic-list-manager.ts");
var trackable_component_1 = __webpack_require__(/*! ../../../common/trackable-component */ "./src/common/trackable-component.ts");
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectWrapperRef = React.createRef();
        _this.state = {
            isOpen: false,
        };
        _this.handleSelect = function (value) {
            _this.props.handleChange(value);
            _this.setPopoverIsOpen(false);
        };
        _this.handleOutsideClick = function (event) {
            var isTargetContained = _this.selectWrapperRef.current &&
                _this.selectWrapperRef.current.contains(event.target);
            if (!isTargetContained) {
                _this.setPopoverIsOpen(false);
            }
        };
        _this.setPopoverIsOpen = function (isOpen) {
            _this.setState({ isOpen: isOpen });
        };
        _this.setupListManager = function () {
            var listManager = new agnostic_list_manager_1.AgnosticListManager();
            listManager.setItems(__spreadArrays(_this.props.items));
            _this.setState({ listManager: listManager });
        };
        _this.renderChildren = function () {
            var _a = _this.props, children = _a.children, value = _a.value;
            var listManager = _this.state.listManager;
            return React.Children.map(children, function (child) {
                var childValue = child.props.value;
                if (listManager && !listManager.itemsByValue[childValue]) {
                    throw new Error("cuReactSelect: cuSelectItem with value \"" + value + "\" is not recognized by cuSelect");
                }
                var isSelected = childValue === value;
                return React.cloneElement(child, {
                    handleSelect: _this.handleSelect,
                    isSelected: isSelected,
                });
            });
        };
        return _this;
    }
    Select.prototype.componentDidMount = function () {
        var _a = this.props, handleChange = _a.handleChange, items = _a.items, unselectedLabel = _a.unselectedLabel, value = _a.value;
        if (items.length > 0) {
            // Only default to the first item if we aren't explicitly given
            // a value and we also are not given an unselected label
            if (!value && !unselectedLabel) {
                handleChange(items[0].value);
                this.setState({ selectedItem: items[0] });
            }
            else if (value) {
                var selectedItem = items.find(function (item) {
                    return item.value === value;
                });
                this.setState({ selectedItem: selectedItem });
            }
            this.setupListManager();
        }
        else {
            throw new Error('cuReactSelect: no items list provided to parent select');
        }
        document.addEventListener('mousedown', this.handleOutsideClick);
    };
    Select.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, items = _a.items, value = _a.value;
        if (prevProps.value !== value) {
            if (items.length > 0) {
                var selectedItem = items.find(function (item) {
                    return item.value === value;
                });
                this.setState({ selectedItem: selectedItem });
            }
        }
    };
    Select.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleOutsideClick);
    };
    Select.prototype.render = function () {
        var _a = this.props, className = _a.className, isDisabled = _a.isDisabled, unselectedLabel = _a.unselectedLabel, trackingId = _a.trackingId;
        var _b = this.state, isOpen = _b.isOpen, selectedItem = _b.selectedItem;
        var selectClasses = classnames_1.default(className, 'cu-d-inline-block');
        var labelClass = classnames_1.default('cu-text-truncate', !!selectedItem && 'cu-text-ui-copy');
        return (React.createElement("div", __assign({ className: selectClasses, ref: this.selectWrapperRef }, trackable_component_1.optionallyAssignTrackingId(trackingId)),
            React.createElement(Popover_1.default, { isDisabled: isDisabled, isOpen: isOpen, toggle: this.setPopoverIsOpen },
                React.createElement(PopoverTarget_1.default, { className: className },
                    React.createElement(Button_1.default, { isDisabled: isDisabled, className: 'cu-w-100 cu-button-default' },
                        React.createElement("div", { className: 'cu-d-flex cu-justify-content-between cu-flex-1' },
                            React.createElement("span", { className: labelClass }, selectedItem ? selectedItem.label : unselectedLabel),
                            React.createElement(Icon_1.default, { name: 'chevron-down', className: 'cu-ml-2' })))),
                React.createElement(PopoverContent_1.default, null,
                    React.createElement("div", { className: 'cu-p-2' }, this.renderChildren())))));
    };
    Select.defaultProps = {
        className: '',
        isDisabled: false,
        items: [],
        unselectedLabel: '',
        value: '',
    };
    return Select;
}(React.Component));
exports.Select = Select;
exports.default = Select;


/***/ }),

/***/ "./src/react/components/select/SelectItem.tsx":
/*!****************************************************!*\
  !*** ./src/react/components/select/SelectItem.tsx ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Button_1 = __importDefault(__webpack_require__(/*! @react/components/button/Button */ "./src/react/components/button/Button.tsx"));
var Icon_1 = __importDefault(__webpack_require__(/*! @react/components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var SelectItem = /** @class */ (function (_super) {
    __extends(SelectItem, _super);
    function SelectItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelect = function () {
            var _a = _this.props, handleSelect = _a.handleSelect, value = _a.value;
            if (handleSelect) {
                handleSelect(value);
            }
        };
        return _this;
    }
    SelectItem.prototype.render = function () {
        var _a = this.props, className = _a.className, isDisabled = _a.isDisabled, isSelected = _a.isSelected, label = _a.label, trackingId = _a.trackingId;
        var selectItemClasses = classnames_1.default(className, 'cu-button-invisible', 'cu-list-item', 'cu-w-100');
        return (React.createElement(Button_1.default, { className: selectItemClasses, isDisabled: isDisabled, onClick: this.onSelect, trackingId: trackingId },
            label,
            " ",
            isSelected && React.createElement(Icon_1.default, { name: 'checkmark', className: 'cu-ml-2 cu-color-success' })));
    };
    SelectItem.defaultProps = {
        className: '',
        isDisabled: false,
        isSelected: false,
    };
    return SelectItem;
}(React.Component));
exports.SelectItem = SelectItem;
exports.default = SelectItem;


/***/ }),

/***/ "./src/react/components/slider/Slider.tsx":
/*!************************************************!*\
  !*** ./src/react/components/slider/Slider.tsx ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
//
// Copyright (c) 2019 by Curalate, Inc.
//
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
function clamp(num, min, max) {
    return Math.min(max, Math.max(min, num));
}
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            bounds: undefined,
        };
        _this.removeListeners = function () {
            document.removeEventListener('mouseup', _this.removeListeners);
            document.removeEventListener('mousemove', _this.onMousemove);
        };
        _this.onMousedown = function (event) {
            // We need to get the bounding rect here in order to determine where on the slider the users mouse is.
            // We get this on every mouse down in order to deal with resizing.
            _this.setState({ bounds: event.currentTarget.getBoundingClientRect() });
            document.addEventListener('mouseup', _this.removeListeners);
            document.addEventListener('mousemove', _this.onMousemove);
            _this.moveHandleFromEventPageX(event.pageX);
        };
        _this.onMousemove = function (event) {
            _this.moveHandleFromEventPageX(event.pageX);
        };
        return _this;
    }
    Slider.prototype.componentWillUnmount = function () {
        this.removeListeners();
    };
    Slider.prototype.getMin = function () {
        return this.props.min !== undefined ? this.props.min : 0;
    };
    Slider.prototype.getMax = function () {
        return this.props.max !== undefined ? this.props.max : 1;
    };
    Slider.prototype.isCloserToLowerValue = function (newValue) {
        var _a = this.props, lowerValue = _a.lowerValue, value = _a.value;
        var roundedValue = this.roundValueToStep(newValue) || 0;
        var distanceFromLowerValue = Math.abs((lowerValue || 0) - roundedValue);
        var distanceFromUpperValue = Math.abs(value - roundedValue);
        return distanceFromLowerValue < distanceFromUpperValue;
    };
    Slider.prototype.handleChange = function (value) {
        if (!this.props.isDisabled) {
            var roundedVal = this.roundValueToStep(value);
            if (!this.showLowerHandle()) {
                this.props.onValueChange(roundedVal);
            }
            else if (this.isCloserToLowerValue(value) && this.props.onLowerValueChange !== undefined) {
                this.props.onLowerValueChange(roundedVal);
            }
            else {
                this.props.onValueChange(roundedVal);
            }
        }
    };
    Slider.prototype.implicitLowerValue = function () {
        return this.props.lowerValue !== undefined ? this.props.lowerValue : this.getMin();
    };
    Slider.prototype.showLowerHandle = function () {
        var lowerValue = this.props.lowerValue;
        return lowerValue !== undefined && lowerValue >= this.getMin();
    };
    /*
    Round the value to the nearest step.
  
    ex. min: 0, max: 50, step: 10
    [0         10 *      20        30        40        50]
                  ^
         click at 12 rounds to 10
  
    ex. min: 5, max: 50, step: 10
    [5         15        25        35        45  * ]
                                                 ^
                                        click at 49 rounds to 50
     */
    Slider.prototype.roundValueToStep = function (value) {
        var max = this.getMax();
        var min = this.getMin();
        var range = max - min;
        var step = (this.props.step || (range / 100));
        var numSteps = Math.floor(range / step);
        var lastStep = min + (numSteps * step);
        var valueFromMin = value - min;
        var quotient = Math.floor(valueFromMin / step);
        var remainder = valueFromMin % step;
        // If the value is closer to the max than the
        // last step, go to max instead of closest step
        var snapToMaxPoint = (max + lastStep) / 2;
        if (value >= snapToMaxPoint) {
            return max;
        }
        var numStepsFromMin = quotient + Math.round(remainder / step);
        var valueAdjustedToStep = min + (numStepsFromMin * step);
        return clamp(valueAdjustedToStep, min, max);
    };
    Slider.prototype.getHandlePositions = function () {
        var value = this.props.value;
        var max = this.getMax();
        var min = this.getMin();
        var range = max - min;
        var implicitLowerValue = this.implicitLowerValue();
        var valueFromMin = value - min;
        var valuesDiff = Math.abs(value - implicitLowerValue);
        var lowerValueFromMin = implicitLowerValue - min;
        return {
            handlePosition: clamp((valueFromMin / range) * 100, 0, 100) + "%",
            lowerHandlePosition: clamp((lowerValueFromMin / range) * 100, 0, 100) + "%",
            middleWidth: clamp((valuesDiff / range) * 100, 0, 100) + "%",
        };
    };
    Slider.prototype.moveHandleFromEventPageX = function (eventPageX) {
        var bounds = this.state.bounds;
        if (bounds) {
            var max = this.getMax();
            var min = this.getMin();
            var range = max - min;
            var safeEventPageX = clamp(eventPageX, bounds.left, bounds.right);
            var eventPageXInPercent = (safeEventPageX - bounds.left) / bounds.width;
            this.handleChange((range * eventPageXInPercent) + min);
        }
    };
    Slider.prototype.render = function () {
        var _this = this;
        var _a = this.props, isDisabled = _a.isDisabled, minLabel = _a.minLabel, maxLabel = _a.maxLabel, style = _a.style;
        var max = this.getMax();
        var min = this.getMin();
        var positions = this.getHandlePositions();
        var className = classnames_1.default(this.props.className, {
            'cu-disabled': isDisabled,
            'cu-slider-container': true,
        });
        return (React.createElement("div", { className: className, style: style },
            minLabel ?
                React.createElement("span", { className: 'cu-slider-label cu-slider-min-label', onClick: function () { return _this.handleChange(min); } }, minLabel)
                : undefined,
            React.createElement("span", { className: 'cu-slider-body', tabIndex: -1, onMouseDown: this.onMousedown },
                React.createElement("div", { className: 'cu-slider-bar-container' },
                    React.createElement("div", { className: 'cu-slider-bar', style: { left: positions.lowerHandlePosition, width: positions.middleWidth } })),
                React.createElement("div", { className: 'cu-slider-track' },
                    this.showLowerHandle() ?
                        React.createElement("div", { className: 'cu-slider-handle', style: { left: positions.lowerHandlePosition } })
                        : undefined,
                    React.createElement("div", { className: 'cu-slider-handle', style: { left: positions.handlePosition } }))),
            maxLabel ?
                React.createElement("span", { className: 'cu-slider-label cu-slider-max-label', onClick: function () { return _this.handleChange(max); } }, maxLabel)
                : undefined));
    };
    return Slider;
}(React.Component));
exports.Slider = Slider;
exports.default = Slider;


/***/ }),

/***/ "./src/react/components/spinner/Spinner.tsx":
/*!**************************************************!*\
  !*** ./src/react/components/spinner/Spinner.tsx ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Icon_1 = __importDefault(__webpack_require__(/*! ../../components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var Spinner = function (props) {
    var className = classnames_1.default(props.className, {
        'cu-spinner': true,
    });
    return (React.createElement(Icon_1.default, { name: 'spinner', className: className }));
};
exports.default = Spinner;


/***/ }),

/***/ "./src/react/components/stat-bubble/StatBubble.tsx":
/*!*********************************************************!*\
  !*** ./src/react/components/stat-bubble/StatBubble.tsx ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
var trackable_component_1 = __webpack_require__(/*! ../../../common/trackable-component */ "./src/common/trackable-component.ts");
var Icon_1 = __importDefault(__webpack_require__(/*! ../../components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var Tooltip_1 = __importDefault(__webpack_require__(/*! ../../components/tooltip/Tooltip */ "./src/react/components/tooltip/Tooltip.tsx"));
var TooltipContent_1 = __importDefault(__webpack_require__(/*! ../../components/tooltip/TooltipContent */ "./src/react/components/tooltip/TooltipContent.tsx"));
var TooltipTarget_1 = __importDefault(__webpack_require__(/*! ../../components/tooltip/TooltipTarget */ "./src/react/components/tooltip/TooltipTarget.tsx"));
var StatBubble = function (_a) {
    var className = _a.className, statLabel = _a.statLabel, statTitle = _a.statTitle, tooltip = _a.tooltip, trackingId = _a.trackingId, value = _a.value;
    return (React.createElement("div", __assign({ className: className + " cu-stat-bubble" }, trackable_component_1.optionallyAssignTrackingId(trackingId)),
        React.createElement("div", { className: 'cu-stat-bubble-content-container' },
            tooltip &&
                React.createElement("div", { className: 'cu-stat-bubble-tooltip-container' },
                    React.createElement(Tooltip_1.default, null,
                        React.createElement(TooltipTarget_1.default, null,
                            React.createElement(Icon_1.default, { name: 'help-sm' })),
                        React.createElement(TooltipContent_1.default, null,
                            React.createElement("div", { className: 'cu-stat-bubble-tooltip-content' }, tooltip)))),
            React.createElement("div", { className: 'cu-stat-bubble-content' },
                React.createElement("div", { className: 'cu-stat-bubble-value', title: value }, value),
                statTitle &&
                    React.createElement("div", { className: 'cu-stat-bubble-title' }, statTitle),
                statLabel &&
                    React.createElement("div", { className: 'cu-stat-bubble-label' }, statLabel)))));
};
StatBubble.defaultProps = {
    className: '',
    statLabel: '',
    statTitle: '',
    tooltip: '',
};
exports.default = StatBubble;


/***/ }),

/***/ "./src/react/components/table-pagination-controls/TablePaginationControls.tsx":
/*!************************************************************************************!*\
  !*** ./src/react/components/table-pagination-controls/TablePaginationControls.tsx ***!
  \************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
var PaginationControls_1 = __importDefault(__webpack_require__(/*! ../../components/pagination-controls/PaginationControls */ "./src/react/components/pagination-controls/PaginationControls.tsx"));
var Select_1 = __importDefault(__webpack_require__(/*! ../../components/select/Select */ "./src/react/components/select/Select.tsx"));
var SelectItem_1 = __importDefault(__webpack_require__(/*! ../../components/select/SelectItem */ "./src/react/components/select/SelectItem.tsx"));
var TablePaginationControls = /** @class */ (function (_super) {
    __extends(TablePaginationControls, _super);
    function TablePaginationControls(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            itemsPerPageSelectOptions: [],
            numPages: 0,
        };
        _this.handleCurrentPageChange = function (page) {
            var _a = _this.props, handlePageChange = _a.handlePageChange, itemsPerPage = _a.itemsPerPage, numItems = _a.numItems;
            var itemsPerPageSelectOptions = _this.state.itemsPerPageSelectOptions;
            _this.setState({
                itemsPerPageSelectOptions: itemsPerPageSelectOptions,
                numPages: Math.ceil(numItems / itemsPerPage),
            }, function () {
                handlePageChange(page, itemsPerPage);
            });
        };
        _this.handleItemsPerPageChange = function (newItemsPerPage) {
            var _a = _this.props, currentPage = _a.currentPage, handlePageChange = _a.handlePageChange, numItems = _a.numItems;
            var _b = _this.state, itemsPerPageSelectOptions = _b.itemsPerPageSelectOptions, numPages = _b.numPages;
            var newPage = Math.floor((currentPage / numPages) * Math.floor(numItems / newItemsPerPage));
            _this.setState({
                itemsPerPageSelectOptions: itemsPerPageSelectOptions,
                numPages: Math.ceil(numItems / newItemsPerPage),
            }, function () {
                handlePageChange(newPage, newItemsPerPage);
            });
        };
        _this.renderSelectItems = function () {
            var itemsPerPage = _this.props.itemsPerPage;
            var itemsPerPageSelectOptions = _this.state.itemsPerPageSelectOptions;
            return itemsPerPageSelectOptions.map(function (selectOption) {
                var isSelected = itemsPerPage === selectOption.value;
                return (React.createElement(SelectItem_1.default, { isSelected: isSelected, key: selectOption.value, label: selectOption.label, value: selectOption.value }));
            });
        };
        var _a = _this.props, itemsPerPage = _a.itemsPerPage, itemsPerPageOptions = _a.itemsPerPageOptions, numItems = _a.numItems;
        var itemsPerPageSelectOptions = itemsPerPageOptions.map(function (i) { return ({ value: i, label: "Show " + i + " Results" }); });
        _this.state = {
            itemsPerPageSelectOptions: itemsPerPageSelectOptions,
            numPages: Math.ceil(numItems / itemsPerPage),
        };
        return _this;
    }
    TablePaginationControls.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, currentPage = _a.currentPage, itemsPerPage = _a.itemsPerPage, numItems = _a.numItems;
        var _b = this.state, itemsPerPageSelectOptions = _b.itemsPerPageSelectOptions, numPages = _b.numPages;
        if (prevProps.currentPage !== currentPage ||
            prevProps.itemsPerPage !== itemsPerPage ||
            prevProps.numItems !== numItems ||
            prevState.numPages !== numPages) {
            this.setState({
                itemsPerPageSelectOptions: itemsPerPageSelectOptions,
                numPages: Math.ceil(numItems / itemsPerPage),
            });
        }
    };
    TablePaginationControls.prototype.render = function () {
        var _a = this.props, currentPage = _a.currentPage, isDisabled = _a.isDisabled, itemsPerPage = _a.itemsPerPage;
        var _b = this.state, itemsPerPageSelectOptions = _b.itemsPerPageSelectOptions, numPages = _b.numPages;
        return (React.createElement("div", { className: 'cu-d-flex cu-justify-content-between cu-w-100' },
            React.createElement(PaginationControls_1.default, { currentPage: currentPage, handlePageChange: this.handleCurrentPageChange, isDisabled: isDisabled, numPages: numPages }),
            React.createElement(Select_1.default, { handleChange: this.handleItemsPerPageChange, isDisabled: isDisabled, items: itemsPerPageSelectOptions, value: itemsPerPage }, this.renderSelectItems())));
    };
    TablePaginationControls.defaultProps = {
        isDisabled: false,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 25, 50, 100],
    };
    return TablePaginationControls;
}(React.Component));
exports.TablePaginationControls = TablePaginationControls;
exports.default = TablePaginationControls;


/***/ }),

/***/ "./src/react/components/toggle/Toggle.tsx":
/*!************************************************!*\
  !*** ./src/react/components/toggle/Toggle.tsx ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Button_1 = __importDefault(__webpack_require__(/*! ../../components/button/Button */ "./src/react/components/button/Button.tsx"));
var Toggle = function (props) {
    var className = props.className, handleChange = props.handleChange, isDisabled = props.isDisabled, value = props.value, trackingId = props.trackingId;
    var classNames = classnames_1.default(className, 'cu-toggle', 'cu-button-invisible', {
        'cu-disabled': isDisabled,
    });
    var containerClassNames = classnames_1.default('cu-toggle-container', {
        'cu-toggle-on': value,
    });
    return (React.createElement(Button_1.default, { className: classNames, onClick: function () { return handleChange(!value); }, isDisabled: isDisabled, trackingId: trackingId },
        React.createElement("div", { className: containerClassNames },
            React.createElement("div", { className: 'cu-toggle-tray' }),
            React.createElement("div", { className: 'cu-toggle-ball' }))));
};
exports.default = Toggle;


/***/ }),

/***/ "./src/react/components/tooltip/Tooltip.tsx":
/*!**************************************************!*\
  !*** ./src/react/components/tooltip/Tooltip.tsx ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Popover_1 = __importDefault(__webpack_require__(/*! ../popover/Popover */ "./src/react/components/popover/Popover.tsx"));
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        _this.setIsOpen = function (isOpen) {
            _this.setState({ isOpen: isOpen });
        };
        return _this;
    }
    Tooltip.prototype.render = function () {
        var _a = this.props, children = _a.children, isDisabled = _a.isDisabled, positioningStrategy = _a.positioningStrategy;
        // Default alignment is center for tooltips.
        positioningStrategy.align = positioningStrategy.align || 'center';
        return (React.createElement(Popover_1.default, { appendToBody: true, closeOnScroll: true, isDisabled: isDisabled, isOpen: this.state.isOpen, openOnHover: true, positioningStrategy: positioningStrategy, stealFocus: false, toggle: this.setIsOpen }, children));
    };
    Tooltip.defaultProps = {
        isDisabled: false,
        positioningStrategy: {},
    };
    return Tooltip;
}(React.Component));
exports.Tooltip = Tooltip;
exports.default = Tooltip;


/***/ }),

/***/ "./src/react/components/tooltip/TooltipContent.tsx":
/*!*********************************************************!*\
  !*** ./src/react/components/tooltip/TooltipContent.tsx ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
var PopoverContent_1 = __importDefault(__webpack_require__(/*! ../popover/PopoverContent */ "./src/react/components/popover/PopoverContent.tsx"));
var TooltipContent = function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement(PopoverContent_1.default, { className: className }, children);
};
exports.default = TooltipContent;


/***/ }),

/***/ "./src/react/components/tooltip/TooltipTarget.tsx":
/*!********************************************************!*\
  !*** ./src/react/components/tooltip/TooltipTarget.tsx ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
var PopoverTarget_1 = __importDefault(__webpack_require__(/*! ../popover/PopoverTarget */ "./src/react/components/popover/PopoverTarget.tsx"));
var TooltipTarget = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b;
    return React.createElement(PopoverTarget_1.default, { allowCustomOnClick: true, className: className }, children);
};
exports.default = TooltipTarget;


/***/ }),

/***/ "./src/react/components/with-unison/WithUnison.tsx":
/*!*********************************************************!*\
  !*** ./src/react/components/with-unison/WithUnison.tsx ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
exports.WithUnison = function (props) {
    return (React.createElement("div", { className: 'unison-component' }, props.children));
};
exports.default = exports.WithUnison;


/***/ }),

/***/ "./src/react/components/workflow-progress/WorkflowProgress.tsx":
/*!*********************************************************************!*\
  !*** ./src/react/components/workflow-progress/WorkflowProgress.tsx ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(/*! react */ "react"));
var WorkflowProgressStep_tsx_1 = __importDefault(__webpack_require__(/*! @react/components/workflow-progress/WorkflowProgressStep.tsx */ "./src/react/components/workflow-progress/WorkflowProgressStep.tsx"));
var WorkflowProgress = function (props) {
    var className = props.className, workflowProgressSteps = props.workflowProgressSteps, currentStep = props.currentStep;
    return (React.createElement("div", { className: "cu-workflow-progress " + className }, workflowProgressSteps.map(function (_a, index) {
        var stepLabel = _a.stepLabel, handleClick = _a.handleClick;
        var stepNumber = index + 1;
        var isLastStep = (stepNumber === workflowProgressSteps.length);
        var isDisabled = (stepNumber > currentStep);
        var isStepComplete = (stepNumber < currentStep);
        {
            return (React.createElement(WorkflowProgressStep_tsx_1.default, { handleClick: handleClick, stepLabel: stepLabel, stepNumber: stepNumber, isDisabled: isDisabled, isLastStep: isLastStep, isStepComplete: isStepComplete }));
        }
    })));
};
exports.default = WorkflowProgress;


/***/ }),

/***/ "./src/react/components/workflow-progress/WorkflowProgressStep.tsx":
/*!*************************************************************************!*\
  !*** ./src/react/components/workflow-progress/WorkflowProgressStep.tsx ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var Button_1 = __importDefault(__webpack_require__(/*! @react/components/button/Button */ "./src/react/components/button/Button.tsx"));
var Icon_1 = __importDefault(__webpack_require__(/*! @react/components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
var WorkflowProgressStep = function (props) {
    var stepClassNames = classnames_1.default(props.className, 'cu-text-table-header', 'cu-workflow-progress-step', props.isDisabled && 'cu-disabled');
    var arrowClassNames = classnames_1.default('cu-mx-4', 'cu-workflow-progress-step-arrow');
    var circleClassNames = classnames_1.default('cu-workflow-progress-step-circle', 'cu-button-flat');
    return (React.createElement("div", { className: stepClassNames },
        React.createElement(Button_1.default, { className: circleClassNames, isDisabled: props.isDisabled, onClick: props.handleClick }, props.isStepComplete ?
            React.createElement(Icon_1.default, { name: 'circle-checkmark', className: 'cu-workflow-progress-step-complete-icon' })
            : props.stepNumber),
        props.stepLabel,
        !props.isLastStep && React.createElement(Icon_1.default, { name: 'chevron-right', className: arrowClassNames })));
};
exports.default = WorkflowProgressStep;


/***/ }),

/***/ "./src/react/core/VerticalDivider.tsx":
/*!********************************************!*\
  !*** ./src/react/core/VerticalDivider.tsx ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(__webpack_require__(/*! classnames */ "./node_modules/classnames/index.js"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var VerticalDivider = function (_a) {
    var children = _a.children, className = _a.className;
    var classNames = classnames_1.default(className, 'cu-vertical-divider-wrapper');
    return (React.createElement("div", { className: classNames },
        React.createElement("div", { className: 'cu-vertical-divider' }),
        children &&
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'cu-vertical-divider-text' }, children),
                React.createElement("div", { className: 'cu-vertical-divider' }))));
};
exports.default = VerticalDivider;


/***/ }),

/***/ "./src/react/index.ts":
/*!****************************!*\
  !*** ./src/react/index.ts ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ActionButton_1 = __importDefault(__webpack_require__(/*! ./components/action-button/ActionButton */ "./src/react/components/action-button/ActionButton.tsx"));
exports.ActionButton = ActionButton_1.default;
var Alert_1 = __importDefault(__webpack_require__(/*! ./components/alert/Alert */ "./src/react/components/alert/Alert.tsx"));
exports.Alert = Alert_1.default;
var Anchor_1 = __importDefault(__webpack_require__(/*! ./components/anchor/Anchor */ "./src/react/components/anchor/Anchor.tsx"));
exports.Anchor = Anchor_1.default;
var Badge_1 = __importDefault(__webpack_require__(/*! ./components/badge/Badge */ "./src/react/components/badge/Badge.tsx"));
exports.Badge = Badge_1.default;
var Button_1 = __importDefault(__webpack_require__(/*! ./components/button/Button */ "./src/react/components/button/Button.tsx"));
exports.Button = Button_1.default;
var Checkbox_1 = __importDefault(__webpack_require__(/*! ./components/checkbox/Checkbox */ "./src/react/components/checkbox/Checkbox.tsx"));
exports.Checkbox = Checkbox_1.default;
var DragAndDrop_1 = __importDefault(__webpack_require__(/*! ./components/drag-and-drop/DragAndDrop */ "./src/react/components/drag-and-drop/DragAndDrop.tsx"));
exports.DragAndDrop = DragAndDrop_1.default;
var ExpandingDataTable_1 = __importDefault(__webpack_require__(/*! ./components/expanding-data-table/ExpandingDataTable */ "./src/react/components/expanding-data-table/ExpandingDataTable.tsx"));
exports.ExpandingDataTable = ExpandingDataTable_1.default;
var Icon_1 = __importDefault(__webpack_require__(/*! ./components/icon/Icon */ "./src/react/components/icon/Icon.tsx"));
exports.Icon = Icon_1.default;
var Modal_1 = __importDefault(__webpack_require__(/*! ./components/modal/Modal */ "./src/react/components/modal/Modal.tsx"));
exports.Modal = Modal_1.default;
var ModalBody_1 = __importDefault(__webpack_require__(/*! ./components/modal/ModalBody */ "./src/react/components/modal/ModalBody.tsx"));
exports.ModalBody = ModalBody_1.default;
var ModalFooter_1 = __importDefault(__webpack_require__(/*! ./components/modal/ModalFooter */ "./src/react/components/modal/ModalFooter.tsx"));
exports.ModalFooter = ModalFooter_1.default;
var ModalHeader_1 = __importDefault(__webpack_require__(/*! ./components/modal/ModalHeader */ "./src/react/components/modal/ModalHeader.tsx"));
exports.ModalHeader = ModalHeader_1.default;
var NavTab_1 = __importDefault(__webpack_require__(/*! ./components/nav-tabs/NavTab */ "./src/react/components/nav-tabs/NavTab.tsx"));
exports.NavTab = NavTab_1.default;
var NavTabs_1 = __importDefault(__webpack_require__(/*! ./components/nav-tabs/NavTabs */ "./src/react/components/nav-tabs/NavTabs.tsx"));
exports.NavTabs = NavTabs_1.default;
var PageFrame_1 = __importDefault(__webpack_require__(/*! ./components/page-frame/PageFrame */ "./src/react/components/page-frame/PageFrame.tsx"));
exports.PageFrame = PageFrame_1.default;
var PageFrameContent_1 = __importDefault(__webpack_require__(/*! ./components/page-frame/PageFrameContent */ "./src/react/components/page-frame/PageFrameContent.tsx"));
exports.PageFrameContent = PageFrameContent_1.default;
var PageFrameHeader_1 = __importDefault(__webpack_require__(/*! ./components/page-frame/PageFrameHeader */ "./src/react/components/page-frame/PageFrameHeader.tsx"));
exports.PageFrameHeader = PageFrameHeader_1.default;
var PageFrameMain_1 = __importDefault(__webpack_require__(/*! ./components/page-frame/PageFrameMain */ "./src/react/components/page-frame/PageFrameMain.tsx"));
exports.PageFrameMain = PageFrameMain_1.default;
var PageFrameScrollWrap_1 = __importDefault(__webpack_require__(/*! ./components/page-frame/PageFrameScrollWrap */ "./src/react/components/page-frame/PageFrameScrollWrap.tsx"));
exports.PageFrameScrollWrap = PageFrameScrollWrap_1.default;
var PageFrameSidebar_1 = __importDefault(__webpack_require__(/*! ./components/page-frame/PageFrameSidebar */ "./src/react/components/page-frame/PageFrameSidebar.tsx"));
exports.PageFrameSidebar = PageFrameSidebar_1.default;
var PaginationControls_1 = __importDefault(__webpack_require__(/*! ./components/pagination-controls/PaginationControls */ "./src/react/components/pagination-controls/PaginationControls.tsx"));
exports.PaginationControls = PaginationControls_1.default;
var Popover_1 = __importDefault(__webpack_require__(/*! ./components/popover/Popover */ "./src/react/components/popover/Popover.tsx"));
exports.Popover = Popover_1.default;
var PopoverContent_1 = __importDefault(__webpack_require__(/*! ./components/popover/PopoverContent */ "./src/react/components/popover/PopoverContent.tsx"));
exports.PopoverContent = PopoverContent_1.default;
var PopoverTarget_1 = __importDefault(__webpack_require__(/*! ./components/popover/PopoverTarget */ "./src/react/components/popover/PopoverTarget.tsx"));
exports.PopoverTarget = PopoverTarget_1.default;
var ProgressBar_1 = __importDefault(__webpack_require__(/*! ./components/progress-bar/ProgressBar */ "./src/react/components/progress-bar/ProgressBar.tsx"));
exports.ProgressBar = ProgressBar_1.default;
var RadioButtonGroup_1 = __importDefault(__webpack_require__(/*! ./components/radio-button-group/RadioButtonGroup */ "./src/react/components/radio-button-group/RadioButtonGroup.tsx"));
exports.RadioButtonGroup = RadioButtonGroup_1.default;
var RadioButtonOption_1 = __importDefault(__webpack_require__(/*! ./components/radio-button-group/RadioButtonOption */ "./src/react/components/radio-button-group/RadioButtonOption.tsx"));
exports.RadioButtonOption = RadioButtonOption_1.default;
var RadioGroup_1 = __importDefault(__webpack_require__(/*! ./components/radio-group/RadioGroup */ "./src/react/components/radio-group/RadioGroup.tsx"));
exports.RadioGroup = RadioGroup_1.default;
var RadioOption_1 = __importDefault(__webpack_require__(/*! ./components/radio-group/RadioOption */ "./src/react/components/radio-group/RadioOption.tsx"));
exports.RadioOption = RadioOption_1.default;
var SearchBar_1 = __importDefault(__webpack_require__(/*! ./components/search-bar/SearchBar */ "./src/react/components/search-bar/SearchBar.tsx"));
exports.SearchBar = SearchBar_1.default;
var Select_1 = __importDefault(__webpack_require__(/*! ./components/select/Select */ "./src/react/components/select/Select.tsx"));
exports.Select = Select_1.default;
var SelectItem_1 = __importDefault(__webpack_require__(/*! ./components/select/SelectItem */ "./src/react/components/select/SelectItem.tsx"));
exports.SelectItem = SelectItem_1.default;
var Slider_1 = __importDefault(__webpack_require__(/*! ./components/slider/Slider */ "./src/react/components/slider/Slider.tsx"));
exports.Slider = Slider_1.default;
var Spinner_1 = __importDefault(__webpack_require__(/*! ./components/spinner/Spinner */ "./src/react/components/spinner/Spinner.tsx"));
exports.Spinner = Spinner_1.default;
var StatBubble_1 = __importDefault(__webpack_require__(/*! ./components/stat-bubble/StatBubble */ "./src/react/components/stat-bubble/StatBubble.tsx"));
exports.StatBubble = StatBubble_1.default;
var TablePaginationControls_1 = __importDefault(__webpack_require__(/*! ./components/table-pagination-controls/TablePaginationControls */ "./src/react/components/table-pagination-controls/TablePaginationControls.tsx"));
exports.TablePaginationControls = TablePaginationControls_1.default;
var Toggle_1 = __importDefault(__webpack_require__(/*! ./components/toggle/Toggle */ "./src/react/components/toggle/Toggle.tsx"));
exports.Toggle = Toggle_1.default;
var Tooltip_1 = __importDefault(__webpack_require__(/*! ./components/tooltip/Tooltip */ "./src/react/components/tooltip/Tooltip.tsx"));
exports.Tooltip = Tooltip_1.default;
var TooltipContent_1 = __importDefault(__webpack_require__(/*! ./components/tooltip/TooltipContent */ "./src/react/components/tooltip/TooltipContent.tsx"));
exports.TooltipContent = TooltipContent_1.default;
var TooltipTarget_1 = __importDefault(__webpack_require__(/*! ./components/tooltip/TooltipTarget */ "./src/react/components/tooltip/TooltipTarget.tsx"));
exports.TooltipTarget = TooltipTarget_1.default;
var WithUnison_1 = __importDefault(__webpack_require__(/*! ./components/with-unison/WithUnison */ "./src/react/components/with-unison/WithUnison.tsx"));
exports.WithUnison = WithUnison_1.default;
var WorkflowProgress_1 = __importDefault(__webpack_require__(/*! ./components/workflow-progress/WorkflowProgress */ "./src/react/components/workflow-progress/WorkflowProgress.tsx"));
exports.WorkflowProgress = WorkflowProgress_1.default;
var VerticalDivider_1 = __importDefault(__webpack_require__(/*! ./core/VerticalDivider */ "./src/react/core/VerticalDivider.tsx"));
exports.VerticalDivider = VerticalDivider_1.default;
var DateUtils = __importStar(__webpack_require__(/*! ../common/date-utils/dateUtils */ "./src/common/date-utils/dateUtils.ts"));
exports.DateUtils = DateUtils;
var variables_1 = __importDefault(__webpack_require__(/*! ../common/variables */ "./src/common/variables.ts"));
exports.Constants = variables_1.default;
var CuMixins_1 = __importDefault(__webpack_require__(/*! ../theme/CuMixins */ "./src/theme/CuMixins.ts"));
exports.CuMixins = CuMixins_1.default;


/***/ }),

/***/ "./src/theme/CuMixins.ts":
/*!*******************************!*\
  !*** ./src/theme/CuMixins.ts ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CuMixinsBases_1 = __webpack_require__(/*! ./CuMixinsBases */ "./src/theme/CuMixinsBases.ts");
var theme_1 = __importDefault(__webpack_require__(/*! ./theme */ "./src/theme/theme.ts"));
/**
 * @deprecated Use the `Mixins` from the @theme/mixins.ts file in frontend instead.
 */
var CuMixins = {
    Text: {
        Display: "\n      font-size: " + theme_1.default.fontSizes[0] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.titleLeading + ";\n      color: " + theme_1.default.colors.aliases.bodyPrimary + ";\n    ",
        Title: "\n      font-size: " + theme_1.default.fontSizes[1] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.titleLeading + ";\n      color: " + theme_1.default.colors.aliases.bodyPrimary + ";\n    ",
        Subtitle: "\n      font-size: " + theme_1.default.fontSizes[2] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.titleLeading + ";\n      color: " + theme_1.default.colors.aliases.bodyPrimary + ";\n    ",
        Section: "\n      font-size: " + theme_1.default.fontSizes[3] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.titleLeading + ";\n      color: " + theme_1.default.colors.aliases.bodyPrimary + ";\n    ",
        Subsection: "\n      font-size: " + theme_1.default.fontSizes[4] + ";\n      font-weight: " + theme_1.default.fontWeights.semiBold + ";\n      line-height: " + theme_1.default.lineHeights.bodyLeading + ";\n      color: " + theme_1.default.colors.aliases.bodyPrimary + ";\n    ",
        Metatag: "\n      font-size: " + theme_1.default.fontSizes[6] + ";\n      font-weight: " + theme_1.default.fontWeights.bold + ";\n      line-height: " + theme_1.default.lineHeights.uiLeading + ";\n      color: " + theme_1.default.colors.aliases.bodySecondary + ";\n      text-transform: uppercase;\n      letter-spacing: .1em;\n    ",
        Body: "\n      font-size: " + theme_1.default.fontSizes[5] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.bodyLeading + ";\n      color: " + theme_1.default.colors.aliases.bodyPrimary + ";\n    ",
        BodyBold: "\n      font-size: " + theme_1.default.fontSizes[5] + ";\n      font-weight: " + theme_1.default.fontWeights.bold + ";\n      line-height: " + theme_1.default.lineHeights.bodyLeading + ";\n      color: " + theme_1.default.colors.aliases.bodyPrimary + ";\n    ",
        BodySecondary: "\n      font-size: " + theme_1.default.fontSizes[5] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.bodyLeading + ";\n      color: " + theme_1.default.colors.aliases.bodySecondary + ";\n    ",
        BodyDisabled: "\n      font-size: " + theme_1.default.fontSizes[5] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.bodyLeading + ";\n      color: " + theme_1.default.colors.aliases.disabled + ";\n    ",
        BodyError: "\n      font-size: " + theme_1.default.fontSizes[5] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.bodyLeading + ";\n      color: " + theme_1.default.colors.aliases.error + ";\n    ",
        UiCopy: "\n      font-size: " + theme_1.default.fontSizes[5] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.uiLeading + ";\n      color: " + theme_1.default.colors.aliases.bodyPrimary + ";\n    ",
        UiCopyBold: "\n      font-size: " + theme_1.default.fontSizes[5] + ";\n      font-weight: " + theme_1.default.fontWeights.bold + ";\n      line-height: " + theme_1.default.lineHeights.uiLeading + ";\n      color: " + theme_1.default.colors.aliases.bodyPrimary + ";\n    ",
        UiCopySecondary: "\n      font-size: " + theme_1.default.fontSizes[5] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.uiLeading + ";\n      color: " + theme_1.default.colors.aliases.bodySecondary + ";\n    ",
        UiCopyDisabled: "\n      font-size: " + theme_1.default.fontSizes[5] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.uiLeading + ";\n      color: " + theme_1.default.colors.aliases.disabled + ";\n    ",
        UiCopyError: "\n      font-size: " + theme_1.default.fontSizes[5] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.uiLeading + ";\n      color: " + theme_1.default.colors.aliases.error + ";\n    ",
        Caption: "\n      font-size: " + theme_1.default.fontSizes[6] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.bodyLeading + ";\n      color: " + theme_1.default.colors.aliases.bodyPrimary + ";\n    ",
        CaptionSecondary: "\n      font-size: " + theme_1.default.fontSizes[6] + ";\n      font-weight: " + theme_1.default.fontWeights.normal + ";\n      line-height: " + theme_1.default.lineHeights.bodyLeading + ";\n      color: " + theme_1.default.colors.aliases.bodySecondary + ";\n    ",
        LinkPrimary: "\n      &, &:hover {\n        font-size: " + theme_1.default.fontSizes[5] + ";\n        font-weight: " + theme_1.default.fontWeights.normal + ";\n        line-height: " + theme_1.default.lineHeights.bodyLeading + ";\n        color: " + theme_1.default.colors.aliases.primary + ";\n\n        &[disabled], &.cu-disabled {\n          color: " + theme_1.default.colors.aliases.disabled + ";\n          text-decoration: none;\n          cursor: not-allowed;\n        }\n      }\n    ",
        LinkCaptionPrimary: "\n      &, &:hover {\n        font-size: " + theme_1.default.fontSizes[6] + ";\n        font-weight: " + theme_1.default.fontWeights.normal + ";\n        line-height: " + theme_1.default.lineHeights.bodyLeading + ";\n        color: " + theme_1.default.colors.aliases.primary + ";\n\n        &[disabled], &.cu-disabled {\n          color: " + theme_1.default.colors.aliases.disabled + ";\n          text-decoration: none;\n          cursor: not-allowed;\n        }\n      }\n    ",
        LinkSecondary: "\n      &, &:hover {\n        font-size: " + theme_1.default.fontSizes[5] + ";\n        font-weight: " + theme_1.default.fontWeights.normal + ";\n        line-height: " + theme_1.default.lineHeights.bodyLeading + ";\n        color: " + theme_1.default.colors.aliases.bodySecondary + ";\n\n        &[disabled], &.cu-disabled {\n          color: " + theme_1.default.colors.aliases.disabled + ";\n          text-decoration: none;\n          cursor: not-allowed;\n        }\n      }\n    ",
    },
    Sheet: {
        Low: "\n      display: flex;\n      background-color: " + theme_1.default.colors.white + ";\n      box-shadow: " + theme_1.default.boxShadows[1] + ";\n    ",
        Medium: "\n      display: flex;\n      background-color: " + theme_1.default.colors.white + ";\n      box-shadow: " + theme_1.default.boxShadows[2] + ";\n    ",
        High: "\n      display: flex;\n      background-color: " + theme_1.default.colors.white + ";\n      box-shadow: " + theme_1.default.boxShadows[3] + ";\n    ",
    },
    FormControl: {
        Primary: CuMixinsBases_1.FormControlBase,
        Error: CuMixinsBases_1.FormControlBase + ("\n      border-color: " + theme_1.default.colors.aliases.error + ";\n      background-color: " + theme_1.default.colors.red0 + ";\n      outline: 0;\n    "),
    },
};
var wrapStyles = function (styles) { return "&, .unison-component & { " + styles + " }"; };
var processInlineComponentOverrides = function (mixins) {
    return Object.fromEntries(Object.entries(mixins).map(function (_a) {
        var key = _a[0], val = _a[1];
        if (typeof val === 'string') {
            return [key, wrapStyles(val)];
        }
        else {
            return [key, processInlineComponentOverrides(val)];
        }
    }));
};
exports.default = processInlineComponentOverrides(CuMixins);


/***/ }),

/***/ "./src/theme/CuMixinsBases.ts":
/*!************************************!*\
  !*** ./src/theme/CuMixinsBases.ts ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = __importDefault(__webpack_require__(/*! ./theme */ "./src/theme/theme.ts"));
/**
 * Separate declations of base styles so that they can be easily
 * extended in the primary mixins file.
 */
exports.FormControlBase = "\n  border-radius: " + theme_1.default.borderRadii[1] + ";\n  box-sizing: border-box;\n  height: " + theme_1.default.spacings[5] + ";\n  padding: " + theme_1.default.spacings[2] + ";\n  color: " + theme_1.default.colors.aliases.bodyPrimary + ";\n\n  &::placeholder {\n    color: " + theme_1.default.colors.gray4 + ";\n    opacity: 1;\n  }\n\n  &[disabled] {\n    color: " + theme_1.default.colors.gray4 + ";\n    background-color: " + theme_1.default.colors.gray0 + ";\n  }\n\n  &:not([disabled]) {\n    &:hover {\n      box-shadow: " + theme_1.default.boxShadows[1] + ";\n    }\n\n    &:focus,\n    &.cu-focus {\n      border-color: " + theme_1.default.colors.aliases.focus + ";\n      background-color: " + theme_1.default.colors.white + ";\n      outline: none;\n      box-shadow: inset 0 0 0 " + theme_1.default.borderWidths[1] + " " + theme_1.default.colors.aliases.focus + ",\n        inset 0 0 0 " + theme_1.default.borderWidths[2] + " " + theme_1.default.colors.cyan2 + ";\n    }\n  }\n";


/***/ }),

/***/ "./src/theme/theme.ts":
/*!****************************!*\
  !*** ./src/theme/theme.ts ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var variables_1 = __importDefault(__webpack_require__(/*! ../common/variables */ "./src/common/variables.ts"));
exports.default = variables_1.default;


/***/ }),

/***/ "./src/utils/buildOxfordList.ts":
/*!**************************************!*\
  !*** ./src/utils/buildOxfordList.ts ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
Object.defineProperty(exports, "__esModule", { value: true });
function buildOxfordList(list) {
    return "" + list.slice(0, -1).join(', ');
}
exports.default = buildOxfordList;


/***/ }),

/***/ "./src/utils/formatSizeUnits.ts":
/*!**************************************!*\
  !*** ./src/utils/formatSizeUnits.ts ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
Object.defineProperty(exports, "__esModule", { value: true });
function formatSizeUnits(bytes) {
    var bytesFormatted = '';
    if (bytes >= 1073741824) {
        bytesFormatted = (bytes / 1073741824).toFixed(2) + ' GB';
    }
    else if (bytes >= 1048576) {
        bytesFormatted = (bytes / 1048576).toFixed(2) + ' MB';
    }
    else if (bytes >= 1024) {
        bytesFormatted = (bytes / 1024).toFixed(2) + ' KB';
    }
    else if (bytes > 1) {
        bytesFormatted = bytes + ' bytes';
    }
    else if (bytes === 1) {
        bytesFormatted = bytes + ' byte';
    }
    else {
        bytesFormatted = '0 bytes';
    }
    return bytesFormatted;
}
exports.default = formatSizeUnits;


/***/ }),

/***/ "./src/utils/uuid.ts":
/*!***************************!*\
  !*** ./src/utils/uuid.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function rand4HexStr() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}
function default_1() {
    // Adapted from StackOverflow - Jon Surrell
    // http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    return rand4HexStr() + rand4HexStr() + "-" + rand4HexStr() + "-" + rand4HexStr() + "-" + rand4HexStr() + "-" + rand4HexStr() + rand4HexStr() + rand4HexStr();
}
exports.default = default_1;


/***/ }),

/***/ "./src/variables.ts":
/*!**************************!*\
  !*** ./src/variables.ts ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.variables = {
    'white': '#fff',
    'gray-00': '#fafbfb',
    'gray-0': '#f5f6f6',
    'gray-1': '#e9eaec',
    'gray-2': '#dbdee0',
    'gray-3': '#cdd1d4',
    'gray-4': '#bec3c7',
    'gray-5': '#adb3b8',
    'gray-6': '#9ba0a5',
    'gray-7': '#868b8f',
    'gray-8': '#67686B',
    'gray-9': '#4E495C',
    'orange-0': '#fff4ea',
    'orange-1': '#ffe5c8',
    'orange-2': '#ffd5a7',
    'orange-3': '#ffc483',
    'orange-4': '#ffaf5a',
    'orange-5': '#ff9623',
    'orange-6': '#f68000',
    'orange-7': '#d76e00',
    'orange-8': '#af5800',
    'orange-9': '#763800',
    'mint-0': '#ebf8f6',
    'mint-1': '#c9f3ed',
    'mint-2': '#a7ebe1',
    'mint-3': '#81e2d2',
    'mint-4': '#51d7c3',
    'mint-5': '#00c9b1',
    'mint-6': '#00b59e',
    'mint-7': '#009e89',
    'mint-8': '#00806f',
    'mint-9': '#005549',
    'cyan-0': '#eff7f9',
    'cyan-1': '#d2f0f6',
    'cyan-2': '#b6e6f1',
    'cyan-3': '#97dbe9',
    'cyan-4': '#75cfe1',
    'cyan-5': '#47c1d7',
    'cyan-6': '#00b0c8',
    'cyan-7': '#0099b0',
    'cyan-8': '#007c92',
    'cyan-9': '#005363',
    'red-0': '#fff3f1',
    'red-1': '#ffdfd8',
    'red-2': '#ffcbc1',
    'red-3': '#ffb8aa',
    'red-4': '#ffa18f',
    'red-5': '#ff8670',
    'red-6': '#ff6248',
    'red-7': '#f84f35',
    'red-8': '#cc3b26',
    'red-9': '#8d1f11',
    'yellow-0': '#fff6d4',
    'yellow-1': '#ffe991',
    'yellow-2': '#ffd641',
    'yellow-3': '#ffc300',
    'yellow-4': '#eeaf00',
    'yellow-5': '#da9900',
    'yellow-6': '#c48100',
    'yellow-7': '#aa6700',
    'yellow-8': '#8a4b00',
    'yellow-9': '#5b2b00',
    'green-0': '#ebf9f2',
    'green-1': '#caf4df',
    'green-2': '#a8edcb',
    'green-3': '#82e4b5',
    'green-4': '#54d99c',
    'green-5': '#00cc7d',
    'green-6': '#00b76f',
    'green-7': '#009f5f',
    'green-8': '#00814b',
    'green-9': '#00562f',
    'purple-1': '#684B77',
    'purple-2': '#886C93',
    'purple-3': '#C4A3DC',
    'teal-1': '#007c92',
    'teal-2': '#0099b0',
    'teal-3': '#005f70',
    'spacings': {
        0: '0',
        1: '4px',
        2: '8px',
        3: '16px',
        4: '24px',
        5: '32px',
        6: '48px',
        7: '64px',
    },
    'z-index': {
        'popover-backdrop': '990',
        'fixed': '1030',
        'sticky': '1030',
        'modal-backdrop': '1040',
        'modal': '1050',
        'popover': '1060',
        'tooltip': '1070',
        'navbar': '1080',
    },
    'grid-columns': '12',
    'container-max-widths': {
        sm: '540px',
        md: '720px',
        lg: '960px',
        xl: '1140px',
    },
    'grid-breakpoints': {
        xs: '0',
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
    },
    'ease-out-sine': 'cubic-bezier(.39, .575, .565, 1)',
    'ease-out-cubic': 'cubic-bezier(.215, .61, .355, 1)',
    'ease-out-quint': 'cubic-bezier(.23, 1, .32, 1)',
    'ease-out-circ': 'cubic-bezier(.075, .82, .165, 1)',
    'ease-out-quad': 'cubic-bezier(.25, .46, .45, .94)',
    'ease-out-quart': 'cubic-bezier(.165, .84, .44, 1)',
    'ease-out-expo': 'cubic-bezier(.19, 1, .22, 1)',
    'ease-out-back': 'cubic-bezier(.175, .885, .32, 1.275)',
    'ease-in-out-sine': 'cubic-bezier(.445, .05, .55, .95)',
    'ease-in-out-cubic': 'cubic-bezier(.645, .045, .355, 1)',
    'ease-in-out-quint': 'cubic-bezier(.86, 0, .07, 1)',
    'ease-in-out-circ': 'cubic-bezier(.785, .135, .15, .86)',
    'ease-in-out-quad': 'cubic-bezier(.455, .03, .515, .955)',
    'ease-in-out-quart': 'cubic-bezier(.77, 0, .175, 1)',
    'ease-in-out-expo': 'cubic-bezier(1, 0, 0, 1)',
    'ease-in-out-back': 'cubic-bezier(.68, -.55, .265, 1.55)',
    'font-weights': {
        'light': '300',
        'normal': '400',
        'semi-bold': '600',
        'bold': '700',
    },
    'title-leading': '1.25',
    'body-leading': '1.5',
    'ui-leading': '1',
    'wide-measure': '584px',
    'medium-measure': '440px',
    'small-measure': '232px',
    'font-sizes': {
        0: '48px',
        1: '32px',
        2: '24px',
        3: '20px',
        4: '16px',
        5: '14px',
        6: '12px',
        7: '10px',
    },
    'border-radii': {
        0: '0',
        1: '2px',
        2: '4px',
        3: '10px',
        4: '20px',
        pill: '500px',
    },
    'border-widths': {
        0: '0',
        1: '1px',
        1.5: '1.5px',
        2: '2px',
        3: '4px',
        4: '8px',
    },
    'box-shadows': {
        0: 'none',
        1: '0 1px 3px 0 rgba(0, 0, 0, 0.24)',
        2: '0 3px 6px 0 rgba(0, 0, 0, 0.24)',
        3: '0 6px 6px 0 rgba(0, 0, 0, 0.24)',
        4: '0 10px 10px 0 rgba(0, 0, 0, 0.24)',
    },
};


/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "react-dom":
/*!****************************!*\
  !*** external "react-dom" ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ "styled-components":
/*!************************************!*\
  !*** external "styled-components" ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ })));
//# sourceMappingURL=react.js.map